(() => {
  const PARAM = 'customily_ui';
  const SKIN_PARAM = 'customily_skin';
  const PREVIEW_MODE = 'progressive';
  const NATIVE_MODE = 'native';
  const DEFAULT_SKIN = 'clubhouse';
  const EXPECTED_TEMPLATE_SUFFIX = 'customily-products';
  const EXPECTED_RUNTIME_FINGERPRINT = 'gs-customily-guided-studio-v12-20260720';
  const CLUBHOUSE_SKIN_VALUES = new Set(['clubhouse', 'dark', 'dark-gold', 'gold']);
  const MODES = new Set([PREVIEW_MODE]);
  const STYLE_SELECTOR = 'input[type="radio"][name="properties[Choose Style]"]';
  const CUSTOMIZATION_METHOD_SELECTOR = 'input[type="radio"][name="properties[Choose Customization Type]"]';
  const IMAGE_METHOD_SELECTOR = 'input[type="radio"][name="properties[Images]"]';
  const TEXT_SELECTOR = 'textarea[name="properties[Add Text]"], input[name="properties[Add Text]"]';
  const MONOGRAM_SELECTOR = 'input[type="radio"][name="properties[Monogram]"]';
  const MONOGRAM_INITIAL_SELECTORS = {
    3: 'input[name="properties[3 Initials]"], textarea[name="properties[3 Initials]"]',
    2: 'input[name="properties[2 Initials ]"], textarea[name="properties[2 Initials ]"]',
    1: 'input[name="properties[1 Initial]"], textarea[name="properties[1 Initial]"]'
  };
  const MONOGRAM_INITIALS_SELECTOR = Object.values(MONOGRAM_INITIAL_SELECTORS).join(', ');
  const MONOGRAM_BRANCHES = [
    { length: 3, defaultValue: 'ABC', styles: ['Style 1', 'Style 3', 'Style 10'] },
    { length: 2, defaultValue: 'AB', styles: ['Style 2', 'Style 7', 'Style 9'] },
    { length: 1, defaultValue: 'A', styles: ['Style 4', 'Style 5', 'Style 8'] }
  ];
  const FONT_STYLE_SELECTOR = 'input[type="radio"][name="properties[Choose Font Style]"]';
  const DESIGN_COLOR_SELECTOR = 'input[type="radio"][name="properties[Design Color]"]';
  const TEE_DESIGN_COLOR_SELECTOR = 'input[type="radio"][name="properties[Design Color / B]"], input[type="radio"][name="properties[Design Color / W]"], input[type="radio"][name="properties[Design Color]"]';
  const FILE_SELECTOR = '#cl_optionsapp input[type="file"], .gs-shell input[type="file"]';
  const CANVAS_SELECTOR = '#preview-canvas, #preview-canvas-popup canvas, #preview-canvas-popup2 canvas, #cloned-canvas, #cloned-canvas2, #popup-canvas, #cl_optionsapp canvas, .main-preview canvas, .customily-preview canvas';
  const ARTWORK_CONSENT_SELECTOR = '.customily_option.cl-has-checkbox.gs-sane-artwork-rights input[type="checkbox"], .gs-sane-artwork-rights input[type="checkbox"]';
  const ARTWORK_CONSENT_PRIVATE_NAME = 'properties[_Artwork Rights Confirmed]';
  const FINAL_CONFIRM_SELECTOR = '.main-preview-with-checkbox #agree_checkbox, .main-preview-with-checkbox .final_check_btn';
  const DESIGN_CONFIRM_SELECTOR = '#design-confirm-check';
  const PLACEHOLDER_RE = /^(your text here|custom text|add text|text|ab|abc|xyz|name|sample)$/i;
  const FAMILY_STANDARD = 'standard-multistyle';
  const FAMILY_TEES = 'tee-text-only';
  const FAMILY_DRINKWARE_GATED = 'drinkware-method-gated';
  const FAMILY_DRINKWARE_DIRECT = 'drinkware-direct-multistyle';
  const FAMILY_IMAGE_ONLY_LIMITED = 'image-only-limited';
  const FAMILY_SPECIAL_TEMPLATE = 'special-template';
  const FAMILY_UNKNOWN = 'unknown-customily';
  // In Golf Swag operations, Full Color Digital Print is the controlled
  // decoration_methods value for the Helix-capable production path.
  const DECORATION_FULL_COLOR_DIGITAL = 'Full Color Digital Print';
  const DECORATION_FULL_COLOR_HEAT_PRESS = 'Full Color Heat Press';
  const DECORATION_LASER = 'Laser Engraving';
  const DECORATION_MIXED = 'Full Color Digital Print or Laser Engraving';
  const DECORATION_SCREEN_PRINTING = 'Screen Printing';
  const DECORATION_METHODS_BY_FAMILY = Object.freeze({
    [FAMILY_STANDARD]: new Set([DECORATION_FULL_COLOR_DIGITAL, DECORATION_FULL_COLOR_HEAT_PRESS]),
    [FAMILY_TEES]: new Set([DECORATION_SCREEN_PRINTING]),
    [FAMILY_DRINKWARE_DIRECT]: new Set([DECORATION_FULL_COLOR_DIGITAL, DECORATION_LASER]),
    [FAMILY_DRINKWARE_GATED]: new Set([DECORATION_MIXED])
  });
  const ADAPTER_VERSIONS = Object.freeze({
    [FAMILY_STANDARD]: 'standard-multistyle-v7',
    [FAMILY_TEES]: 'tee-text-only-v5',
    [FAMILY_DRINKWARE_GATED]: 'drinkware-method-gated-v6',
    [FAMILY_DRINKWARE_DIRECT]: 'drinkware-direct-multistyle-v3'
  });
  const EXPECTED_PROPERTY_CONTRACTS = {
    [FAMILY_STANDARD]: {
      Images: {
        requiredKeys: ['Choose Style', 'Images', '_Artwork Rights Confirmed', '_customily-thumb-id', '_customily-preview', '_customily-thumb', '_customily-customization-url', '_customily-production-url', '_customily-personalization-id', '_customily-eps-name'],
        oneOfUploadKeys: ['_Upload Image + Remove Background', '_Upload Image ', '_Upload Logo', '_Facecut']
      },
      'Custom Text': {
        requiredKeys: ['Choose Style', 'Add Text', 'Choose Font Style', 'Design Color', '_customily-thumb-id', '_customily-preview', '_customily-thumb', '_customily-customization-url', '_customily-production-url', '_customily-personalization-id', '_customily-eps-name'],
        oneOfFontGroupKeys: ['Sports', 'Signature', 'Minimal']
      },
      Monogram: {
        requiredKeys: ['Choose Style', 'Monogram', 'Design Color', '_customily-thumb-id', '_customily-preview', '_customily-thumb', '_customily-customization-url', '_customily-production-url', '_customily-personalization-id', '_customily-eps-name'],
        oneOfInitialKeys: ['1 Initial', '2 Initials ', '3 Initials']
      }
    },
    [FAMILY_TEES]: {
      Text: {
        requiredKeys: ['Add Text', 'Choose Font Style', '_customily-thumb-id', '_customily-preview', '_customily-thumb', '_customily-customization-url', '_customily-production-url', '_customily-personalization-id', '_customily-eps-name'],
        oneOfColorKeys: ['Design Color / B', 'Design Color / W', 'Design Color']
      }
    },
    [FAMILY_DRINKWARE_DIRECT]: {
      Multistyle: { requiredKeys: ['Choose Style', '_customily-production-url', '_customily-personalization-id'] }
    },
    [FAMILY_DRINKWARE_GATED]: {
      Method: { requiredKeys: ['Choose Customization Type', '_customily-production-url', '_customily-personalization-id'] }
    }
  };

  if (window.__gsCustomilyGuidedStudioV3) return;
  window.__gsCustomilyGuidedStudioV3 = true;

  const query = new URLSearchParams(window.location.search);
  const requestedMode = String(query.get(PARAM) || '').trim().toLowerCase();

  // Certified PDPs default to progressive. Explicit native or unknown modes fail closed to untouched Customily.
  if (requestedMode === NATIVE_MODE) return;
  const mode = requestedMode || PREVIEW_MODE;
  if (!MODES.has(mode)) return;
  const VARIANT = /progressive|inline/.test(mode) ? 'progressive' : 'guided';
  const requestedSkin = String(query.get(SKIN_PARAM) || query.get('gs_skin') || DEFAULT_SKIN).trim().toLowerCase();
  const CLUBHOUSE_ENABLED = VARIANT === 'progressive' && (CLUBHOUSE_SKIN_VALUES.has(requestedSkin) || query.get('gsclubhouse') === '1');

  // The metafield values are authoritative and exact. Do not coerce aliases,
  // whitespace, objects, tags, handles, or titles into supported configuration.
  function authoritativeFamily(value) { return typeof value === 'string' ? value : ''; }
  function authoritativeDecorationMethod(value) { return typeof value === 'string' ? value : ''; }
  function decorationMethodSupported(family, value) {
    return !!DECORATION_METHODS_BY_FAMILY[family]?.has(authoritativeDecorationMethod(value));
  }

  function safeJsonFromScript(id) {
    const node = document.getElementById(id);
    if (!node) return {};
    try { return JSON.parse(node.textContent || '{}') || {}; }
    catch (error) { return {}; }
  }

  function resolution(family, source, enabled, reason = '') {
    return { family, source, enabled: enabled === true, reason };
  }

  function resolveCustomizerFamily(context) {
    const family = authoritativeFamily(context.customizerFamily);
    if (ADAPTER_VERSIONS[family]) {
      return resolution(family, 'metafield', true, 'exact authoritative product metafield');
    }
    return resolution(FAMILY_UNKNOWN, 'metafield', false, 'missing or mismatched authoritative product metafield');
  }

  function createStandardMultistyleAdapter() {
    return {
      marker: FAMILY_STANDARD,
      label: 'Standard multistyle',
      requiredSelectors: [STYLE_SELECTOR],
      bootAssert(root) { return !!root && qsa(STYLE_SELECTOR, root).length > 0; },
      expectedPropertyContract: EXPECTED_PROPERTY_CONTRACTS[FAMILY_STANDARD]
    };
  }

  function createTeeTextOnlyAdapter() {
    return {
      marker: FAMILY_TEES,
      label: 'Tee text-only',
      requiredSelectors: [TEXT_SELECTOR, FONT_STYLE_SELECTOR, TEE_DESIGN_COLOR_SELECTOR],
      bootAssert(root) {
        return !!root && qsa(TEXT_SELECTOR, root).length > 0 && qsa(FONT_STYLE_SELECTOR, root).length > 0 && qsa(TEE_DESIGN_COLOR_SELECTOR, root).length > 0;
      },
      expectedPropertyContract: EXPECTED_PROPERTY_CONTRACTS[FAMILY_TEES]
    };
  }

  function createDirectDrinkwareAdapter() {
    return {
      marker: FAMILY_DRINKWARE_DIRECT,
      label: 'Drinkware direct multistyle',
      requiredSelectors: [STYLE_SELECTOR],
      bootAssert(root) { return !!root && qsa(STYLE_SELECTOR, root).length > 0 && qsa(CUSTOMIZATION_METHOD_SELECTOR, root).length === 0; },
      expectedPropertyContract: EXPECTED_PROPERTY_CONTRACTS[FAMILY_DRINKWARE_DIRECT]
    };
  }

  function createMethodGatedDrinkwareAdapter() {
    return {
      marker: FAMILY_DRINKWARE_GATED,
      label: 'Drinkware method-gated',
      requiredSelectors: [CUSTOMIZATION_METHOD_SELECTOR],
      bootAssert(root) { return !!root && qsa(CUSTOMIZATION_METHOD_SELECTOR, root).length > 0; },
      expectedPropertyContract: EXPECTED_PROPERTY_CONTRACTS[FAMILY_DRINKWARE_GATED]
    };
  }

  function createSuppressedAdapter(marker, label) {
    return {
      marker,
      label,
      requiredSelectors: [],
      bootAssert() { return false; },
      suppressed: true
    };
  }

  const ADAPTERS = {
    [FAMILY_STANDARD]: createStandardMultistyleAdapter(),
    [FAMILY_TEES]: createTeeTextOnlyAdapter(),
    [FAMILY_DRINKWARE_GATED]: createMethodGatedDrinkwareAdapter(),
    [FAMILY_DRINKWARE_DIRECT]: createDirectDrinkwareAdapter(),
    [FAMILY_IMAGE_ONLY_LIMITED]: createSuppressedAdapter(FAMILY_IMAGE_ONLY_LIMITED, 'Image-only limited'),
    [FAMILY_SPECIAL_TEMPLATE]: createSuppressedAdapter(FAMILY_SPECIAL_TEMPLATE, 'Special template')
  };

  function suppressForFamily(reason) {
    document.documentElement.dataset.gsCustomizerFamilySuppressed = reason;
    document.documentElement.classList.remove('gs-customily-guided-studio-enabled', 'gs-customily-progressive-enabled');
    if (window.console && console.info) console.info('[Golf Swag Customily] progressive UI suppressed:', reason);
  }

  function variantClass() { return VARIANT === 'progressive' ? 'gs-customily-progressive-enabled' : 'gs-customily-guided-studio-enabled'; }
  function isGuided() { return VARIANT === 'guided'; }
  function enhancementEnabled() { return document.documentElement.classList.contains('gs-customily-guided-studio-enabled') || document.documentElement.classList.contains('gs-customily-progressive-enabled'); }

  function evaluateActivation(context) {
    const family = authoritativeFamily(context.customizerFamily);
    const adapter = ADAPTERS[family] || null;
    const checks = Object.freeze({
      activationRequested: mode === PREVIEW_MODE,
      productId: Number.isSafeInteger(context.productId) && context.productId > 0,
      templateSuffix: context.templateSuffix === EXPECTED_TEMPLATE_SUFFIX,
      customizerFamily: !!ADAPTER_VERSIONS[family],
      decorationMethod: decorationMethodSupported(family, context.decorationMethod),
      adapterVersion: context.adapterVersion === ADAPTER_VERSIONS[family],
      runtimeFingerprint: context.runtimeFingerprint === EXPECTED_RUNTIME_FINGERPRINT,
      adapterAvailable: !!adapter && !adapter.suppressed
    });
    const failed = Object.entries(checks).filter(([, passed]) => !passed).map(([name]) => name);
    return Object.freeze({ enabled: failed.length === 0, checks, failed });
  }

  const productContext = safeJsonFromScript('gs-customily-product-context');
  const familyResolution = resolveCustomizerFamily(productContext);
  const activeAdapter = ADAPTERS[familyResolution.family] || null;
  const activationGate = evaluateActivation(productContext);
  window.__gsCustomilyProductContext = productContext;
  window.__gsCustomilyActivationGate = activationGate;
  window.__gsCustomilyFamilyResolution = familyResolution;
  window.__gsCustomilyAdapterRegistry = Object.keys(ADAPTERS);
  window.__gsCustomilyActiveAdapter = activationGate.enabled && activeAdapter ? { marker: activeAdapter.marker, label: activeAdapter.label, suppressed: !!activeAdapter.suppressed } : null;
  window.__gsCustomilyExpectedPropertyContracts = EXPECTED_PROPERTY_CONTRACTS;

  if (!activationGate.enabled || !familyResolution.enabled || !activeAdapter || activeAdapter.suppressed) {
    if (window.console && console.info) console.info('[Golf Swag Customily] guided UI fail-closed:', activationGate.failed.join(', ') || 'adapter unavailable');
    return;
  }

  function enableRuntimeClasses() {
    document.documentElement.dataset.gsCustomizerFamily = familyResolution.family;
    document.documentElement.dataset.gsCustomizerFamilySource = familyResolution.source;
    document.documentElement.dataset.gsCustomizerFamilyEnabled = 'true';
    if (familyResolution.reason) document.documentElement.dataset.gsCustomizerFamilyReason = familyResolution.reason;
    document.documentElement.classList.add(variantClass());
    if (CLUBHOUSE_ENABLED) {
      document.documentElement.classList.add('gs-customily-clubhouse-enabled');
      document.documentElement.dataset.gsCustomilySkin = 'clubhouse';
    }
    document.documentElement.dataset.gsCustomilyGuidedStudio = 'catalog-four-family-adapters-v4';
    document.documentElement.dataset.gsCustomilyGuidedVariant = VARIANT;
    document.documentElement.dataset.gsCustomilyActiveAdapter = activeAdapter.marker;
  }

  const state = {
    adapter: activeAdapter,
    launcher: null,
    shell: null,
    stepBadge: null,
    progress: null,
    stepTitle: null,
    statusHost: null,
    pathHost: null,
    methodHost: null,
    methodChips: null,
    previewHost: null,
    uploadHost: null,
    detailHost: null,
    consentHost: null,
    footer: null,
    footerHint: null,
    footerBtn: null,
    backBtn: null,
    review: null,
    reviewList: null,
    reviewError: null,
    reviewSubmit: null,
    inline: null,
    inlineProgress: null,
    inlineTitle: null,
    inlineStatus: null,
    inlineNext: null,
    inlineBtn: null,
    approvalModal: null,
    approvalPreview: null,
    approvalSummary: null,
    approvalError: null,
    approvalTerms: null,
    approvalTermsRow: null,
    approvalTermsCopy: null,
    approvalPreviewCheck: null,
    approvalPreviewCopy: null,
    approvalConfirm: null,
    approvalZoomModal: null,
    approvalZoomImage: null,
    approvalZoomViewport: null,
    approvalZoomLevel: null,
    approvalZoomAnnouncement: null,
    approvalZoomResizeObserver: null,
    approvalPreviewImageSrc: '',
    approvalSyncingHiddenConsent: false,
    zoomScale: 1,
    zoomX: 0,
    zoomY: 0,
    zoomPointers: new Map(),
    zoomDragStart: null,
    zoomPinchStart: null,
    zoomDragging: false,
    zoomGestureHadMultiTouch: false,
    zoomTransformFrame: 0,
    zoomAnnouncementTimer: 0,
    zoomAnnouncementPendingPercent: null,
    zoomReturnFocus: null,
    approvalZoomCloseTimer: 0,
    approvalZoomFocusFrame: 0,
    approvalSubmitting: false,
    approvalAmbiguous: false,
    approvalReturnFocus: null,
    approvalVisibleClickConsumed: false,
    approvalNativeClickConsumed: false,
    approvalTimeout: null,
    approvalDrawerObserver: null,
    approvalUnsubscribers: [],
    observer: null,
    refreshRafQueued: false,
    refreshDeferredForPan: false,
    swatchLifecycleObserver: null,
    swatchLifecycleScope: null,
    swatchReconcileRaf: 0,
    swatchLoadErrorBound: false,
    previewObserver: null,
    previewObservedRoot: null,
    familyFailClosed: false,
    adapterProbeStartedAt: 0,
    previewReadyDebounce: null,
    teeVariantRescanTimers: [],
    mobileInitialUiScrollDone: false,
    mobileInitialUiScrollTimers: [],
    progressiveCardRestampTimers: [],
    imagePreviewReady: false,
    confirmedUpload: null,
    noUploadImagesHoldTimer: 0,
    uploadEpoch: 0,
    uploadEventSignature: '',
    uploadEventAt: 0,
    uploadErrorActive: false,
    lastControlChangeValues: new Map(),
    nativeEditorOpenWait: null,
    imageClearTimer: null,
    floatingPreviewMinimized: false,
    floatingPreviewExpanded: false,

    validationNoticeTimer: null,
    uploadRequiredTimer: null,
    floatingViewportListenerBound: false,
    floatingViewportRaf: 0,
    floatingPreviewViewState: 'collapsed',
    floatingPreviewPointer: null,
    floatingPreviewPointers: new Map(),
    floatingPreviewDragStart: null,
    floatingPreviewPinchStart: null,
    floatingPreviewDragging: false,
    floatingPreviewGestureHadMultiTouch: false,
    floatingPreviewZoomScale: 1,
    floatingPreviewZoomX: 0,
    floatingPreviewZoomY: 0,
    floatingPreviewTransformFrame: 0,
    floatingPreviewAnnouncementTimer: 0,
    floatingPreviewAnnouncementPendingPercent: null,
    floatingPreviewSuppressClick: false,
    floatingPreviewSuppressClickTimer: 0,
    floatingPreviewSuppressClickPoint: null,
    floatingPreviewInteractionOwner: null,
    floatingPreviewInteractionAbort: null,
    floatingPreviewConvergence: null,
    floatingPreviewConvergenceGeneration: 0,
    floatingPreviewConvergenceTimer: 0,
    floatingPreviewConvergenceRaf: 0,
    floatingPreviewConvergenceRequest: null,
    floatingPreviewImageFilterEntries: [],
    floatingPreviewImageFilterObserver: null,
    floatingPreviewImageFilterNetworkEntries: [],
    floatingPreviewImageFilterInFlight: 0,
    floatingPreviewImageFilterInstrumentationInstalled: false,
    progressiveImageProcessingNoticeTimer: 0,
    floatingPreviewBootRestoreRequested: false,
    progressiveRuntimeRoot: null,
    progressiveRootReplacementObserver: null,
    progressiveRootReplacementRaf: 0,
    floatingPreviewBaselineSample: null,
    floatingPreviewDetailFrame: null,
    adjustPlacementHighlightTimer: 0,
    preloadedFontImages: new Set(),
    expandedPopupZoomed: false,
    nativeEditorPopupObserver: null,
    nativeEditorPopupRaf: 0,
    nativeEditorPopupWatchInterval: 0,
    nativeEditorPreviousBodyOverflow: null,
    nativeEditorPreviewWasMinimized: false,
    nativeEditorReturnFocus: null,
    nativeEditorDialogRestore: null,
    nativeEditorInertRestore: [],
    popupObserver: null,
    booted: false,
    open: false,
    lastHash: ''
  };

  const SCRIPT_SRC = document.currentScript?.src || '';
  function themeAssetUrl(filename) {
    if (!filename) return '';
    try { return SCRIPT_SRC ? new URL(filename, SCRIPT_SRC).href : filename; } catch (_) { return filename; }
  }

  // PR69 2026-07-06: Customily font-family previews are opaque white-backed WebP
  // swatches. CSS multiply helped on desktop but Asher caught that iOS/mobile can
  // still show the baked white square. For the Clubhouse font-family cards only,
  // replace those vendor swatches with transparent PNG equivalents generated from
  // the current served assets. This is visual-only: values, inputs, labels, and
  // Customily behavior stay untouched.
  const TRANSPARENT_FONT_SWATCH_ASSETS = {
    'e3be0ddc-c3ec-4479-8856-f0f9b1c6d82c.webp': 'gs-font-swatch-transparent-e3be0ddc-c3ec-4479-8856-f0f9b1c6d82c.png',
    '4e0cd94a-7497-4c11-95fd-ce41496d1cb8.webp': 'gs-font-swatch-transparent-4e0cd94a-7497-4c11-95fd-ce41496d1cb8.png',
    'a696479d-2bcf-4e01-a009-850dd0b199f8.webp': 'gs-font-swatch-transparent-a696479d-2bcf-4e01-a009-850dd0b199f8.png',
    'bf6d5921-e7a1-4725-b804-a0a862a6c571.webp': 'gs-font-swatch-transparent-bf6d5921-e7a1-4725-b804-a0a862a6c571.png',
    'd8eebf26-159d-4382-88a5-9018b8d58b09.webp': 'gs-font-swatch-transparent-d8eebf26-159d-4382-88a5-9018b8d58b09.png',
    '674d7959-76b6-4a12-b185-ed50956ad916.webp': 'gs-font-swatch-transparent-674d7959-76b6-4a12-b185-ed50956ad916.png',
    '02e6094a-cc78-4062-a191-7d5ea02ddc7b.webp': 'gs-font-swatch-transparent-02e6094a-cc78-4062-a191-7d5ea02ddc7b.png',
    'e71a6112-88c2-4ec4-83c1-f2b4eeab7406.webp': 'gs-font-swatch-transparent-e71a6112-88c2-4ec4-83c1-f2b4eeab7406.png',
    '084fcb8b-b213-4354-be8c-ee9f001888b0.webp': 'gs-font-swatch-transparent-084fcb8b-b213-4354-be8c-ee9f001888b0.png',
    'f43715cc-316e-4497-93f0-d1c950287d58.webp': 'gs-font-swatch-transparent-f43715cc-316e-4497-93f0-d1c950287d58.png',
    'db6e4a7e-c8a7-473b-918c-ec7628d59946.webp': 'gs-font-swatch-transparent-db6e4a7e-c8a7-473b-918c-ec7628d59946.png',
    '1a7a8dc8-9340-444e-9dc5-86fc1cd86992.webp': 'gs-font-swatch-transparent-1a7a8dc8-9340-444e-9dc5-86fc1cd86992.png',
    '7ce67db2-14f3-4275-b8f2-647136c65215.webp': 'gs-font-swatch-transparent-7ce67db2-14f3-4275-b8f2-647136c65215.png',
    '8194301b-03ec-4238-941e-339aab754503.webp': 'gs-font-swatch-transparent-8194301b-03ec-4238-941e-339aab754503.png',
    '18da2ca6-0dfc-4ab1-9e7f-f824c20a9c1d.webp': 'gs-font-swatch-transparent-18da2ca6-0dfc-4ab1-9e7f-f824c20a9c1d.png',
    '921e44bd-15bb-49e6-b043-a7e5ba2875bb.webp': 'gs-font-swatch-transparent-921e44bd-15bb-49e6-b043-a7e5ba2875bb.png',
    'dfd078ca-6ddd-46ac-bfdc-308e439c64f5.webp': 'gs-font-swatch-transparent-dfd078ca-6ddd-46ac-bfdc-308e439c64f5.png',
    '72acbe2e-f163-487a-961e-6894d85f95c0.webp': 'gs-font-swatch-transparent-72acbe2e-f163-487a-961e-6894d85f95c0.png',
    '6f9c4b4e-de1a-4fc5-8892-ea1361ca442a.webp': 'gs-font-swatch-transparent-6f9c4b4e-de1a-4fc5-8892-ea1361ca442a.png',
    'f14aee9d-89e0-4a42-9763-42ed71ba33f5.webp': 'gs-font-swatch-transparent-f14aee9d-89e0-4a42-9763-42ed71ba33f5.png',
    '92b98ccb-c7b4-4c30-aea8-60a1af967f52.webp': 'gs-font-swatch-transparent-92b98ccb-c7b4-4c30-aea8-60a1af967f52.png',
    '03c4ce43-aa94-4f2f-bc0a-216761ba0823.webp': 'gs-font-swatch-transparent-03c4ce43-aa94-4f2f-bc0a-216761ba0823.png',
    '6dedd7ec-57d4-4b34-9619-75c4a2306948.webp': 'gs-font-swatch-transparent-6dedd7ec-57d4-4b34-9619-75c4a2306948.png',
    '844ebf35-2799-4de8-92e6-c88f52e5e3b7.webp': 'gs-font-swatch-transparent-844ebf35-2799-4de8-92e6-c88f52e5e3b7.png'
  };

  // Customily sometimes remounts the selected font group with ten spinner-only
  // containers and never inserts its thumbnail <img>. These exact value mappings
  // preserve the accepted PR69 artwork while giving every connected card an
  // image whose readiness can be owned and verified. Twenty-four values use the
  // approved transparent theme PNGs; the six already-clean values use their
  // canonical Customily CDN swatches. This is presentation-only and remains
  // fail-closed to this certified progressive Clubhouse lane.
  const FONT_SWATCH_PRESENTATION_ASSETS = {
    'properties[Sports]::Monagi': 'gs-font-swatch-transparent-e3be0ddc-c3ec-4479-8856-f0f9b1c6d82c.png',
    'properties[Sports]::SPORT NEWS': 'gs-font-swatch-transparent-4e0cd94a-7497-4c11-95fd-ce41496d1cb8.png',
    'properties[Sports]::EA Sports Covers SC': 'gs-font-swatch-transparent-a696479d-2bcf-4e01-a009-850dd0b199f8.png',
    'properties[Sports]::Racing Sport Display': 'gs-font-swatch-transparent-bf6d5921-e7a1-4725-b804-a0a862a6c571.png',
    'properties[Sports]::Sports World': 'gs-font-swatch-transparent-d8eebf26-159d-4382-88a5-9018b8d58b09.png',
    'properties[Sports]::ProtestGuerrilla': 'gs-font-swatch-transparent-674d7959-76b6-4a12-b185-ed50956ad916.png',
    'properties[Sports]::Shrikhand': 'gs-font-swatch-transparent-02e6094a-cc78-4062-a191-7d5ea02ddc7b.png',
    'properties[Sports]::Sportypo': 'gs-font-swatch-transparent-e71a6112-88c2-4ec4-83c1-f2b4eeab7406.png',
    'properties[Sports]::League Sport': 'https://cdn.customily.com/shopify/assetFiles/swatches/golfswagllc.myshopify.com/e0e0d282-b1aa-44f1-a7f2-eef17a44e24e/26/c3b4b199-9b71-442b-a962-24532d87968b.webp',
    'properties[Sports]::Tourney': 'https://cdn.customily.com/shopify/assetFiles/swatches/golfswagllc.myshopify.com/e0e0d282-b1aa-44f1-a7f2-eef17a44e24e/26/46e07257-e96f-4b8f-85f4-51521b370914.webp',
    'properties[Signature]::Black Signature': 'gs-font-swatch-transparent-084fcb8b-b213-4354-be8c-ee9f001888b0.png',
    'properties[Signature]::Beth Ellen': 'gs-font-swatch-transparent-f43715cc-316e-4497-93f0-d1c950287d58.png',
    'properties[Signature]::Calligraffitti': 'gs-font-swatch-transparent-db6e4a7e-c8a7-473b-918c-ec7628d59946.png',
    'properties[Signature]::Great Vibes': 'gs-font-swatch-transparent-1a7a8dc8-9340-444e-9dc5-86fc1cd86992.png',
    'properties[Signature]::Lobster': 'gs-font-swatch-transparent-7ce67db2-14f3-4275-b8f2-647136c65215.png',
    'properties[Signature]::Satisfy': 'gs-font-swatch-transparent-8194301b-03ec-4238-941e-339aab754503.png',
    'properties[Signature]::Style': 'gs-font-swatch-transparent-18da2ca6-0dfc-4ab1-9e7f-f824c20a9c1d.png',
    'properties[Signature]::Carattere': 'gs-font-swatch-transparent-921e44bd-15bb-49e6-b043-a7e5ba2875bb.png',
    'properties[Signature]::Grand Hotel': 'https://cdn.customily.com/shopify/assetFiles/swatches/golfswagllc.myshopify.com/e0e0d282-b1aa-44f1-a7f2-eef17a44e24e/27/e87e0b10-6373-4429-b85e-eba2f82ed39d.webp',
    'properties[Signature]::Sacramento': 'https://cdn.customily.com/shopify/assetFiles/swatches/golfswagllc.myshopify.com/e0e0d282-b1aa-44f1-a7f2-eef17a44e24e/27/520f8c55-d55f-428f-9eae-84e2d276570b.webp',
    'properties[Minimal]::Poppins': 'gs-font-swatch-transparent-dfd078ca-6ddd-46ac-bfdc-308e439c64f5.png',
    'properties[Minimal]::Edu QLD Hand': 'gs-font-swatch-transparent-72acbe2e-f163-487a-961e-6894d85f95c0.png',
    'properties[Minimal]::Julius Sans One': 'gs-font-swatch-transparent-6f9c4b4e-de1a-4fc5-8892-ea1361ca442a.png',
    'properties[Minimal]::Lexend': 'gs-font-swatch-transparent-f14aee9d-89e0-4a42-9763-42ed71ba33f5.png',
    'properties[Minimal]::Roboto': 'gs-font-swatch-transparent-92b98ccb-c7b4-4c30-aea8-60a1af967f52.png',
    'properties[Minimal]::Titan One': 'gs-font-swatch-transparent-03c4ce43-aa94-4f2f-bc0a-216761ba0823.png',
    'properties[Minimal]::Chonburi': 'gs-font-swatch-transparent-6dedd7ec-57d4-4b34-9619-75c4a2306948.png',
    'properties[Minimal]::Instrument': 'gs-font-swatch-transparent-844ebf35-2799-4de8-92e6-c88f52e5e3b7.png',
    'properties[Minimal]::Bodoni': 'https://cdn.customily.com/shopify/assetFiles/swatches/golfswagllc.myshopify.com/e0e0d282-b1aa-44f1-a7f2-eef17a44e24e/28/3e2c39b6-d538-4136-a577-df2c9e64b5c5.webp',
    'properties[Minimal]::Lora': 'https://cdn.customily.com/shopify/assetFiles/swatches/golfswagllc.myshopify.com/e0e0d282-b1aa-44f1-a7f2-eef17a44e24e/28/41a07f14-3bda-4f42-9b83-fb0530d5c0c7.webp'
  };

  function progressiveFontSwatchUrlForInput(input) {
    if (!CLUBHOUSE_ENABLED || !input || !input.isConnected) return '';
    const group = input.closest('.customily_option.sports-font-family');
    if (!group) return '';
    const key = `${input.name || ''}::${norm(input.value)}`;
    const asset = FONT_SWATCH_PRESENTATION_ASSETS[key] || '';
    if (!asset) return '';
    return /^https:\/\//i.test(asset) ? asset : themeAssetUrl(asset);
  }
  function filenameFromUrl(url) {
    const raw = String(url || '').split('?')[0].split('#')[0];
    return raw.split('/').pop() || '';
  }
  function transparentFontSwatchUrlFor(img, input = null) {
    const deterministic = progressiveFontSwatchUrlForInput(input);
    if (deterministic) return deterministic;
    if (!img || !CLUBHOUSE_ENABLED) return '';
    const original = img.dataset.gsOriginalFontSwatchSrc || img.currentSrc || img.src || img.getAttribute('src') || '';
    const replacement = TRANSPARENT_FONT_SWATCH_ASSETS[filenameFromUrl(original)];
    return replacement ? themeAssetUrl(replacement) : '';
  }

  // A Customily swatch remount is not atomic: its 44x44 .csh-backdrop parent can
  // paint before the replacement image is decoded. Keep the last valid glyph by
  // real input name/value, decode the next source off-DOM, then swap it in. The
  // CSS partner below owns the first-paint parent layer so this remains stable
  // even before progressive role attributes are restamped.
  const SWATCH_IMAGE_MEMORY = new WeakMap();
  const SWATCH_FAILED_TARGET_MEMORY = new WeakMap();
  const SWATCH_DECODE_CACHE = new Map();
  let swatchRequestSequence = 0;

  function progressiveSwatchContainer(node) {
    if (!node) return null;
    if (node.matches?.('.csh-image-container')) return node;
    return node.closest?.('.csh-image-container')
      || node.closest?.('label')?.querySelector?.('.csh-image-container')
      || node.closest?.('.customily-swatch')?.querySelector?.('.csh-image-container')
      || null;
  }

  function progressiveSwatchScope(img) {
    return img?.closest('form[action*="/cart/add"]') || img?.closest('#cl_optionsapp') || customilyRoot();
  }

  function progressiveSwatchMemory(img) {
    const scope = progressiveSwatchScope(img);
    if (!scope) return null;
    if (!SWATCH_IMAGE_MEMORY.has(scope)) SWATCH_IMAGE_MEMORY.set(scope, new Map());
    return SWATCH_IMAGE_MEMORY.get(scope);
  }

  function progressiveSwatchFailureMemory(img) {
    const scope = progressiveSwatchScope(img);
    if (!scope) return null;
    if (!SWATCH_FAILED_TARGET_MEMORY.has(scope)) SWATCH_FAILED_TARGET_MEMORY.set(scope, new Map());
    return SWATCH_FAILED_TARGET_MEMORY.get(scope);
  }

  function progressiveSwatchKey(input) {
    if (!input) return '';
    const optionId = input.closest('.customily_option')?.getAttribute('opt-id') || '';
    return `${optionId}::${input.name || ''}::${input.value || ''}`;
  }

  function progressiveSwatchSrc(img) {
    return String(img?.currentSrc || img?.src || img?.getAttribute?.('src') || '');
  }

  function sameProgressiveSwatchUrl(left, right) {
    if (!left || !right) return false;
    try {
      return new URL(left, window.location.href).pathname === new URL(right, window.location.href).pathname;
    } catch (error) {
      return String(left) === String(right);
    }
  }

  function retainProgressiveSwatchVisual(img, url) {
    const container = progressiveSwatchContainer(img);
    if (!container || !url) return;
    setDatasetIfChanged(container, 'gsSwatchRetained', 'true');
    const retainedImage = `url(${JSON.stringify(String(url))})`;
    if (container.style.getPropertyValue('--gs-swatch-retained-image') !== retainedImage) {
      container.style.setProperty('--gs-swatch-retained-image', retainedImage);
    }
  }

  function clearProgressiveSwatchVisual(img) {
    const container = progressiveSwatchContainer(img);
    if (!container) return;
    if (container.dataset.gsSwatchRetained) delete container.dataset.gsSwatchRetained;
    if (container.style.getPropertyValue('--gs-swatch-retained-image')) {
      container.style.removeProperty('--gs-swatch-retained-image');
    }
  }

  function setProgressiveSwatchState(img, nextState) {
    if (!img) return;
    const container = progressiveSwatchContainer(img);
    const validPixels = img.complete && img.naturalWidth > 0 && img.naturalHeight > 0;
    if (validPixels && ['ready', 'retained', 'error'].includes(nextState)) {
      setDatasetIfChanged(img, 'gsIconReady', 'true');
    } else if (img.dataset.gsIconReady === 'true') {
      delete img.dataset.gsIconReady;
    }
    if (container) {
      setDatasetIfChanged(container, 'gsSwatchState', nextState);
      if (nextState !== 'error' && container.dataset.gsSwatchError) delete container.dataset.gsSwatchError;
    }
    if (nextState === 'ready' && validPixels) {
      setStyleIfChanged(img, 'visibility', 'visible');
      // Ready artwork lets the stylesheet own selected/unselected opacity.
      // Customily and earlier stabilizers can leave inline `opacity:1 !important`,
      // which would otherwise defeat the native-checked hierarchy and hover.
      removeStyleIfPresent(img, 'opacity');
      setStyleIfChanged(img, 'display', 'block');
    } else if (['loading', 'retained', 'error'].includes(nextState)) {
      setStyleIfChanged(img, 'visibility', 'hidden');
      setStyleIfChanged(img, 'opacity', '0');
    }
  }

  function preloadAndDecodeSwatch(url) {
    if (!url) return Promise.reject(new Error('missing swatch URL'));
    if (SWATCH_DECODE_CACHE.has(url)) return SWATCH_DECODE_CACHE.get(url);
    const request = new Promise((resolve, reject) => {
      const probe = new Image();
      let settled = false;
      const fail = () => {
        if (settled) return;
        settled = true;
        reject(new Error(`swatch image failed: ${filenameFromUrl(url) || 'unknown'}`));
      };
      const finish = async () => {
        if (settled) return;
        try {
          if (typeof probe.decode === 'function') await probe.decode();
        } catch (error) {
          // Safari can reject decode() after a successful load. Natural pixels
          // are the final readiness contract; only fail when they are absent.
          if (!(probe.complete && probe.naturalWidth > 0)) { fail(); return; }
        }
        if (!(probe.complete && probe.naturalWidth > 0)) { fail(); return; }
        settled = true;
        resolve(url);
      };
      probe.decoding = 'async';
      probe.addEventListener('load', finish, { once: true });
      probe.addEventListener('error', fail, { once: true });
      probe.src = url;
      if (probe.complete) window.queueMicrotask(finish);
    }).catch((error) => {
      SWATCH_DECODE_CACHE.delete(url);
      throw error;
    });
    SWATCH_DECODE_CACHE.set(url, request);
    return request;
  }

  function stabilizeProgressiveSwatchImage(img, input, targetUrl, onStateChange) {
    if (!img) return false;
    const key = progressiveSwatchKey(input);
    const memory = progressiveSwatchMemory(img);
    const failureMemory = progressiveSwatchFailureMemory(img);
    const currentUrl = progressiveSwatchSrc(img);
    const currentReady = img.complete && img.naturalWidth > 0 && img.naturalHeight > 0;
    const rememberedUrl = key && memory ? memory.get(key) : '';

    if (currentReady && (!targetUrl || sameProgressiveSwatchUrl(currentUrl, targetUrl))) {
      if (key && memory && currentUrl) memory.set(key, currentUrl);
      if (img.dataset.gsSwatchRequest) delete img.dataset.gsSwatchRequest;
      if (img.dataset.gsSwatchTarget) delete img.dataset.gsSwatchTarget;
      if (img.dataset.gsSwatchFailedTarget) delete img.dataset.gsSwatchFailedTarget;
      if (key && failureMemory) failureMemory.delete(key);
      clearProgressiveSwatchVisual(img);
      setProgressiveSwatchState(img, 'ready');
      return true;
    }

    // Preserve valid pixels while the intended target is decoded. On a fresh
    // remount, restore the last good source for this exact input when available.
    if (currentReady) {
      if (key && memory && currentUrl) memory.set(key, currentUrl);
      retainProgressiveSwatchVisual(img, currentUrl);
      setProgressiveSwatchState(img, 'retained');
    } else if (rememberedUrl && !sameProgressiveSwatchUrl(rememberedUrl, currentUrl)) {
      retainProgressiveSwatchVisual(img, rememberedUrl);
      setAttrIfChanged(img, 'src', rememberedUrl);
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      setProgressiveSwatchState(img, img.complete && img.naturalWidth > 0 && img.naturalHeight > 0 ? 'retained' : 'loading');
    } else {
      setProgressiveSwatchState(img, 'loading');
    }

    if (!targetUrl) return currentReady;
    const rememberedFailure = key && failureMemory ? failureMemory.get(key) : null;
    if (rememberedFailure && sameProgressiveSwatchUrl(rememberedFailure.url, targetUrl)) {
      if (Date.now() - rememberedFailure.at < 10000) {
        setDatasetIfChanged(img, 'gsSwatchFailedTarget', targetUrl);
        setProgressiveSwatchState(img, 'error');
        return false;
      }
      failureMemory.delete(key);
    }
    if (img.dataset.gsSwatchFailedTarget === targetUrl) {
      setProgressiveSwatchState(img, 'error');
      return img.dataset.gsIconReady === 'true';
    }
    if (img.dataset.gsSwatchTarget === targetUrl && img.dataset.gsSwatchRequest) {
      return img.dataset.gsIconReady === 'true';
    }

    const requestToken = String(++swatchRequestSequence);
    setDatasetIfChanged(img, 'gsSwatchTarget', targetUrl);
    setDatasetIfChanged(img, 'gsSwatchRequest', requestToken);

    const finishReady = async () => {
      if (!img.isConnected || img.dataset.gsSwatchRequest !== requestToken) return;
      try {
        if (typeof img.decode === 'function') await img.decode();
      } catch (error) {
        if (!(img.complete && img.naturalWidth > 0 && img.naturalHeight > 0)) return;
      }
      if (!img.isConnected || img.dataset.gsSwatchRequest !== requestToken || !(img.complete && img.naturalWidth > 0 && img.naturalHeight > 0)) return;
      const readyUrl = progressiveSwatchSrc(img);
      if (!sameProgressiveSwatchUrl(readyUrl, targetUrl)) return;
      if (key && memory && readyUrl) memory.set(key, readyUrl);
      delete img.dataset.gsSwatchRequest;
      if (img.dataset.gsSwatchTarget) delete img.dataset.gsSwatchTarget;
      if (img.dataset.gsSwatchFailedTarget) delete img.dataset.gsSwatchFailedTarget;
      if (key && failureMemory) failureMemory.delete(key);
      clearProgressiveSwatchVisual(img);
      setProgressiveSwatchState(img, 'ready');
      onStateChange?.();
    };

    preloadAndDecodeSwatch(targetUrl).then(() => {
      if (!img.isConnected || img.dataset.gsSwatchRequest !== requestToken) return;
      // The replacement is already decoded in the browser cache before this
      // source mutation. The retained glyph (or loader) remains until the DOM
      // image itself confirms usable natural pixels.
      const visibleUrl = progressiveSwatchSrc(img);
      if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0 && visibleUrl) retainProgressiveSwatchVisual(img, visibleUrl);
      setProgressiveSwatchState(img, 'loading');
      setAttrIfChanged(img, 'src', targetUrl);
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
        finishReady();
        return;
      }
      img.addEventListener('load', finishReady, { once: true });
      img.addEventListener('error', () => {
        if (!img.isConnected || img.dataset.gsSwatchRequest !== requestToken) return;
        const container = progressiveSwatchContainer(img);
        if (container) setDatasetIfChanged(container, 'gsSwatchError', 'dom-image-failed');
        setDatasetIfChanged(img, 'gsSwatchFailedTarget', targetUrl);
        if (key && failureMemory) failureMemory.set(key, { url: targetUrl, at: Date.now() });
        delete img.dataset.gsSwatchRequest;
        setProgressiveSwatchState(img, 'error');
        onStateChange?.();
      }, { once: true });
    }).catch((error) => {
      if (!img.isConnected || img.dataset.gsSwatchRequest !== requestToken) return;
      delete img.dataset.gsSwatchRequest;
      const container = progressiveSwatchContainer(img);
      if (container) setDatasetIfChanged(container, 'gsSwatchError', 'decode-failed');
      setDatasetIfChanged(img, 'gsSwatchFailedTarget', targetUrl);
      if (key && failureMemory) failureMemory.set(key, { url: targetUrl, at: Date.now() });
      setProgressiveSwatchState(img, 'error');
      if (window.console && console.warn) console.warn('[Golf Swag Customily] swatch decode failed:', error.message);
      onStateChange?.();
    });

    return img.dataset.gsIconReady === 'true';
  }

  // Asher approved his exact 2026-06-29 submitted artwork for both visual lanes.
  // Clubhouse must not rewrite these filenames to generated/gold alternatives.
  function skinIconImage(filename) {
    return filename;
  }

  // Immutable names below are locked to Asher's exact approved 2026-06-29 files.
  // The legacy *-Black.webp keys are also byte-identical compatibility copies.
  // Do not replace either generation without fresh Asher approval and hash QA.
  const STYLE_META = {
    Images: { title: 'Images', note: '', badge: 'Recommended', primary: true, order: 1, iconImage: 'GS-Asher-20260629-Image.webp' },
    'Custom Text': { title: 'Custom Text', note: '', order: 2, iconImage: 'GS-Asher-20260629-Custom-Text.webp' },
    Monogram: { title: 'Monogram', note: '', order: 3, iconImage: 'GS-Asher-20260629-Monogram.webp' }
  };

  const METHOD_META = {
    'Upload Image': { title: 'Full Image', note: 'Use a photo or full-color graphic.', icon: 'I', order: 1, iconImage: 'GS-Asher-20260629-Image.webp' },
    'Upload Logo': { title: 'Logo', note: 'Best for brand marks and clean vector art.', icon: 'L', order: 2, iconImage: 'GS-Asher-20260629-Logo.webp' },
    'Upload Face Image': { title: 'Face Cut', note: 'Crop a face or subject for novelty art.', icon: 'F', order: 3, iconImage: 'GS-Asher-20260629-Facecut.webp' },
    'Upload Image & Remove Background': { title: 'BG Remover', note: 'Use when the art needs cleanup.', icon: 'B', order: 4, iconImage: 'GS-Asher-20260629-Background-Remover.webp' }
  };

  // Progressive visual order now mirrors the live Customily UI. Keep the real
  // input/label DOM pairs intact and use CSS order for font/monogram groups so
  // Customily/Vue event indices cannot drift from the shopper-visible card.
  const PROGRESSIVE_OPTION_ORDERS = {
    'properties[Design Color]': ['Black', 'White', 'The Green', 'Blue Steel', 'Red Coupe', 'Navy Blue', 'Bubblegum', 'Golden Pond', 'Orange Cream', 'Burgundy', 'Plum Purple', 'Sky Blue', 'Stone Age', 'Chocolate'],
    'properties[Sports]': ['Monagi', 'SPORT NEWS', 'EA Sports Covers SC', 'Racing Sport Display', 'Sports World', 'ProtestGuerrilla', 'Shrikhand', 'Sportypo'],
    'properties[Signature]': ['Black Signature', 'Beth Ellen', 'Calligraffitti', 'Great Vibes', 'Lobster', 'Satisfy', 'Style', 'Carattere'],
    'properties[Minimal]': ['Poppins', 'Edu QLD Hand', 'Julius Sans One', 'Lexend', 'Roboto', 'Titan One', 'Chonburi', 'Instrument'],
    'properties[Monogram]': ['Style 9', 'Style 10', 'Style 2', 'Style 3', 'Style 1', 'Style 7', 'Style 5', 'Style 4']
  };
  // The method-gated drinkware catalog has one additional native style that was
  // previously pruned with the standard-family allowlist. Restore only that
  // family-specific option; native inputs/values/order remain untouched.
  const METHOD_GATED_DRINKWARE_MONOGRAM_ORDER = Object.freeze([
    ...PROGRESSIVE_OPTION_ORDERS['properties[Monogram]'],
    'Style 8'
  ]);
  const TEE_FONT_STYLE_ORDER = Object.freeze([
    'Poppins',
    'Edu QLD Hand',
    'Julius Sans One',
    'Lexend',
    'Roboto',
    'Titan One',
    'Chonburi',
    'Instrument'
  ]);
  const CUSTOMIZATION_METHOD_COPY = Object.freeze({
    'Full Color': Object.freeze({ title: 'Full Color', note: 'Multi-color logos & designs.' }),
    Engraving: Object.freeze({ title: 'Engraving', note: 'Permanent single-color mark.' })
  });

  // Exact current Customily/admin swatch colors captured from the served draft.
  // Keep the visual order in PROGRESSIVE_OPTION_ORDERS, but use these values so
  // the compact swatches match the actual preview render (not approximations).
  const DESIGN_COLOR_SWATCHES = {
    Black: 'rgb(6, 8, 8)',
    White: 'rgb(255, 255, 255)',
    'The Green': 'rgb(0, 114, 72)',
    'Blue Steel': 'rgb(0, 93, 170)',
    'Red Coupe': 'rgb(206, 32, 46)',
    'Navy Blue': 'rgb(0, 21, 65)',
    Bubblegum: 'rgb(240, 101, 164)',
    'Golden Pond': 'rgb(210, 185, 132)',
    'Orange Cream': 'rgb(242, 116, 33)',
    Burgundy: 'rgb(151, 0, 46)',
    'Plum Purple': 'rgb(79, 38, 131)',
    'Sky Blue': 'rgb(0, 154, 216)',
    'Stone Age': 'rgb(143, 143, 142)',
    Chocolate: 'rgb(69, 33, 0)'
  };

  function qs(selector, scope = document) { return scope.querySelector(selector); }
  function qsa(selector, scope = document) { return Array.from(scope.querySelectorAll(selector)); }
  function norm(value) { return String(value || '').trim(); }
  function lower(value) { return norm(value).toLowerCase(); }
  // ---- Idempotent write guards (FIX A: diff-before-write) ----------------
  // These elide redundant DOM writes so the steady state performs ZERO
  // mutations (the MutationObserver therefore stops self-retriggering). They
  // never change the END-STATE value — only whether a write happens at all.
  function setStyleIfChanged(el, prop, val) {
    if (!el) return;
    if (el.style.getPropertyValue(prop) !== val) el.style.setProperty(prop, val, 'important');
  }
  function setStylePlainIfChanged(el, prop, val) {
    if (!el) return;
    if (el.style.getPropertyValue(prop) !== val) el.style.setProperty(prop, val);
  }
  function removeStyleIfPresent(el, prop) {
    if (!el) return;
    if (el.style.getPropertyValue(prop) !== '') el.style.removeProperty(prop);
  }
  function setDatasetIfChanged(el, key, val) {
    if (!el || !el.dataset) return;
    if (el.dataset[key] !== val) el.dataset[key] = val;
  }
  function setHiddenIfChanged(el, val) {
    if (!el) return;
    if (el.hidden !== val) el.hidden = val;
  }
  function setAttrIfChanged(el, name, val) {
    if (!el) return;
    if (el.getAttribute(name) !== val) el.setAttribute(name, val);
  }
  function visible(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    const css = window.getComputedStyle(el);
    return rect.width > 1 && rect.height > 1 && css.display !== 'none' && css.visibility !== 'hidden' && css.opacity !== '0';
  }
  function customilyRoot() { return qs('#cl_optionsapp'); }
  function customilyRoots() { return qsa('#cl_optionsapp').filter((root) => root.isConnected); }
  function productForm() { return qs('product-form form') || qs('form[action*="/cart/add"]'); }
  function realSubmitButton() { return qs('product-form [type="submit"]') || productForm()?.querySelector('[type="submit"]'); }
  function customilyCartButton() { return qs('#customily-cart-btn') || productForm()?.querySelector('button[name="add"]:not([type="submit"]), [name="add"][type="button"]'); }
  function addToCartButton() { return customilyCartButton() || realSubmitButton() || productForm()?.querySelector('button[name="add"], [name="add"], button[type="button"]'); }

  function labelFor(input) {
    if (!input) return null;
    if (input.id) {
      try {
        const byFor = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (byFor) return byFor;
      } catch (_) {}
    }
    return input.closest('label') || input.closest('.customily-swatch')?.querySelector('label') || input;
  }

  function cardFor(input) {
    return input?.closest('.customily-swatch, .swatch, .swatch-container > *, label') || labelFor(input) || input;
  }

  function clickRealInput(input) {
    if (!input) return false;
    const target = labelFor(input) || input;
    target.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
    target.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
    target.click();
    if (input.type === 'radio' || input.type === 'checkbox') input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    refreshSoon();
    window.setTimeout(refreshSoon, 140);
    window.setTimeout(refreshSoon, 480);
    return true;
  }

  function checkedValue(selector) {
    const checked = qsa(selector).find((input) => input.checked);
    return checked ? norm(checked.value) : '';
  }

  function radioByValue(selector, value) {
    const target = lower(value);
    return qsa(selector).find((input) => lower(input.value) === target);
  }

  function textFields() {
    return qsa(TEXT_SELECTOR).filter((field) => visible(field.closest('.customily_option') || field));
  }

  function fileInputs() {
    return qsa(FILE_SELECTOR).filter((input) => visible(input.closest('.customily_option') || input));
  }

  function allFileInputs() { return qsa(FILE_SELECTOR); }

  function uploadScope() { return state.uploadHost || customilyRoot() || document; }

  function isUploadThumbnail(img) {
    if (!img || !visible(img)) return false;
    const src = String(img.currentSrc || img.src || '');
    const cls = String(img.className || '');
    if (!src) return false;
    if (/swatches\/|gs-customily-|Frame_29|added-icon/i.test(src + ' ' + cls)) return false;
    return /blob:|cdn\.shopify|cdn\.customily|https?:|data:image/i.test(src);
  }

  function uploadedPreviewImage() {
    return qsa('img', uploadScope()).find(isUploadThumbnail) || null;
  }

  function visibleUploadedMeta(scope) {
    return qsa('.file-name, .filename, [data-uploaded="true"], .customily-file-with-thumbnail', scope)
      .some((node) => {
        if (!visible(node)) return false;
        if (String(node.getAttribute('data-uploaded')).toLowerCase() === 'true') return true;
        const text = norm(node.textContent || node.getAttribute('aria-label') || node.getAttribute('title') || '');
        if (!text || /placeholder|select image|replace|remove|delete/i.test(text)) return false;
        return /\.(png|jpe?g|webp|bmp|heic|dng|pdf|svg)(\?|$)|uploaded|attached|ready/i.test(text);
      });
  }

  function hasUploadedControlState() {
    const scope = uploadScope();
    const hasVisibleError = qsa('.cl-error-message, [class*="error"]', scope)
      .some((node) => visible(node) && norm(node.textContent));
    if (hasVisibleError) return false;
    const hasMeta = visibleUploadedMeta(scope);
    if (hasMeta) return true;
    return qsa('button, a, [role="button"]', scope).some((node) => {
      if (!visible(node)) return false;
      const text = norm(node.textContent || node.getAttribute('aria-label') || '');
      return /remove|delete/i.test(text) && hasMeta;
    });
  }

  const CUSTOMILY_ERROR_SELECTOR = [
    '[aria-invalid="true"]', '[role="alert"]', '[aria-live="assertive"]',
    '.cl-error-message', '.customily-error', '.customily-error-message', '.error-message',
    '[class*="validation-error"]', '[class*="upload-error"]', '[class*="file-error"]',
    '[class*="error_message"]', '[class*="error-message"]'
  ].join(',');
  const CUSTOMILY_ERROR_TEXT_RE = /\b(?:invalid|validation|error|failed|failure|unsupported|not supported|could not|unable to|must (?:upload|select|choose|enter)|please (?:upload|select|choose|enter))\b/i;

  function controlAssociatedWithError(error, root = customilyRoot()) {
    if (!error || !root) return null;
    if (error.matches?.('input, textarea, select, button')) return error;
    if (error.id) {
      const id = CSS.escape(error.id);
      const described = qs(`[aria-describedby~="${id}"], [aria-errormessage="${id}"]`, root);
      if (described) return described;
    }
    const errorFor = error.getAttribute?.('for');
    if (errorFor) {
      try { const labelled = qs(`#${CSS.escape(errorFor)}`, root); if (labelled) return labelled; } catch (_) {}
    }
    const group = error.closest?.('.customily_option, .customily-swatch, [role="group"], [role="radiogroup"], fieldset') || error.parentElement;
    return qsa('input, textarea, select, button', group || root).find((control) => control !== error && (visible(control) || visible(labelFor(control)) || control.type === 'file'))
      || (chosenStyle() === 'Images' ? firstVisibleControl(FILE_SELECTOR, root) : null);
  }

  function visibleCustomilyError() {
    const root = customilyRoot();
    if (!root) return null;
    const candidates = qsa(CUSTOMILY_ERROR_SELECTOR, root);
    // Customily builds do not expose one stable error class. Use visible short
    // leaf/status text as a fallback, still scoped strictly to its real root.
    qsa('[class], [role], p, span, small', root).forEach((node) => {
      if (!candidates.includes(node) && node.children.length === 0 && CUSTOMILY_ERROR_TEXT_RE.test(norm(node.textContent))) candidates.push(node);
    });
    const error = candidates.find((node) => {
      if (!visible(node)) return false;
      if (node.matches?.('[aria-invalid="true"]')) return true;
      const text = norm(node.textContent || node.getAttribute?.('aria-label') || node.getAttribute?.('title') || '');
      return !!text && (CUSTOMILY_ERROR_TEXT_RE.test(text) || /error|invalid/i.test(String(node.className || '')));
    });
    return error ? { error, target: controlAssociatedWithError(error, root) } : null;
  }

  function directlyUploadAssociatedCustomilyError(error, root = customilyRoot()) {
    if (!error || !root) return false;
    if (error.matches?.(FILE_SELECTOR) || error.closest?.('[data-gs-progressive-role="upload"]')) return true;
    if (error.id) {
      const id = CSS.escape(error.id);
      const described = qs(`[aria-describedby~="${id}"], [aria-errormessage="${id}"]`, root);
      if (described?.matches?.(FILE_SELECTOR) || described?.closest?.('[data-gs-progressive-role="upload"]')) return true;
    }
    const errorFor = error.getAttribute?.('for');
    if (!errorFor) return false;
    try {
      const labelled = qs(`#${CSS.escape(errorFor)}`, root);
      return !!(labelled?.matches?.(FILE_SELECTOR) || labelled?.closest?.('[data-gs-progressive-role="upload"]'));
    } catch (_) {
      return false;
    }
  }

  function uploadAssociatedCustomilyError(details) {
    return !!details && directlyUploadAssociatedCustomilyError(details.error);
  }

  const IMAGE_UPLOAD_PROPERTY_KEYS = EXPECTED_PROPERTY_CONTRACTS[FAMILY_STANDARD].Images.oneOfUploadKeys;
  const UPLOAD_PROPERTY_VALUE_RE = /^(?:https?:|blob:|data:)|cdn\.|\.(?:png|jpe?g|webp|bmp|heic|dng|pdf|svg)(?:\?|$)/i;
  const IMAGE_METHOD_BY_UPLOAD_PROPERTY = Object.freeze({
    '_Upload Image ': 'Upload Image',
    '_Upload Logo': 'Upload Logo',
    '_Facecut': 'Upload Face Image',
    '_Upload Image + Remove Background': 'Upload Image & Remove Background'
  });

  function uploadPropertyImageMethod(key) {
    return IMAGE_METHOD_BY_UPLOAD_PROPERTY[key] || '';
  }

  function uploadRecordMatchesImageMethod(record, method = chosenImageMethod()) {
    if (!record) return false;
    const recordMethod = norm(record.method || uploadPropertyImageMethod(record.key));
    const selectedMethod = norm(method);
    return !!recordMethod && !!selectedMethod && recordMethod === selectedMethod;
  }

  function customilyPropertyValue(key) {
    const expectedName = `properties[${key}]`;
    const controls = qsa('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]');
    const control = controls.find((candidate) => candidate.name === expectedName
      && candidate.type !== 'file'
      && norm(candidate.value));
    return norm(control?.value || '');
  }


  function stampConfirmedUploadRecord(record = state.confirmedUpload) {
    const html = document.documentElement;
    html.dataset.gsUploadEpoch = String(state.uploadEpoch || 0);
    html.dataset.gsConfirmedUploadEpoch = record ? String(record.epoch ?? '') : '';
    html.dataset.gsConfirmedUploadReady = record?.convergedReady === true ? 'true' : 'false';
    html.dataset.gsConfirmedUploadMethod = record?.method || uploadPropertyImageMethod(record?.key) || '';
  }

  function invalidateConfirmedUpload(reason = 'replacement') {
    if (reason === 'error' && state.uploadErrorActive) return;
    state.uploadEpoch = Number(state.uploadEpoch || 0) + 1;
    state.uploadErrorActive = reason === 'error';
    state.confirmedUpload = null;
    state.imagePreviewReady = false;
    stampConfirmedUploadRecord(null);
  }

  function rememberPendingUpload(input) {
    const file = input?.files?.[0];
    if (!file) return null;
    const signature = `${file.name || 'upload'}:${file.size || 0}:${file.lastModified || 0}`;
    const now = Date.now();
    if (signature !== state.uploadEventSignature || now - Number(state.uploadEventAt || 0) > 750) {
      invalidateConfirmedUpload('replacement');
      state.uploadEventSignature = signature;
      state.uploadEventAt = now;
    }
    state.confirmedUpload = {
      key: 'file-input',
      value: signature,
      method: chosenImageMethod(),
      personalizationId: customilyPropertyValue('_customily-personalization-id'),
      epoch: state.uploadEpoch,
      convergedReady: false,
      ready: false,
      at: now
    };
    stampConfirmedUploadRecord();
    return state.confirmedUpload;
  }

  function confirmedUploadRecord(options = {}) {
    const uploadError = uploadAssociatedCustomilyError(visibleCustomilyError());
    if (uploadError) {
      // Customily can leave the prior method's empty-upload validation visible
      // during a remount. The active convergence path owns error invalidation once
      // the error is proven to belong to the selected method/generation.
      return null;
    }
    state.uploadErrorActive = false;
    const selectedMethod = chosenImageMethod();
    const personalizationId = customilyPropertyValue('_customily-personalization-id');
    const cached = state.confirmedUpload?.epoch === state.uploadEpoch
      && uploadRecordMatchesImageMethod(state.confirmedUpload, selectedMethod)
      ? state.confirmedUpload
      : null;
    const liveUpload = IMAGE_UPLOAD_PROPERTY_KEYS
      .map((key) => ({ key, value: customilyPropertyValue(key) }))
      .find(({ key, value }) => uploadPropertyImageMethod(key) === selectedMethod
        && value && UPLOAD_PROPERTY_VALUE_RE.test(value));
    const durablePreview = customilyPropertyValue('_customily-preview')
      || customilyPropertyValue('_customily-customization-url')
      || customilyPropertyValue('_customily-production-url');
    if (liveUpload && durablePreview) {
      const prior = cached;
      const identityChanged = !!(prior?.personalizationId && personalizationId && prior.personalizationId !== personalizationId);
      const priorWasDurable = !!prior && IMAGE_UPLOAD_PROPERTY_KEYS.includes(prior.key);
      const artifactChanged = priorWasDurable && (prior.key !== liveUpload.key || prior.value !== liveUpload.value);
      if (identityChanged || artifactChanged) invalidateConfirmedUpload('identity-change');
      const currentPrior = identityChanged || artifactChanged ? null : prior;
      const sameUpload = !!prior
        && prior.key === liveUpload.key
        && prior.value === liveUpload.value
        && (!prior.personalizationId || !personalizationId || prior.personalizationId === personalizationId);
      const convergedReady = options.ready === true
        || (!identityChanged && !artifactChanged && (state.imagePreviewReady === true || (sameUpload && prior.convergedReady === true)));
      state.confirmedUpload = {
        key: liveUpload.key,
        value: liveUpload.value,
        method: uploadPropertyImageMethod(liveUpload.key),
        personalizationId: personalizationId || currentPrior?.personalizationId || '',
        epoch: state.uploadEpoch,
        convergedReady,
        ready: convergedReady,
        at: Date.now()
      };
      stampConfirmedUploadRecord();
      return state.confirmedUpload;
    }
    if (options.ready === true
      && state.confirmedUpload?.epoch === state.uploadEpoch
      && uploadRecordMatchesImageMethod(state.confirmedUpload, selectedMethod)) {
      state.confirmedUpload.convergedReady = true;
      state.confirmedUpload.ready = true;
      state.confirmedUpload.at = Date.now();
      stampConfirmedUploadRecord();
      return state.confirmedUpload;
    }
    if (options.ready === true && hasFileAttached()) {
      state.confirmedUpload = {
        key: 'runtime-attachment',
        value: 'verified-convergence',
        method: selectedMethod,
        personalizationId,
        epoch: state.uploadEpoch,
        convergedReady: true,
        ready: true,
        at: Date.now()
      };
      stampConfirmedUploadRecord();
      return state.confirmedUpload;
    }
    // Customily removes and rebuilds its property controls during style changes.
    // Preserve only a previously verified upload while those controls are absent.
    return state.confirmedUpload?.epoch === state.uploadEpoch
      && state.confirmedUpload?.convergedReady === true
      && uploadRecordMatchesImageMethod(state.confirmedUpload, selectedMethod)
      ? state.confirmedUpload
      : null;
  }

  function hasDefiniteFileAttachment() {
    if (allFileInputs().some((input) => input.files && input.files.length > 0)) return true;
    const root = customilyRoot();
    if (!root) return false;
    if (visibleUploadedMeta(root)) return true;
    return qsa('input[name^="properties["]', root).some((input) => {
      if (input.type === 'file' || input.type === 'radio' || input.type === 'checkbox') return false;
      return /https?:|blob:|cdn\.|\.(png|jpe?g|webp|bmp|heic|dng|pdf|svg)(\?|$)/i.test(input.value || '');
    });
  }

  function hasFileAttached() {
    if (hasDefiniteFileAttachment()) return true;
    const thumbnail = uploadedPreviewImage();
    if (thumbnail?.complete && thumbnail.naturalWidth > 0) return true;
    return hasUploadedControlState();
  }

  function syncImagePreviewMemory() {
    // File presence is not render completion. Preserve a previously verified
    // contract-backed upload across Customily/Vue style-control remounts.
    if (!hasFileAttached() && !confirmedUploadRecord()) state.imagePreviewReady = false;
  }

  function hasImagePreviewReady() {
    if (uploadAssociatedCustomilyError(visibleCustomilyError())) return false;
    const confirmed = confirmedUploadRecord();
    return (hasFileAttached() || !!confirmed) && (state.imagePreviewReady || confirmed?.ready === true);
  }

  function scheduleImagePreviewClear() {
    window.clearTimeout(state.imageClearTimer);
    state.imageClearTimer = window.setTimeout(() => {
      if (!hasFileAttached() && !confirmedUploadRecord()) state.imagePreviewReady = false;
      refreshSoon();
    }, 180);
  }

  function chosenStyle() { return checkedValue(STYLE_SELECTOR); }
  function chosenCustomizationMethod() { return checkedValue(CUSTOMIZATION_METHOD_SELECTOR); }
  function chosenImageMethod() { return checkedValue(IMAGE_METHOD_SELECTOR); }
  function selectedMonogram() { return checkedValue(MONOGRAM_SELECTOR); }
  function selectedFontStyle() { return checkedValue(FONT_STYLE_SELECTOR); }
  function isTeeAdapter() { return state?.adapter?.marker === FAMILY_TEES; }
  function isDirectDrinkwareAdapter() { return state?.adapter?.marker === FAMILY_DRINKWARE_DIRECT; }
  function isMethodGatedDrinkwareAdapter() { return state?.adapter?.marker === FAMILY_DRINKWARE_GATED; }
  function activeDesignColorInputs(scope = document) { return qsa(isTeeAdapter() ? TEE_DESIGN_COLOR_SELECTOR : DESIGN_COLOR_SELECTOR, scope); }
  function activeDesignColorGroup() {
    const groups = activeDesignColorInputs().map((input) => input.closest('.customily_option') || input.closest('[role="radiogroup"]') || input.parentElement).filter(Boolean);
    return groups.find((group) => visible(group)) || groups.find((group) => qsa('input[type="radio"]', group).some((input) => input.checked)) || groups[0] || null;
  }
  function selectedDesignColorInput() {
    const group = activeDesignColorGroup();
    const inputs = group ? activeDesignColorInputs(group) : activeDesignColorInputs();
    return inputs.find((input) => input.checked) || null;
  }
  function selectedDesignColor() { return norm(selectedDesignColorInput()?.value || ''); }
  function designColorRequirement() {
    if (isTeeAdapter() || state?.adapter?.marker === FAMILY_STANDARD) return 'required';
    const decorationMethod = authoritativeDecorationMethod(productContext.decorationMethod);
    if (isDirectDrinkwareAdapter()) {
      if (decorationMethod === DECORATION_LASER) return 'inapplicable';
      if (decorationMethod === DECORATION_FULL_COLOR_DIGITAL) return 'required';
      return 'unresolved';
    }
    if (isMethodGatedDrinkwareAdapter()) {
      if (decorationMethod !== DECORATION_MIXED) return 'unresolved';
      const selectedMethod = chosenCustomizationMethod();
      if (selectedMethod === 'Engraving') return 'inapplicable';
      if (selectedMethod === 'Full Color') return 'required';
      return 'unresolved';
    }
    return 'unresolved';
  }
  function hasVisibleDesignColorControl() {
    const group = activeDesignColorGroup();
    return !!group && visible(group);
  }
  function syncDesignColorCapabilityGuard(requirement = designColorRequirement()) {
    const shouldExclude = requirement !== 'required';
    const selector = `${isTeeAdapter() ? TEE_DESIGN_COLOR_SELECTOR : DESIGN_COLOR_SELECTOR}, input[type="radio"][data-gs-capability-name]`;
    qsa(selector).forEach((input) => {
      const guardedName = input.dataset.gsCapabilityName || '';
      if (shouldExclude) {
        const currentName = input.getAttribute('name') || '';
        if (!guardedName && currentName) input.dataset.gsCapabilityName = currentName;
        if (currentName) input.removeAttribute('name');
      } else if (guardedName) {
        input.setAttribute('name', guardedName);
        delete input.dataset.gsCapabilityName;
      }
    });
    return requirement;
  }
  function designColorComplete() {
    const requirement = syncDesignColorCapabilityGuard();
    if (requirement === 'required') return hasVisibleDesignColorControl() && !!selectedDesignColorInput() && !selectedDesignColorInput().disabled;
    if (requirement === 'inapplicable') return !hasVisibleDesignColorControl();
    return false;
  }
  function selectedDesignColorPropertyName() {
    const name = selectedDesignColorInput()?.name || '';
    const match = name.match(/^properties\[(.*)\]$/);
    return match ? match[1] : 'Design Color';
  }
  function visibleTextValue() {
    const field = textFields().find((candidate) => norm(candidate.value) && !PLACEHOLDER_RE.test(norm(candidate.value)));
    return norm(field?.value || '');
  }
  function selectedMonogramBranch() {
    const selected = lower(selectedMonogram());
    return MONOGRAM_BRANCHES.find((branch) => branch.styles.some((style) => lower(style) === selected)) || null;
  }
  function expectedMonogramInitialLength() {
    return selectedMonogramBranch()?.length || 3;
  }
  function activeMonogramInitialSelector() {
    return MONOGRAM_INITIAL_SELECTORS[expectedMonogramInitialLength()] || MONOGRAM_INITIAL_SELECTORS[3];
  }
  function activeMonogramInitialGroup() {
    const field = qs(activeMonogramInitialSelector());
    return field ? (field.closest('.customily_option') || field.parentElement) : null;
  }
  function monogramInitialFields() {
    const group = activeMonogramInitialGroup();
    return group ? qsa(activeMonogramInitialSelector(), group) : [];
  }
  function monogramInitialsValue() {
    const field = monogramInitialFields()[0];
    return norm(field?.value || '');
  }
  function hasValidMonogramInitialsValue() {
    const value = monogramInitialsValue().toUpperCase();
    return !!value && value.length === expectedMonogramInitialLength();
  }
  function hasCommittedTextPreview() {
    return (isTeeAdapter() || chosenStyle() === 'Custom Text') && !!visibleTextValue();
  }
  function hasCommittedMonogramPreview() {
    return chosenStyle() === 'Monogram' && !!selectedMonogram() && designColorComplete() && hasValidMonogramInitialsValue();
  }
  function hasPreviewReadyContent() {
    const style = chosenStyle();
    if (style === 'Images') return hasImagePreviewReady();
    if (isTeeAdapter()) return hasCommittedTextPreview();
    if (style === 'Custom Text') return hasCommittedTextPreview();
    if (style === 'Monogram') return hasCommittedMonogramPreview();
    return false;
  }

  function hasFloatingPreviewReadyContent() {
    if (state.pendingNoUploadImagesSelection) return false;
    const style = chosenStyle();
    // Mobile shopper guidance: choosing Images should reveal the stable base
    // product preview before an upload exists. This only opens the presentation
    // gate; hasVisualPreviewSurface() still requires the current synchronized,
    // painted mirror, so a missing/blank/stale canvas continues to fail closed.
    // Upload readiness, image-editor access, validation, and cart semantics keep
    // using hasImagePreviewReady() and are intentionally unchanged.
    if (style === 'Images') return nativeEditorPopupMobileAllowed() ? true : hasImagePreviewReady();
    if (style === 'Custom Text') return true;
    if (style === 'Monogram') return !!selectedMonogram();
    if (isTeeAdapter()) return hasCommittedTextPreview();
    return false;
  }
  function hasPlaceholderText() {
    return textFields().some((field) => {
      const value = norm(field.value);
      return !value || PLACEHOLDER_RE.test(value);
    });
  }
  function hasPlaceholderInitials() {
    const fields = monogramInitialFields();
    if (!fields.length) return true;
    return fields.some((field) => {
      const value = norm(field.value).toUpperCase();
      return !value || value.length !== expectedMonogramInitialLength();
    });
  }
  function activeFontFamilyGroup() {
    if (isTeeAdapter()) return null;
    const root = customilyRoot();
    if (!root) return null;
    const selected = selectedFontStyle();
    const escaped = selected ? selected.replace(/["\\]/g, '\\$&') : '';
    const named = escaped ? qs(`input[type="radio"][name="properties[${escaped}]"]`, root) : null;
    if (named) return named.closest('.customily_option') || named.parentElement;
    return qsa('.customily_option', root).find((group) => {
      const cls = String(group.className || '');
      return /font-family/.test(cls) && !group.matches('.custom-font-style');
    }) || null;
  }
  function artworkConsent() {
    const box = qs(ARTWORK_CONSENT_SELECTOR);
    if (box && box.name !== ARTWORK_CONSENT_PRIVATE_NAME) {
      box.dataset.gsOriginalPropertyName = box.name || '';
      box.name = ARTWORK_CONSENT_PRIVATE_NAME;
    }
    return box;
  }
  function consentRequired() { return isGuided() && chosenStyle() === 'Images' && hasFileAttached() && !!artworkConsent(); }
  function consentChecked() {
    const box = artworkConsent();
    return box ? !!box.checked : true;
  }
  function finalConfirmBoxes() { return qsa(FINAL_CONFIRM_SELECTOR); }
  function finalConfirmBox() { return finalConfirmBoxes()[0] || null; }
  function markFinalConfirmReviewed() {
    finalConfirmBoxes().forEach((box) => {
      if (!box || box.checked) return;
      box.checked = true;
      box.dispatchEvent(new Event('input', { bubbles: true }));
      box.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  function checkAndDispatch(box) {
    if (!box) return;
    if (!box.checked) box.checked = true;
    box.dispatchEvent(new Event('input', { bubbles: true }));
    box.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function syncGatingCheckboxesForApproval() {
    // Approval-modal confirm syncs every gating checkbox that is present in the
    // DOM so the single delegated Customily cart-button click satisfies all of
    // them. Each is guarded for existence; none are created or removed here.
    // #agree_checkbox / .final_check_btn are handled by markFinalConfirmReviewed
    // (called before this), and the artwork-rights box by
    // syncHiddenArtworkConsentForApproval; this covers the final-confirm option
    // and #design-confirm-check only when they render at runtime.
    const designConfirm = qs(DESIGN_CONFIRM_SELECTOR);
    if (designConfirm) checkAndDispatch(designConfirm);
  }
  function syncFinalConfirmForProgressive() {
    if (isGuided() || !enhancementEnabled() || !validation().ok || !state.approvalSubmitting) return;
    markFinalConfirmReviewed();
  }
  function resetApprovalForCustomizationChange(target) {
    if (state.approvalSyncingHiddenConsent) return;
    if (!target || target.closest?.('.gs-approval-modal') || target.closest?.('.gs-approval-zoom')) return;
    if (!target.matches?.(`${STYLE_SELECTOR}, ${IMAGE_METHOD_SELECTOR}, ${FILE_SELECTOR}, ${TEXT_SELECTOR}, ${FONT_STYLE_SELECTOR}, ${DESIGN_COLOR_SELECTOR}, ${TEE_DESIGN_COLOR_SELECTOR}, ${MONOGRAM_SELECTOR}, ${MONOGRAM_INITIALS_SELECTOR}, ${ARTWORK_CONSENT_SELECTOR}`)) return;
    state.approvalSubmitting = false;
    state.approvalVisibleClickConsumed = false;
    state.approvalNativeClickConsumed = false;
    finalConfirmBoxes().forEach((box) => {
      if (!box?.checked) return;
      box.checked = false;
      box.dispatchEvent(new Event('input', { bubbles: true }));
      box.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const hiddenRights = artworkConsent();
    if (hiddenRights?.checked) {
      hiddenRights.checked = false;
      hiddenRights.dispatchEvent(new Event('input', { bubbles: true }));
      hiddenRights.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function previewCanvas() { return qsa(CANVAS_SELECTOR).find((el) => visible(el)) || qs(CANVAS_SELECTOR); }

  function stepNumber() {
    if (isTeeAdapter()) {
      if (hasPlaceholderText()) return 1;
      if (!selectedFontStyle() || !selectedDesignColor()) return 2;
      return 3;
    }
    const style = chosenStyle();
    if (!style) return 1;
    if (style === 'Images') {
      if (!chosenImageMethod() || !hasImagePreviewReady() || (consentRequired() && !consentChecked())) return 2;
      return 3;
    }
    if (style === 'Custom Text') return hasPlaceholderText() || !selectedFontStyle() || !designColorComplete() ? 2 : 3;
    if (style === 'Monogram') return !selectedMonogram() || hasPlaceholderInitials() || !designColorComplete() ? 2 : 3;
    return 2;
  }

  function validation() {
    const style = chosenStyle();
    const issues = [];
    if (!customilyRoot()) issues.push('Customily controls are not loaded yet.');
    if (visibleCustomilyError()) issues.push('Fix the highlighted personalization issue.');
    if (isTeeAdapter()) {
      if (hasPlaceholderText()) issues.push('Replace placeholder text with the real tee text.');
      if (!selectedFontStyle()) issues.push('Choose a font style.');
      if (!designColorComplete()) issues.push('Choose a design color.');
      return { ok: issues.length === 0, issues };
    }
    if (!style) issues.push('Choose a personalization path.');
    if (style === 'Images') {
      if (!chosenImageMethod()) issues.push('Choose Image, Background Remover, Facecut, or Logo.');
      const syncStatus = state.floatingPreviewConvergence?.status || 'idle';
      if (!hasFileAttached()) issues.push('Upload your artwork.');
      else if (!hasImagePreviewReady() && ['processing', 'settling'].includes(syncStatus)) issues.push('Wait for the preview to finish updating.');
      else if (!hasImagePreviewReady() && syncStatus === 'ambiguous') issues.push('The preview is taking longer than expected. Replace the image and try again.');
      else if (!hasImagePreviewReady() && syncStatus === 'error') issues.push('The preview could not be updated. Replace the image and try again.');
      else if (!hasImagePreviewReady()) issues.push('Wait for the preview to finish updating.');
      if (consentRequired() && !consentChecked()) issues.push('Confirm you have the right to use this artwork.');
    }
    if (style === 'Custom Text') {
      if (hasPlaceholderText()) issues.push('Replace placeholder text with the real message.');
      if (!selectedFontStyle()) issues.push('Choose a font style.');
      if (!designColorComplete()) issues.push(designColorRequirement() === 'unresolved' ? 'Choose a valid customization type.' : 'Choose a design color.');
    }
    if (style === 'Monogram') {
      if (!selectedMonogram()) issues.push('Choose a monogram style.');
      if (selectedMonogram() && hasPlaceholderInitials()) issues.push(`Enter your real ${expectedMonogramInitialLength()}-letter initials.`);
      if (selectedMonogram() && !designColorComplete()) issues.push(designColorRequirement() === 'unresolved' ? 'Choose a valid customization type.' : 'Choose a design color.');
    }
    return { ok: issues.length === 0, issues };
  }

  function validationNoticeMessage(result) {
    const issues = result?.issues || validation().issues || [];
    if (chosenStyle() === 'Images' && issues.some((issue) => /upload/i.test(issue))) {
      return 'Upload your image first so we can create the preview before adding to cart.';
    }
    return issues[0] || 'Finish the required personalization steps before adding to cart.';
  }

  function firstVisibleControl(selector, root = customilyRoot()) {
    return qsa(selector, root).find((control) => visible(control) || visible(labelFor(control)) || visible(cardFor(control))) || null;
  }

  function showProgressiveValidationNotice(result) {
    const message = validationNoticeMessage(result);
    let toast = qs('.gs-progressive-validation-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'gs-progressive-validation-toast';
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.hidden = false;
    toast.classList.remove('is-visible');
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.clearTimeout(state.validationNoticeTimer);
    state.validationNoticeTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 5200);

    const uploadGroup = qs('[data-gs-progressive-role="upload"]');
    if (chosenStyle() === 'Images' && uploadGroup && /upload/i.test(message)) {
      uploadGroup.dataset.gsUploadRequiredNotice = 'true';
      let inline = qs('.gs-progressive-upload-required-message', uploadGroup);
      if (!inline) {
        inline = document.createElement('div');
        inline.className = 'gs-progressive-upload-required-message';
        inline.setAttribute('role', 'alert');
        uploadGroup.appendChild(inline);
      }
      inline.textContent = 'Upload image first';
      window.clearTimeout(state.uploadRequiredTimer);
      state.uploadRequiredTimer = window.setTimeout(() => {
        if (uploadGroup.dataset.gsUploadRequiredNotice === 'true') delete uploadGroup.dataset.gsUploadRequiredNotice;
      }, 6500);
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char]));
  }

  // Provided-icon <img> markup with a one-shot onerror fallback: when the skin
  // remaps an icon (clubhouse gold) and that asset ever fails to load, degrade
  // to the original -Black.webp asset (always served) instead of a broken glyph.
  function shellIconImgHtml(iconImage) {
    const src = themeAssetUrl(skinIconImage(iconImage));
    const fallback = themeAssetUrl(iconImage);
    const onerror = src !== fallback
      ? ` onerror="if(!this.dataset.gsIconFellBack){this.dataset.gsIconFellBack='1';this.src='${escapeHtml(fallback)}';}"`
      : '';
    return `<img src="${escapeHtml(src)}" alt="" loading="eager" decoding="async"${onerror}>`;
  }

  // ---- Real-control adoption: keep Customily's Vue-owned option tree intact.
  // Do NOT move Customily radio/consent/text groups before dependent options render;
  // that breaks the upload branch. Only adopt the already-rendered genuine file
  // upload group into the shell so mobile Safari still clicks the real input.
  function groupOf(selector) {
    const input = qs(selector);
    return input ? (input.closest('.customily_option') || input.closest('[role="radiogroup"]') || input.parentElement) : null;
  }

  function adoptInto(host, node, marker) {
    if (!host || !node) return;
    if (node.dataset.gsGuidedSlot === marker && node.parentElement === host) return;
    node.dataset.gsGuidedSlot = marker;
    node.classList.add('gs-guided-real-slot');
    host.appendChild(node);
  }

  // Adopt only the live Customily upload group after it exists.
  function relocateRealGroups() {
    const fileInput = qs(FILE_SELECTOR);
    const uploadGroup = fileInput ? (fileInput.closest('.customily_option') || fileInput.parentElement) : null;
    if (uploadGroup && state.uploadHost) {
      adoptInto(state.uploadHost.querySelector('.gs-shell-upload__real'), uploadGroup, 'upload');
    }
  }

  function renderConsentProxy() {
    if (!state.consentHost) return;
    const box = artworkConsent();
    const show = consentRequired();
    state.consentHost.hidden = !show;
    if (!show) { state.consentHost.innerHTML = ''; return; }
    const checked = !!box.checked;
    state.consentHost.innerHTML = `
      <button type="button" class="gs-shell-consent${checked ? ' is-checked' : ''}" aria-pressed="${checked ? 'true' : 'false'}">
        <span class="gs-shell-consent__box">${checked ? '✓' : ''}</span>
        <span class="gs-shell-consent__text">I have the rights to use this artwork and approve it for printing.</span>
      </button>
    `;
    state.consentHost.querySelector('button').addEventListener('click', () => {
      box.checked = !box.checked;
      box.dispatchEvent(new Event('input', { bubbles: true }));
      box.dispatchEvent(new Event('change', { bubbles: true }));
      refreshSoon();
    });
  }

  // ---- Proxy chip rendering: read real radios, render shell chips that click them ----
  function renderPathCards() {
    if (!state.pathHost) return;
    const inputs = qsa(STYLE_SELECTOR);
    if (!inputs.length) { state.pathHost.innerHTML = '<p class="gs-shell-empty">Loading personalization options…</p>'; return; }
    const current = chosenStyle();
    state.pathHost.innerHTML = '';
    inputs
      .map((input) => ({ input, meta: STYLE_META[input.value] || { title: input.value, note: '', order: 9 } }))
      .sort((a, b) => (a.meta.order || 9) - (b.meta.order || 9))
      .forEach(({ input, meta }) => {
        const selected = lower(input.value) === lower(current);
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'gs-shell-path-card' + (meta.primary ? ' gs-shell-path-card--recommended' : '') + (meta.primary && selected ? ' gs-shell-path-card--primary' : '');
        card.classList.toggle('is-selected', selected);
        card.innerHTML =
          (meta.badge ? `<span class="gs-shell-path-card__badge">${escapeHtml(meta.badge)}</span>` : '') +
          (meta.iconImage ? `<span class="gs-shell-path-card__icon">${shellIconImgHtml(meta.iconImage)}</span>` : '') +
          `<span class="gs-shell-path-card__title">${escapeHtml(meta.title)}</span>` +
          `<span class="gs-shell-path-card__note">${escapeHtml(meta.note || '')}</span>`;
        card.addEventListener('click', () => { clickRealInput(input); });
        state.pathHost.appendChild(card);
      });
  }

  function renderMethodChips() {
    if (!state.methodChips) return;
    const inputs = qsa(IMAGE_METHOD_SELECTOR);
    const show = chosenStyle() === 'Images' && inputs.length > 0;
    state.methodHost.hidden = !show;
    if (!show) { state.methodChips.innerHTML = ''; return; }
    const current = chosenImageMethod();
    state.methodChips.innerHTML = '';
    inputs
      .map((input) => ({ input, meta: METHOD_META[input.value] || { title: input.value, order: 9 } }))
      .sort((a, b) => (a.meta.order || 9) - (b.meta.order || 9))
      .forEach(({ input, meta }) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'gs-shell-method-card';
        chip.classList.toggle('is-selected', lower(input.value) === lower(current));
        const iconHtml = meta.iconImage
          ? shellIconImgHtml(meta.iconImage)
          : escapeHtml(meta.icon || meta.title.charAt(0));
        chip.innerHTML = `
          <span class="gs-shell-method-card__icon">${iconHtml}</span>
          <span class="gs-shell-method-card__copy">
            <span class="gs-shell-method-card__title">${escapeHtml(meta.title)}</span>
            <span class="gs-shell-method-card__note">${escapeHtml(meta.note || '')}</span>
          </span>
        `;
        chip.addEventListener('click', () => { clickRealInput(input); });
        state.methodChips.appendChild(chip);
      });
  }

  function ensureImageMethodOrderStyles() {
    if (document.getElementById('gs-image-method-order-style')) return;
    const style = document.createElement('style');
    style.id = 'gs-image-method-order-style';
    style.textContent = `
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-image-method-order="1"] { order: 1 !important; }
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-image-method-order="2"] { order: 2 !important; }
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-image-method-order="3"] { order: 3 !important; }
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-image-method-order="4"] { order: 4 !important; }
    `;
    document.head.appendChild(style);
  }

  function ensureCompactChoiceGridStyles() {
    if (document.getElementById('gs-compact-choice-grid-style')) return;
    const style = document.createElement('style');
    style.id = 'gs-compact-choice-grid-style';
    style.textContent = `
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="font-family"] .swatch-container,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="font-family"] [role="radiogroup"],
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="monogram"] .swatch-container,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="monogram"] [role="radiogroup"] {
        display: grid !important;
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
        gap: 10px !important; /* ISSUE 2c -- match font-family group gap (font-family already 10px) */
        align-items: stretch !important;
      }
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-compact-choice-hidden="true"] {
        display: none !important;
      }
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="font-family"] .customily-swatch.swatch label,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="monogram"] .customily-swatch.swatch label {
        min-height: 62px !important;
        height: 62px !important;
        padding: 6px !important;
        border-radius: 14px !important;
      }
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="monogram"] .customily-swatch.swatch label {
        min-height: 74px !important;
        height: 74px !important;
      }
    `;
    document.head.appendChild(style);
  }

  function ensureSingleSelectionBadgeStyles() {
    // Served QA caught duplicate checks: the theme/Customily layer injects an outer
    // .customily-swatch::after badge after the CSS asset loads, while the premium
    // pass intentionally draws the badge on label::after. Re-append this runtime
    // guard after Customily refreshes so the approved label badge is the only one.
    document.getElementById('gs-single-selection-badge-style')?.remove();
    const style = document.createElement('style');
    style.id = 'gs-single-selection-badge-style';
    style.textContent = `
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="style"].customily_option.custom-swatch1 .swatch-container .customily-swatch.swatch:has(input:checked)::after,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="font-style"] .customily-swatch.swatch:has(input:checked)::after,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="font-family"] .customily-swatch.swatch:has(input:checked)::after,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root [data-gs-progressive-role="monogram"] .customily-swatch.swatch:has(input:checked)::after,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root .custom-font-style .customily-swatch.swatch:has(input:checked)::after,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root .custom-font-family-box .customily-swatch.swatch:has(input:checked)::after,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root .sports-font-family .customily-swatch.swatch:has(input:checked)::after,
      html.gs-customily-progressive-enabled #cl_optionsapp.gs-progressive-customily-root .monogram-style .customily-swatch.swatch:has(input:checked)::after {
        content: none !important;
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  function ensurePreviewSurfaceStyles() {
    // Emergency rollback 2026-06-25: the injected preview/zoom control layer broke
    // native Customily popup interactions and could leave the PDP scroll locked.
    // Keep preview positioning in the scoped CSS only until this surface is rebuilt
    // with real interaction tests.
    document.getElementById('gs-preview-surface-fixes-style')?.remove();
    return;
    const style = document.createElement('style');
    style.id = 'gs-preview-surface-fixes-style';
    style.textContent = `
      html.gs-customily-progressive-enabled #preview-main-popup::before,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"] #preview-main-popup::before,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"] body #preview-main-popup#preview-main-popup::before {
        top: 10px !important;
        left: 12px !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        color: var(--gs-ink, #151515) !important;
        font-size: 10px !important;
        font-weight: 950 !important;
        line-height: 1 !important;
        letter-spacing: 0.08em !important;
        pointer-events: none !important;
      }
      html.gs-customily-progressive-enabled #preview-main-popup .gs-floating-preview__minimize {
        position: absolute !important;
        z-index: 5 !important;
        top: 7px !important;
        right: 8px !important;
        width: 28px !important;
        height: 28px !important;
        min-width: 28px !important;
        min-height: 28px !important;
        padding: 0 !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        border: 1px solid rgba(21, 21, 21, 0.12) !important;
        border-radius: 999px !important;
        background: rgba(255, 255, 255, 0.92) !important;
        color: #151515 !important;
        box-shadow: 0 8px 18px rgba(20, 17, 11, 0.14) !important;
        font: 950 18px/1 var(--gs-font, Poppins, sans-serif) !important;
        cursor: pointer !important;
      }
      html.gs-customily-progressive-enabled #preview-canvas-popup2 .canvas-expand-label,
      html.gs-customily-progressive-enabled #preview-main-popup #preview-canvas-popup2 .canvas-expand-label {
        left: 14px !important;
        right: 14px !important;
        bottom: 10px !important;
        top: auto !important;
        width: auto !important;
        min-width: 0 !important;
        min-height: 30px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 8px 12px !important;
        border: 0 !important;
        border-radius: 999px !important;
        background: #151515 !important;
        color: #fff !important;
        box-shadow: 0 10px 24px rgba(20, 17, 11, 0.24) !important;
        font: 950 10px/1 var(--gs-font, Poppins, sans-serif) !important;
        letter-spacing: 0.01em !important;
        text-transform: none !important;
        white-space: nowrap !important;
      }
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"]:not([data-gs-progressive-floating-preview-minimized="true"]) #preview-main-popup,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"]:not([data-gs-progressive-floating-preview-minimized="true"]) #preview-canvas-popup2,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"]:not([data-gs-progressive-floating-preview-minimized="true"]) #preview-canvas-popup2 #cloned-canvas2 {
        display: block !important;
        visibility: visible !important;
        opacity: 1 !important;
        transform: none !important;
      }
      html.gs-customily-progressive-enabled[data-gs-progressive-floating-preview-minimized="true"] #preview-main-popup,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"][data-gs-progressive-floating-preview-minimized="true"] #preview-main-popup {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
        transform: translateY(8px) scale(0.94) !important;
      }
      html.gs-customily-progressive-enabled[data-gs-progressive-floating-preview-minimized="true"] #preview-main-popup::before,
      html.gs-customily-progressive-enabled[data-gs-progressive-floating-preview-minimized="true"] #preview-main-popup::after,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"][data-gs-progressive-floating-preview-minimized="true"] #preview-main-popup::before,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"][data-gs-progressive-floating-preview-minimized="true"] #preview-main-popup::after,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"][data-gs-progressive-floating-preview-minimized="true"] body #preview-main-popup#preview-main-popup::before,
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"][data-gs-progressive-floating-preview-minimized="true"] body #preview-main-popup#preview-main-popup::after {
        content: none !important;
        display: none !important;
      }
      .gs-floating-preview-restore {
        position: fixed !important;
        z-index: 99999 !important;
        left: max(12px, env(safe-area-inset-left)) !important;
        bottom: calc(var(--gs-shopify-preview-bar-offset, 0px) + env(safe-area-inset-bottom)) !important;
        width: auto !important;
        min-width: 84px !important;
        height: 38px !important;
        min-height: 38px !important;
        padding: 0 16px !important;
        display: none !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 0 !important;
        border: 1px solid rgba(255, 255, 255, 0.32) !important;
        border-radius: 999px !important;
        background: #151515 !important;
        color: #fff !important;
        box-shadow: 0 14px 34px rgba(20, 17, 11, 0.28) !important;
        font: 950 10px/1 var(--gs-font, Poppins, sans-serif) !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        cursor: pointer !important;
      }
      .gs-floating-preview-restore svg {
        width: 23px !important;
        height: 23px !important;
        display: block !important;
        flex: 0 0 auto !important;
      }
      .gs-floating-preview-restore__text {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        overflow: hidden !important;
        clip: rect(0 0 0 0) !important;
        white-space: nowrap !important;
      }
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"][data-gs-progressive-floating-preview-minimized="true"] .gs-floating-preview-restore {
        display: inline-flex !important;
      }
      html.gs-customily-progressive-enabled[data-gs-progressive-preview-ready="true"][data-gs-progressive-customizer-active="true"][data-gs-progressive-floating-preview-minimized="true"][data-gs-progressive-cart-drawer-open="true"] .gs-floating-preview-restore {
        display: none !important;
        pointer-events: none !important;
      }
      html.gs-customily-progressive-enabled .main-product__media.popup-active .main-product__media--features,
      html.gs-customily-progressive-enabled .main-product__media.popup-active product-media-info,
      html.gs-customily-progressive-enabled .main-product__media.popup-active .product__media--info,
      html.gs-customily-progressive-enabled .main-product__media.popup-active .product-card__badges,
      html.gs-customily-progressive-enabled .main-product__media.popup-active .product-card__badge,
      html.gs-customily-progressive-enabled .main-product__media.popup-active .badge,
      html.gs-customily-progressive-enabled .main-product__media.popup-active [class*="badge"] {
        display: none !important;
        visibility: hidden !important;
      }
      html.gs-customily-progressive-enabled .main-product__media.popup-active .customily-close-button,
      html.gs-customily-progressive-enabled #canvas-popup-wrapper button {
        background: #151515 !important;
        color: #fff !important;
        border: 0 !important;
        border-radius: 999px !important;
        box-shadow: 0 12px 28px rgba(20, 17, 11, 0.24) !important;
      }
      html.gs-customily-progressive-enabled .main-product__media.popup-active .gs-popup-zoom-toggle {
        position: absolute !important;
        z-index: 12 !important;
        left: 12px !important;
        top: 12px !important;
        min-height: 34px !important;
        padding: 9px 13px !important;
        border: 0 !important;
        border-radius: 999px !important;
        background: #151515 !important;
        color: #fff !important;
        box-shadow: 0 12px 28px rgba(20, 17, 11, 0.22) !important;
        font: 950 12px/1 var(--gs-font, Poppins, sans-serif) !important;
        cursor: pointer !important;
      }
      html.gs-customily-progressive-enabled .main-product__media.popup-active.gs-popup-zoomed {
        overflow: hidden !important;
      }
      html.gs-customily-progressive-enabled .main-product__media.popup-active.gs-popup-zoomed img,
      html.gs-customily-progressive-enabled .main-product__media.popup-active.gs-popup-zoomed canvas,
      html.gs-customily-progressive-enabled .main-product__media.popup-active.gs-popup-zoomed #popup-canvas {
        transform: scale(2.15) !important;
        transform-origin: var(--gs-popup-zoom-origin-x, 50%) var(--gs-popup-zoom-origin-y, 50%) !important;
        transition: transform 120ms ease !important;
        cursor: zoom-out !important;
      }
    `;
    document.head.appendChild(style);
  }

  function setFloatingPreviewMinimized(minimized) {
    state.floatingPreviewMinimized = !!minimized;
    if (state.floatingPreviewMinimized) setFloatingPreviewViewState('collapsed');
    document.documentElement.dataset.gsProgressiveFloatingPreviewMinimized = state.floatingPreviewMinimized ? 'true' : 'false';
  }

  const FLOATING_PREVIEW_VIEW_STATES = new Set(['collapsed', 'fit', 'detail', 'panning']);

  function clearFloatingPreviewCompatibilityClickSuppression() {
    if (state.floatingPreviewSuppressClickTimer) window.clearTimeout(state.floatingPreviewSuppressClickTimer);
    state.floatingPreviewSuppressClickTimer = 0;
    state.floatingPreviewSuppressClick = false;
    state.floatingPreviewSuppressClickPoint = null;
  }

  function armFloatingPreviewCompatibilityClickSuppression(event) {
    if (state.floatingPreviewSuppressClickTimer) window.clearTimeout(state.floatingPreviewSuppressClickTimer);
    state.floatingPreviewSuppressClick = true;
    state.floatingPreviewSuppressClickPoint = {
      x: Number(event?.clientX || 0),
      y: Number(event?.clientY || 0)
    };
    state.floatingPreviewSuppressClickTimer = window.setTimeout(() => {
      state.floatingPreviewSuppressClickTimer = 0;
      state.floatingPreviewSuppressClick = false;
      state.floatingPreviewSuppressClickPoint = null;
    }, 700);
  }

  function resetFloatingPreviewPointer() {
    const holder = state.floatingPreviewInteractionOwner?.holder;
    for (const pointerId of state.floatingPreviewPointers.keys()) {
      try { if (holder?.hasPointerCapture?.(pointerId)) holder.releasePointerCapture(pointerId); } catch (_) {}
    }
    if (state.floatingPreviewTransformFrame) window.cancelAnimationFrame(state.floatingPreviewTransformFrame);
    if (state.floatingPreviewAnnouncementTimer) window.clearTimeout(state.floatingPreviewAnnouncementTimer);
    state.floatingPreviewTransformFrame = 0;
    state.floatingPreviewAnnouncementTimer = 0;
    state.floatingPreviewPointer = null;
    state.floatingPreviewPointers.clear();
    state.floatingPreviewDragStart = null;
    state.floatingPreviewPinchStart = null;
    state.floatingPreviewDragging = false;
    state.floatingPreviewGestureHadMultiTouch = false;
  }

  function syncFloatingPreviewMinimizeControl(preview = qs('#preview-main-popup')) {
    const button = preview ? qs('.gs-floating-preview__minimize', preview) : null;
    if (!button) return;
    const expanded = state.floatingPreviewViewState !== 'collapsed';
    const action = expanded ? 'collapse' : 'hide';
    const label = expanded ? 'Minimize expanded preview' : 'Hide preview';
    if (button.dataset.gsFloatingPreviewAction !== action) {
      button.dataset.gsFloatingPreviewAction = action;
      button.innerHTML = expanded
        ? '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="m5.5 8.5 6.5 6.5 6.5-6.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<span aria-hidden="true">×</span>';
    }
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
  }

  function setFloatingPreviewViewState(next, options = {}) {
    if (!FLOATING_PREVIEW_VIEW_STATES.has(next)) return false;
    const previous = state.floatingPreviewViewState || 'collapsed';
    if (next === 'panning' && previous !== 'detail') return false;
    const cleanSameState = previous === next
      && (next === 'collapsed' || next === 'fit')
      && state.floatingPreviewZoomScale === 1
      && state.floatingPreviewZoomX === 0
      && state.floatingPreviewZoomY === 0
      && state.floatingPreviewPointers.size === 0;
    state.floatingPreviewViewState = next;
    state.floatingPreviewExpanded = next !== 'collapsed';
    document.documentElement.dataset.gsProgressiveFloatingPreviewExpanded = state.floatingPreviewExpanded ? 'true' : 'false';
    document.documentElement.dataset.gsProgressiveFloatingPreviewViewState = next;
    const preview = qs('#preview-main-popup');
    const holder = preview ? qs('#preview-canvas-popup2', preview) : null;
    if (next === 'collapsed' || next === 'fit') {
      if (next === 'collapsed') clearFloatingPreviewCompatibilityClickSuppression();
      if (!cleanSameState) resetFloatingPreviewZoom({ preserveExpandedState: next === 'fit' });
    } else if (holder) {
      holder.style.setProperty('touch-action', 'none', 'important');
      holder.style.setProperty('overscroll-behavior', 'none', 'important');
    }
    if (options.reason) document.documentElement.dataset.gsProgressiveFloatingPreviewTransitionReason = options.reason;
    syncFloatingPreviewExpandText(preview);
    syncFloatingPreviewMinimizeControl(preview);
    return previous !== next;
  }

  function setFloatingPreviewExpanded(expanded) {
    return setFloatingPreviewViewState(expanded ? 'fit' : 'collapsed', { reason: expanded ? 'expand' : 'collapse' });
  }

  function floatingPreviewZoomScale(preview = qs('#preview-main-popup')) {
    const holder = preview ? qs('#preview-canvas-popup2', preview) : null;
    const nativeReady = holder?.dataset?.gsFloatingNativeZoomSource === 'true';
    const media = holder
      ? (nativeReady ? qs('.gs-floating-preview__native-zoom-source', holder) : qs('.gs-floating-preview__canvas-mirror, #cloned-canvas2, canvas, img', holder))
      : null;
    const rect = (holder || preview)?.getBoundingClientRect?.();
    const usingNativeSource = nativeReady && !!media?.classList?.contains('gs-floating-preview__native-zoom-source');
    const intrinsicW = usingNativeSource
      ? (parseFloat(holder?.dataset?.gsFloatingNativeZoomWidth || '') || media.naturalWidth || media.width || 0)
      : (media?.tagName === 'CANVAS' ? media.width : (media?.naturalWidth || media?.width || 0));
    const intrinsicH = usingNativeSource
      ? (parseFloat(holder?.dataset?.gsFloatingNativeZoomHeight || '') || media.naturalHeight || media.height || 0)
      : (media?.tagName === 'CANVAS' ? media.height : (media?.naturalHeight || media?.height || 0));
    const displayW = rect?.width || 1;
    const displayH = rect?.height || displayW;
    const pixelRatioCap = Math.min(intrinsicW / displayW || 1.35, intrinsicH / displayH || 1.35) * 0.88;
    const style = chosenStyle();
    const styleCap = style === 'Images' ? 1.95 : (usingNativeSource ? 2.42 : 1.62);
    return clamp(Number.isFinite(pixelRatioCap) ? pixelRatioCap : 1.35, 1.18, styleCap);
  }

  function cssUrlValue(value) {
    const match = String(value || '').match(/url\(["']?([^"')]+)["']?\)/i);
    return match ? match[1] : '';
  }

  function customilyNativeZoomSource() {
    const base = qsa('.customily-zoom-base-image')
      .find((img) => (img.currentSrc || img.src) && (img.naturalWidth || img.width));
    if (base) {
      return {
        src: base.currentSrc || base.src,
        width: base.naturalWidth || base.width || 0,
        height: base.naturalHeight || base.height || 0
      };
    }
    const zoomed = qsa('.customily-image-zoom__zoomed-image').find((node) => cssUrlValue(getComputedStyle(node).backgroundImage));
    if (zoomed) {
      const style = getComputedStyle(zoomed);
      const size = String(style.backgroundSize || '').split(/\s+/).map((part) => parseFloat(part));
      return {
        src: cssUrlValue(style.backgroundImage),
        width: Number.isFinite(size[0]) ? size[0] : 0,
        height: Number.isFinite(size[1]) ? size[1] : (Number.isFinite(size[0]) ? size[0] : 0)
      };
    }
    return null;
  }


  function floatingPreviewNativeZoomEligible() {
    const style = chosenStyle();
    return style !== 'Images' && !imageAdjustFlowActive();
  }

  function floatingPreviewMediaLayer(holder = qs('#preview-canvas-popup2')) {
    if (!holder) return null;
    let layer = qs('.gs-floating-preview__media-layer', holder);
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'gs-floating-preview__media-layer';
      holder.appendChild(layer);
    }
    return layer;
  }

  function syncFloatingPreviewNativeZoomImage(holder = qs('#preview-canvas-popup2')) {
    if (!holder || isGuided()) return;
    let img = qs('img.gs-floating-preview__native-zoom-source', holder);
    if (!floatingPreviewNativeZoomEligible()) {
      if (img) img.hidden = true;
      if (holder.dataset.gsFloatingNativeZoomSource) delete holder.dataset.gsFloatingNativeZoomSource;
      return;
    }
    const source = customilyNativeZoomSource();
    if (!source?.src) {
      if (img) img.hidden = true;
      if (holder.dataset.gsFloatingNativeZoomSource) delete holder.dataset.gsFloatingNativeZoomSource;
      return;
    }
    if (!img) {
      img = document.createElement('img');
      img.className = 'gs-floating-preview__native-zoom-source';
      img.alt = '';
      img.decoding = 'async';
      img.draggable = false;
    }
    const layer = floatingPreviewMediaLayer(holder);
    if (layer && img.parentElement !== layer) layer.appendChild(img);
    if (img.src !== source.src) img.src = source.src;
    img.hidden = false;
    holder.dataset.gsFloatingNativeZoomSource = 'true';
    holder.dataset.gsFloatingNativeZoomWidth = String(source.width || img.naturalWidth || 0);
    holder.dataset.gsFloatingNativeZoomHeight = String(source.height || img.naturalHeight || 0);
  }

  function authoritativeFloatingPreviewCanvas() {
    const nativeSurfaceForMirror = imageAdjustFlowActive() ? nativeEditorSurface() : null;
    return nativeSurfaceForMirror?.previewCanvas
      || qs('#preview-canvas.lower-canvas')
      || qsa('canvas.lower-canvas').find((node) => node.width && node.height)
      || qs('#preview-canvas');
  }

  function sampledCanvasFingerprint(canvas, size = 64) {
    if (!canvas || canvas.tagName !== 'CANVAS' || !canvas.width || !canvas.height) return { status: 'missing' };
    try {
      const sample = document.createElement('canvas');
      sample.width = size;
      sample.height = size;
      const context = sample.getContext('2d', { willReadFrequently: true });
      context.drawImage(canvas, 0, 0, size, size);
      const bytes = context.getImageData(0, 0, size, size).data;
      let hash = 2166136261;
      let paintedPixels = 0;
      for (let index = 0; index < bytes.length; index += 1) {
        hash ^= bytes[index];
        hash = Math.imul(hash, 16777619);
        if (index % 4 === 3 && bytes[index] > 0) paintedPixels += 1;
      }
      return { status: 'readable', width: canvas.width, height: canvas.height, paintedPixels, hash: (hash >>> 0).toString(16).padStart(8, '0') };
    } catch (error) {
      return { status: error?.name === 'SecurityError' ? 'tainted' : 'error', width: canvas.width, height: canvas.height, error: String(error) };
    }
  }

  function sameCanvasFingerprint(left, right) {
    return left?.status === 'readable' && right?.status === 'readable'
      && left.paintedPixels > 0 && right.paintedPixels > 0
      && left.width === right.width && left.height === right.height && left.hash === right.hash;
  }

  function captureFloatingPreviewDifferenceBaseline(size = 96) {
    const source = authoritativeFloatingPreviewCanvas();
    if (!source || source.tagName !== 'CANVAS' || !source.width || !source.height) return null;
    try {
      const sample = document.createElement('canvas');
      sample.width = size;
      sample.height = size;
      sample.getContext('2d', { willReadFrequently: true }).drawImage(source, 0, 0, size, size);
      return sample;
    } catch (_) {
      return null;
    }
  }

  function trustedFabricCanvasFor(source) {
    if (!source) return null;
    const direct = [source.__canvas, source.fabric, source._fabric, source.parentElement?.__canvas, source.parentElement?._canvas];
    const matches = (candidate) => {
      try {
        if (!candidate || typeof candidate.getObjects !== 'function') return false;
        return candidate.lowerCanvasEl === source
          || candidate._lowerCanvasEl === source
          || candidate.getElement?.() === source;
      } catch (_) {
        return false;
      }
    };
    const found = direct.find(matches);
    if (found) return found;
    const seen = new Set();
    const queue = [window.customily, window.customilyShopify, window.fabric].filter(Boolean).map((value) => ({ value, depth: 0 }));
    while (queue.length) {
      const { value, depth } = queue.shift();
      if (!value || (typeof value !== 'object' && typeof value !== 'function') || seen.has(value)) continue;
      seen.add(value);
      if (matches(value)) return value;
      if (depth >= 2) continue;
      let keys = [];
      try { keys = Object.keys(value).slice(0, 120); } catch (_) {}
      keys.forEach((key) => {
        let child;
        try { child = value[key]; } catch (_) { return; }
        if (child && (typeof child === 'object' || typeof child === 'function') && !(child instanceof Node)) queue.push({ value: child, depth: depth + 1 });
      });
    }
    return null;
  }

  function fabricPersonalizationFrame(preview, source) {
    const canvas = trustedFabricCanvasFor(source);
    if (!canvas) return null;
    let objects = [];
    try { objects = canvas.getObjects(); } catch (_) { return null; }
    const canvasWidth = Number(canvas.getWidth?.() || source.width || 0);
    const canvasHeight = Number(canvas.getHeight?.() || source.height || 0);
    if (!canvasWidth || !canvasHeight) return null;
    const bounds = objects.flatMap((object) => {
      if (!object || object.visible === false || Number(object.opacity ?? 1) <= 0) return [];
      const personalizationMarked = object.selectable === true || object.evented === true
        || object.customilyLayerId || object.layerId || object.customilyId || /text|monogram|upload|design|personal/i.test(String(object.name || object.id || ''));
      if (!personalizationMarked) return [];
      try {
        const rect = object.getBoundingRect?.(true, true) || object.getBoundingRect?.();
        if (!rect || !Number.isFinite(rect.left) || !Number.isFinite(rect.top) || rect.width <= 0 || rect.height <= 0) return [];
        if (rect.width * rect.height > canvasWidth * canvasHeight * 0.82) return [];
        return [rect];
      } catch (_) {
        return [];
      }
    });
    if (!bounds.length) return null;
    const left = Math.min(...bounds.map((rect) => rect.left));
    const top = Math.min(...bounds.map((rect) => rect.top));
    const right = Math.max(...bounds.map((rect) => rect.left + rect.width));
    const bottom = Math.max(...bounds.map((rect) => rect.top + rect.height));
    const width = right - left;
    const height = bottom - top;
    const pixelCap = floatingPreviewZoomScale(preview);
    return {
      x: clamp(((left + right) / 2 / canvasWidth) * 100, 6, 94),
      y: clamp(((top + bottom) / 2 / canvasHeight) * 100, 6, 94),
      scale: clamp(Math.min((canvasWidth * 0.72) / width, (canvasHeight * 0.72) / height), 1.18, Math.max(1.18, pixelCap)),
      source: 'trusted-fabric-object-bounds'
    };
  }

  function personalizationDifferenceFrame(preview = qs('#preview-main-popup')) {
    const source = authoritativeFloatingPreviewCanvas();
    const fabricFrame = fabricPersonalizationFrame(preview, source);
    if (fabricFrame) return fabricFrame;
    const base = qsa('.customily-zoom-base-image').find((img) => img.complete && (img.naturalWidth || img.width));
    const fallback = { x: 50, y: 50, scale: floatingPreviewZoomScale(preview), source: 'deterministic-center-fallback' };
    const baseline = base || state.floatingPreviewBaselineSample;
    if (!source || !baseline) return fallback;
    try {
      const size = 96;
      const sourceSample = document.createElement('canvas');
      const baseSample = document.createElement('canvas');
      sourceSample.width = baseSample.width = size;
      sourceSample.height = baseSample.height = size;
      const sourceContext = sourceSample.getContext('2d', { willReadFrequently: true });
      const baseContext = baseSample.getContext('2d', { willReadFrequently: true });
      sourceContext.drawImage(source, 0, 0, size, size);
      baseContext.drawImage(baseline, 0, 0, size, size);
      const sourceBytes = sourceContext.getImageData(0, 0, size, size).data;
      const baseBytes = baseContext.getImageData(0, 0, size, size).data;
      let minX = size, minY = size, maxX = -1, maxY = -1, changed = 0;
      for (let y = 0; y < size; y += 1) {
        for (let x = 0; x < size; x += 1) {
          const index = (y * size + x) * 4;
          const delta = Math.abs(sourceBytes[index] - baseBytes[index])
            + Math.abs(sourceBytes[index + 1] - baseBytes[index + 1])
            + Math.abs(sourceBytes[index + 2] - baseBytes[index + 2]);
          if (delta < 72) continue;
          changed += 1;
          minX = Math.min(minX, x); minY = Math.min(minY, y);
          maxX = Math.max(maxX, x); maxY = Math.max(maxY, y);
        }
      }
      if (changed < 12 || maxX <= minX || maxY <= minY) return fallback;
      const width = maxX - minX + 1;
      const height = maxY - minY + 1;
      const pixelCap = floatingPreviewZoomScale(preview);
      return {
        x: clamp(((minX + maxX + 1) / 2 / size) * 100, 6, 94),
        y: clamp(((minY + maxY + 1) / 2 / size) * 100, 6, 94),
        scale: clamp(Math.min((size * 0.72) / width, (size * 0.72) / height), 1.18, Math.max(1.18, pixelCap)),
        source: base ? 'personalization-image-difference' : 'generation-baseline-difference'
      };
    } catch (_) {
      return fallback;
    }
  }

  function floatingPreviewStagePoint(clientX, clientY) {
    const holder = state.floatingPreviewInteractionOwner?.holder || qs('#preview-main-popup #preview-canvas-popup2');
    const rect = holder?.getBoundingClientRect?.();
    if (!rect) return { x: 0, y: 0 };
    return { x: clientX - rect.left - rect.width / 2, y: clientY - rect.top - rect.height / 2 };
  }

  function clampFloatingPreviewTranslation() {
    const holder = state.floatingPreviewInteractionOwner?.holder || qs('#preview-main-popup #preview-canvas-popup2');
    if (!holder) return;
    const maxX = Math.max(0, holder.clientWidth * (state.floatingPreviewZoomScale - 1) / 2);
    const maxY = Math.max(0, holder.clientHeight * (state.floatingPreviewZoomScale - 1) / 2);
    state.floatingPreviewZoomX = clamp(state.floatingPreviewZoomX || 0, -maxX, maxX);
    state.floatingPreviewZoomY = clamp(state.floatingPreviewZoomY || 0, -maxY, maxY);
    if (state.floatingPreviewZoomScale === 1) {
      state.floatingPreviewZoomX = 0;
      state.floatingPreviewZoomY = 0;
    }
  }

  function scheduleFloatingPreviewZoomAnnouncement(percent) {
    const announcement = qs('[data-gs-floating-zoom-announcement]');
    if (!announcement || announcement.textContent === `Zoom ${percent} percent` || state.floatingPreviewAnnouncementPendingPercent === percent) return;
    state.floatingPreviewAnnouncementPendingPercent = percent;
    window.clearTimeout(state.floatingPreviewAnnouncementTimer);
    state.floatingPreviewAnnouncementTimer = window.setTimeout(() => {
      state.floatingPreviewAnnouncementTimer = 0;
      state.floatingPreviewAnnouncementPendingPercent = null;
      announcement.textContent = `Zoom ${percent} percent`;
    }, 300);
  }

  function applyFloatingPreviewZoomTransform() {
    const preview = qs('#preview-main-popup');
    const holder = preview ? qs('#preview-canvas-popup2', preview) : null;
    const layer = holder ? qs('.gs-floating-preview__media-layer', holder) : null;
    state.floatingPreviewZoomScale = clamp(state.floatingPreviewZoomScale || 1, 1, 2);
    clampFloatingPreviewTranslation();
    if (layer) setStyleIfChanged(layer, 'transform', `translate3d(${state.floatingPreviewZoomX}px, ${state.floatingPreviewZoomY}px, 0) scale(${state.floatingPreviewZoomScale})`);
    const percent = Math.round(state.floatingPreviewZoomScale * 100);
    const zoomed = state.floatingPreviewZoomScale > 1;
    const priorZoomed = holder?.dataset.zoomed || '';
    if (state.floatingPreviewExpanded) {
      state.floatingPreviewViewState = zoomed ? 'detail' : 'fit';
      setDatasetIfChanged(document.documentElement, 'gsProgressiveFloatingPreviewViewState', state.floatingPreviewViewState);
    }
    setDatasetIfChanged(document.documentElement, 'gsProgressiveFloatingPreviewZoomed', zoomed ? 'true' : 'false');
    if (holder) {
      setDatasetIfChanged(holder, 'zoomed', zoomed ? 'true' : 'false');
      setDatasetIfChanged(holder, 'panning', state.floatingPreviewDragging ? 'true' : 'false');
      setDatasetIfChanged(holder, 'pinching', state.floatingPreviewPinchStart ? 'true' : 'false');
      setDatasetIfChanged(holder, 'zoomPercent', String(percent));
      setStyleIfChanged(holder, 'touch-action', state.floatingPreviewExpanded ? 'none' : 'manipulation');
      setStyleIfChanged(holder, 'overscroll-behavior', state.floatingPreviewExpanded ? 'none' : 'contain');
      setAttrIfChanged(holder, 'aria-label', zoomed
        ? `Expanded preview at ${percent} percent. Move the image with a pointer, touch, or the arrow keys; use the zoom controls or keyboard shortcuts to change zoom.`
        : 'Expanded preview at fit. Tap the image, use the zoom controls, or use keyboard shortcuts to zoom.');
    }
    const level = qs('[data-gs-floating-zoom-level]');
    if (level && level.textContent !== `${percent}%`) level.textContent = `${percent}%`;
    const zoomOut = qs('[data-gs-floating-zoom-out]');
    const zoomIn = qs('[data-gs-floating-zoom-in]');
    const fit = qs('[data-gs-floating-zoom-reset]');
    if (zoomOut && zoomOut.disabled !== (state.floatingPreviewZoomScale <= 1)) zoomOut.disabled = state.floatingPreviewZoomScale <= 1;
    if (zoomIn && zoomIn.disabled !== (state.floatingPreviewZoomScale >= 2)) zoomIn.disabled = state.floatingPreviewZoomScale >= 2;
    const fitDisabled = state.floatingPreviewZoomScale === 1 && state.floatingPreviewZoomX === 0 && state.floatingPreviewZoomY === 0;
    if (fit && fit.disabled !== fitDisabled) fit.disabled = fitDisabled;
    scheduleFloatingPreviewZoomAnnouncement(percent);
    // Labels depend on zoom state, not every pan pixel. Keep them off the
    // compositor hot path so one drag frame cannot wake broad DOM reconciliation.
    if (priorZoomed !== (zoomed ? 'true' : 'false')) {
      syncFloatingPreviewExpandText(preview);
      syncFloatingPreviewMinimizeControl(preview);
    }
  }

  function requestFloatingPreviewZoomTransform() {
    if (state.floatingPreviewTransformFrame) return;
    state.floatingPreviewTransformFrame = window.requestAnimationFrame(() => {
      state.floatingPreviewTransformFrame = 0;
      applyFloatingPreviewZoomTransform();
    });
  }

  function resetFloatingPreviewZoom(options = {}) {
    resetFloatingPreviewPointer();
    state.floatingPreviewZoomScale = 1;
    state.floatingPreviewZoomX = 0;
    state.floatingPreviewZoomY = 0;
    if (options.preserveExpandedState) {
      state.floatingPreviewViewState = 'fit';
      state.floatingPreviewExpanded = true;
    }
    requestFloatingPreviewZoomTransform();
  }

  function setFloatingPreviewZoomScale(next, clientX, clientY) {
    if (!state.floatingPreviewExpanded) return;
    const holder = state.floatingPreviewInteractionOwner?.holder || qs('#preview-main-popup #preview-canvas-popup2');
    if (!holder) return;
    const boundedScale = clamp(next, 1, 2);
    const rect = holder.getBoundingClientRect();
    const focusX = Number.isFinite(clientX) ? clientX : rect.left + rect.width / 2;
    const focusY = Number.isFinite(clientY) ? clientY : rect.top + rect.height / 2;
    const point = floatingPreviewStagePoint(focusX, focusY);
    const ratio = boundedScale / state.floatingPreviewZoomScale;
    state.floatingPreviewZoomX = point.x - (point.x - state.floatingPreviewZoomX) * ratio;
    state.floatingPreviewZoomY = point.y - (point.y - state.floatingPreviewZoomY) * ratio;
    state.floatingPreviewZoomScale = boundedScale;
    requestFloatingPreviewZoomTransform();
  }

  function cycleFloatingPreviewZoomAt(clientX, clientY) {
    if (state.floatingPreviewZoomScale < 1.25) setFloatingPreviewZoomScale(1.5, clientX, clientY);
    else if (state.floatingPreviewZoomScale < 1.75) setFloatingPreviewZoomScale(2, clientX, clientY);
    else resetFloatingPreviewZoom({ preserveExpandedState: true });
  }

  function enterFloatingPreviewDetail(event) {
    if (!state.floatingPreviewExpanded) return false;
    cycleFloatingPreviewZoomAt(event?.clientX, event?.clientY);
    return true;
  }

  function syncFloatingPreviewExpandText(preview = qs('#preview-main-popup')) {
    const expand = preview ? qs('.gs-floating-preview__expand-bar', preview) : null;
    if (!expand) return;
    // Every visible collapsed preview has an expansion action. Images uses the
    // safe mirrored inspector until a real native editor is ready. Keep the same
    // shopper-facing label across styles while the existing Images route still
    // upgrades the destination to the native editor when it is ready.
    if (expand.hidden) expand.hidden = false;
    if (expand.getAttribute('aria-hidden') !== 'false') expand.setAttribute('aria-hidden', 'false');
    if (expand.tabIndex !== 0) expand.tabIndex = 0;
    if (document.documentElement.dataset.gsProgressiveFloatingPreviewExpansionAvailable !== 'true') document.documentElement.dataset.gsProgressiveFloatingPreviewExpansionAvailable = 'true';
    const expanded = document.documentElement.dataset.gsProgressiveFloatingPreviewExpanded === 'true';
    const zoomed = document.documentElement.dataset.gsProgressiveFloatingPreviewZoomed === 'true';
    const nextText = expanded ? (zoomed ? 'Tap image to reset' : 'Tap image to zoom') : 'Expand preview';
    if (expand.textContent !== nextText) expand.textContent = nextText;
    if (expand.getAttribute('aria-label') !== nextText) expand.setAttribute('aria-label', nextText);
    const ariaExpanded = expanded ? 'true' : 'false';
    if (expand.getAttribute('aria-expanded') !== ariaExpanded) expand.setAttribute('aria-expanded', ariaExpanded);
  }

  function floatingPreviewTouchPoint(event) {
    const touch = event?.changedTouches?.[0] || event?.touches?.[0];
    return touch || event;
  }

  function isFloatingPreviewControlTarget(target) {
    return !!target?.closest?.('.gs-floating-preview__minimize, .gs-floating-preview__expand-bar, .gs-floating-preview-restore, .gs-floating-preview__adjust, .gs-floating-preview__zoom-controls');
  }

  function suppressFloatingPreviewCompatibilityClick(event) {
    const ownsGuidedStageClick = !isFloatingPreviewControlTarget(event.target);
    // This listener exists only while the guided preview owns the theme's legacy
    // #preview-canvas-popup2 node. PointerEnd handles every intentional stage tap,
    // so no non-control click may reach the legacy bubble listener that opens
    // .main-product__media.popup-active. Ownership does not depend on transient
    // zoom/expanded state, which closes pointerup-to-click and remount timing gaps.
    if (!ownsGuidedStageClick && !state.floatingPreviewSuppressClick && event.detail < 2) return;
    if (!ownsGuidedStageClick && state.floatingPreviewSuppressClick) {
      const point = state.floatingPreviewSuppressClickPoint;
      const attributable = event.detail > 0
        && event.button === 0
        && !isFloatingPreviewControlTarget(event.target)
        && !!point
        && Math.hypot(event.clientX - point.x, event.clientY - point.y) <= 24;
      if (!attributable) {
        clearFloatingPreviewCompatibilityClickSuppression();
        if (event.detail < 2) return;
      }
    }
    clearFloatingPreviewCompatibilityClickSuppression();
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  // 2026-07-08 PR69 lock-plus: zoom/pan must feel native, not like a blown-up
  // thumbnail. Use a source-resolution-capped zoom scale and pointer capture so
  // drag-pan works smoothly for Custom Text and Monogram without touching the
  // native Images editor path.
  function floatingPreviewMovementThreshold(pointer) {
    return pointer?.type === 'touch' ? 12 : 5;
  }

  function bindFloatingPreviewZoomPan(preview) {
    const holder = preview ? qs('#preview-canvas-popup2', preview) : null;
    if (!preview || !holder) return;
    if (state.floatingPreviewInteractionOwner?.preview === preview && state.floatingPreviewInteractionOwner?.holder === holder) return;
    const html = document.documentElement;
    if (state.floatingPreviewInteractionOwner) {
      html.dataset.gsProgressiveFloatingPreviewUnbindCount = String((parseInt(html.dataset.gsProgressiveFloatingPreviewUnbindCount || '0', 10) || 0) + 1);
    }
    state.floatingPreviewInteractionAbort?.abort();
    resetFloatingPreviewPointer();
    const controller = new AbortController();
    state.floatingPreviewInteractionAbort = controller;
    state.floatingPreviewInteractionOwner = { preview, holder };
    holder.tabIndex = 0;
    holder.setAttribute('role', 'region');
    holder.setAttribute('aria-describedby', 'gs-floating-preview-zoom-instructions');
    html.dataset.gsProgressiveFloatingPreviewBindCount = String((parseInt(html.dataset.gsProgressiveFloatingPreviewBindCount || '0', 10) || 0) + 1);

    const pointerDown = (event) => {
      if (isFloatingPreviewControlTarget(event.target) || !holder.contains(event.target) || event.button > 0) return;
      const pointer = {
        x: event.clientX,
        y: event.clientY,
        startX: event.clientX,
        startY: event.clientY,
        type: event.pointerType,
        startedAt: performance.now(),
        startedExpanded: state.floatingPreviewExpanded
      };
      state.floatingPreviewPointers.set(event.pointerId, pointer);
      clearFloatingPreviewCompatibilityClickSuppression();
      if (!state.floatingPreviewExpanded) return;
      if (state.floatingPreviewPointers.size === 2) {
        state.floatingPreviewGestureHadMultiTouch = true;
        for (const pointerId of state.floatingPreviewPointers.keys()) holder.setPointerCapture?.(pointerId);
        const [a, b] = [...state.floatingPreviewPointers.values()];
        const midpoint = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        const point = floatingPreviewStagePoint(midpoint.x, midpoint.y);
        state.floatingPreviewPinchStart = {
          distance: Math.hypot(a.x - b.x, a.y - b.y) || 1,
          scale: state.floatingPreviewZoomScale,
          contentX: (point.x - state.floatingPreviewZoomX) / state.floatingPreviewZoomScale,
          contentY: (point.y - state.floatingPreviewZoomY) / state.floatingPreviewZoomScale
        };
        state.floatingPreviewDragStart = null;
        state.floatingPreviewDragging = false;
        setDatasetIfChanged(holder, 'pinching', 'true');
        event.preventDefault();
      } else {
        state.floatingPreviewDragStart = {
          pointerId: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          translateX: state.floatingPreviewZoomX,
          translateY: state.floatingPreviewZoomY
        };
        if (state.floatingPreviewZoomScale > 1) {
          holder.setPointerCapture?.(event.pointerId);
          event.preventDefault();
        }
      }
      requestFloatingPreviewZoomTransform();
    };

    const pointerMove = (event) => {
      if (!state.floatingPreviewPointers.has(event.pointerId)) return;
      const prior = state.floatingPreviewPointers.get(event.pointerId);
      const samples = event.getCoalescedEvents?.() || [];
      const pointEvent = samples[samples.length - 1] || event;
      state.floatingPreviewPointers.set(event.pointerId, { ...prior, x: pointEvent.clientX, y: pointEvent.clientY });
      if (!state.floatingPreviewExpanded) return;
      if (state.floatingPreviewPointers.size >= 2 && state.floatingPreviewPinchStart) {
        event.preventDefault();
        const [a, b] = [...state.floatingPreviewPointers.values()];
        const midpoint = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
        const point = floatingPreviewStagePoint(midpoint.x, midpoint.y);
        const distance = Math.hypot(a.x - b.x, a.y - b.y) || 1;
        state.floatingPreviewZoomScale = clamp(state.floatingPreviewPinchStart.scale * distance / state.floatingPreviewPinchStart.distance, 1, 2);
        state.floatingPreviewZoomX = point.x - state.floatingPreviewPinchStart.contentX * state.floatingPreviewZoomScale;
        state.floatingPreviewZoomY = point.y - state.floatingPreviewPinchStart.contentY * state.floatingPreviewZoomScale;
        requestFloatingPreviewZoomTransform();
        return;
      }
      if (state.floatingPreviewPointers.size === 1 && state.floatingPreviewDragStart?.pointerId === event.pointerId && state.floatingPreviewZoomScale > 1) {
        const movement = Math.hypot(pointEvent.clientX - state.floatingPreviewDragStart.x, pointEvent.clientY - state.floatingPreviewDragStart.y);
        const threshold = floatingPreviewMovementThreshold(prior);
        if (movement > threshold && !state.floatingPreviewDragging) state.floatingPreviewDragging = true;
        if (!state.floatingPreviewDragging) return;
        event.preventDefault();
        setDatasetIfChanged(holder, 'panning', 'true');
        state.floatingPreviewZoomX = state.floatingPreviewDragStart.translateX + pointEvent.clientX - state.floatingPreviewDragStart.x;
        state.floatingPreviewZoomY = state.floatingPreviewDragStart.translateY + pointEvent.clientY - state.floatingPreviewDragStart.y;
        requestFloatingPreviewZoomTransform();
      }
    };

    const pointerEnd = (event, cancelled = false) => {
      const pointer = state.floatingPreviewPointers.get(event.pointerId);
      if (!pointer) return;
      const hadMultiple = state.floatingPreviewGestureHadMultiTouch || state.floatingPreviewPointers.size > 1;
      const movement = Math.hypot(event.clientX - pointer.startX, event.clientY - pointer.startY);
      const duration = performance.now() - pointer.startedAt;
      const threshold = floatingPreviewMovementThreshold(pointer);
      const wasDragging = state.floatingPreviewDragging;
      state.floatingPreviewPointers.delete(event.pointerId);
      if (holder.hasPointerCapture?.(event.pointerId)) holder.releasePointerCapture(event.pointerId);
      const cleanTap = !cancelled && !hadMultiple && !wasDragging && movement <= threshold && duration < 500;
      const completedDrag = !cancelled && !hadMultiple && wasDragging && event.button === 0;
      if (completedDrag) {
        // Compatibility click follows mouse release. Arm here so a slow or held
        // drag cannot outlive the bounded suppression window before click exists.
        armFloatingPreviewCompatibilityClickSuppression(event);
      } else if (cancelled) {
        clearFloatingPreviewCompatibilityClickSuppression();
      }
      if (cleanTap) {
        armFloatingPreviewCompatibilityClickSuppression(event);
        event.preventDefault();
        event.stopPropagation();
        if (!pointer.startedExpanded) {
          if (!openReadyImageEditorOrBlock(event)) setFloatingPreviewViewState('fit', { reason: 'collapsed-stage-tap' });
        } else {
          cycleFloatingPreviewZoomAt(event.clientX, event.clientY);
        }
      }
      state.floatingPreviewPinchStart = null;
      state.floatingPreviewDragStart = null;
      state.floatingPreviewDragging = false;
      setDatasetIfChanged(holder, 'panning', 'false');
      setDatasetIfChanged(holder, 'pinching', 'false');
      if (state.floatingPreviewPointers.size === 1) {
        const [pointerId, remaining] = [...state.floatingPreviewPointers.entries()][0];
        state.floatingPreviewDragStart = {
          pointerId,
          x: remaining.x,
          y: remaining.y,
          translateX: state.floatingPreviewZoomX,
          translateY: state.floatingPreviewZoomY
        };
      } else if (state.floatingPreviewPointers.size === 0) {
        state.floatingPreviewGestureHadMultiTouch = false;
      }
      requestFloatingPreviewZoomTransform();
      if (state.floatingPreviewPointers.size === 0) flushRefreshDeferredForPan();
    };

    const keyDown = (event) => {
      if (!state.floatingPreviewExpanded) return;
      const key = event.key;
      if (key === 'Escape') {
        event.preventDefault();
        setFloatingPreviewViewState('collapsed', { reason: 'escape-minimize' });
        window.requestAnimationFrame(() => qs('#preview-main-popup .gs-floating-preview__minimize')?.focus?.({ preventScroll: true }));
      }
      else if (key === '+' || key === '=') { event.preventDefault(); setFloatingPreviewZoomScale(state.floatingPreviewZoomScale + 0.5); }
      else if (key === '-') { event.preventDefault(); setFloatingPreviewZoomScale(state.floatingPreviewZoomScale - 0.5); }
      else if (key === '0' || key === 'Home') { event.preventDefault(); resetFloatingPreviewZoom({ preserveExpandedState: true }); }
      else if (state.floatingPreviewZoomScale > 1 && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(key)) {
        event.preventDefault();
        const step = 48;
        if (key === 'ArrowLeft') state.floatingPreviewZoomX += step;
        if (key === 'ArrowRight') state.floatingPreviewZoomX -= step;
        if (key === 'ArrowUp') state.floatingPreviewZoomY += step;
        if (key === 'ArrowDown') state.floatingPreviewZoomY -= step;
        requestFloatingPreviewZoomTransform();
      }
    };

    holder.addEventListener('pointerdown', pointerDown, { passive: false, signal: controller.signal });
    holder.addEventListener('pointermove', pointerMove, { passive: false, signal: controller.signal });
    holder.addEventListener('pointerup', (event) => pointerEnd(event), { passive: false, signal: controller.signal });
    holder.addEventListener('pointercancel', (event) => pointerEnd(event, true), { passive: false, signal: controller.signal });
    holder.addEventListener('lostpointercapture', (event) => pointerEnd(event, true), { passive: false, signal: controller.signal });
    holder.addEventListener('click', suppressFloatingPreviewCompatibilityClick, { capture: true, signal: controller.signal });
    holder.addEventListener('keydown', keyDown, { signal: controller.signal });
    qs('[data-gs-floating-zoom-in]', preview)?.addEventListener('click', () => setFloatingPreviewZoomScale(state.floatingPreviewZoomScale + 0.5), { signal: controller.signal });
    qs('[data-gs-floating-zoom-out]', preview)?.addEventListener('click', () => setFloatingPreviewZoomScale(state.floatingPreviewZoomScale - 0.5), { signal: controller.signal });
    qs('[data-gs-floating-zoom-reset]', preview)?.addEventListener('click', () => resetFloatingPreviewZoom({ preserveExpandedState: true }), { signal: controller.signal });
    preview.addEventListener('dblclick', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, { capture: true, signal: controller.signal });
    applyFloatingPreviewZoomTransform();
  }

  function syncFloatingPreviewCanvasMirror() {
    const holder = qs('#preview-canvas-popup2');
    if (!holder || isGuided()) return { copied: false, reason: 'missing-holder' };
    const source = authoritativeFloatingPreviewCanvas();
    const generation = state.floatingPreviewConvergence?.generation || state.floatingPreviewConvergenceGeneration || 0;
    if (!source || source.tagName !== 'CANVAS' || !source.width || !source.height) {
      holder.dataset.gsFloatingMirrorReady = 'false';
      holder.dataset.gsFloatingMirrorFingerprint = '';
      holder.dataset.gsFloatingMirrorGeneration = String(generation);
      return { copied: false, reason: 'missing-authoritative-source' };
    }
    const layer = floatingPreviewMediaLayer(holder);
    let mirror = qs('canvas.gs-floating-preview__canvas-mirror', holder);
    if (!mirror) {
      mirror = document.createElement('canvas');
      mirror.className = 'gs-floating-preview__canvas-mirror';
    }
    if (layer && mirror.parentElement !== layer) layer.appendChild(mirror);
    if (layer && holder.lastElementChild !== layer) holder.appendChild(layer);
    mirror.style.setProperty('z-index', '3', 'important');
    mirror.style.setProperty('pointer-events', 'none', 'important');
    const w = source.width || source.getBoundingClientRect().width || 780;
    const h = source.height || source.getBoundingClientRect().height || w;
    if (mirror.width !== w) mirror.width = w;
    if (mirror.height !== h) mirror.height = h;
    holder.dataset.gsFloatingMirrorReady = 'false';
    holder.dataset.gsFloatingMirrorFingerprint = '';
    holder.dataset.gsFloatingMirrorGeneration = String(generation);
    try {
      const ctx = mirror.getContext('2d');
      ctx.clearRect(0, 0, mirror.width, mirror.height);
      ctx.drawImage(source, 0, 0, mirror.width, mirror.height);
      const sourceFingerprint = sampledCanvasFingerprint(source);
      const mirrorFingerprint = sampledCanvasFingerprint(mirror);
      const parity = sameCanvasFingerprint(sourceFingerprint, mirrorFingerprint);
      holder.dataset.gsFloatingMirrorReady = parity ? 'true' : 'false';
      holder.dataset.gsFloatingMirrorSyncedAt = String(Date.now());
      holder.dataset.gsFloatingMirrorFingerprint = parity ? sourceFingerprint.hash : '';
      holder.dataset.gsFloatingMirrorGeneration = String(generation);
      holder.dataset.gsFloatingMirrorCarryForward = 'false';
      syncFloatingPreviewNativeZoomImage(holder);
      return { copied: true, parity, sourceFingerprint, mirrorFingerprint };
    } catch (error) {
      holder.dataset.gsFloatingMirrorReady = 'false';
      return { copied: false, reason: 'copy-error', error: String(error) };
    }
  }

  function carryForwardVerifiedFloatingPreviewMirror(generation) {
    const holder = qs('#preview-canvas-popup2');
    const mirror = holder ? qs('canvas.gs-floating-preview__canvas-mirror', holder) : null;
    if (!holder || !mirror?.isConnected || holder.dataset.gsFloatingMirrorReady !== 'true') return false;
    const recordedFingerprint = holder.dataset.gsFloatingMirrorFingerprint || '';
    const mirrorFingerprint = sampledCanvasFingerprint(mirror);
    if (!recordedFingerprint
      || mirrorFingerprint.status !== 'readable'
      || mirrorFingerprint.paintedPixels <= 0
      || mirrorFingerprint.hash !== recordedFingerprint) return false;
    // Text and monogram renders update an already valid preview in place. Carry
    // that last verified frame into the new convergence generation so the
    // readiness gate does not hide the card while Customily paints the next
    // frame. Images remain strict: they must establish fresh generation parity.
    holder.dataset.gsFloatingMirrorGeneration = String(generation);
    holder.dataset.gsFloatingMirrorCarryForward = 'true';
    return true;
  }

  function invalidateFloatingPreviewMirror(generation = null) {
    const holder = qs('#preview-canvas-popup2');
    if (!holder) return;
    holder.dataset.gsFloatingMirrorReady = 'false';
    holder.dataset.gsFloatingMirrorFingerprint = '';
    holder.dataset.gsFloatingMirrorCarryForward = 'false';
    if (generation !== null) holder.dataset.gsFloatingMirrorGeneration = String(generation);
  }

  function setNoUploadImagesTransitionHold(active) {
    const preview = qs('#preview-main-popup');
    if (!preview) return;
    if (active) {
      preview.dataset.gsImagesTransitionHold = 'true';
      preview.style.setProperty('visibility', 'hidden', 'important');
      preview.style.setProperty('pointer-events', 'none', 'important');
      return;
    }
    if (preview.dataset.gsImagesTransitionHold !== 'true') return;
    delete preview.dataset.gsImagesTransitionHold;
    preview.style.removeProperty('visibility');
    preview.style.removeProperty('pointer-events');
  }

  function releaseNoUploadImagesTransitionHold(options = {}) {
    window.clearTimeout(state.noUploadImagesHoldTimer);
    state.noUploadImagesHoldTimer = 0;
    if (options.invalidateToken && state.pendingNoUploadImagesSelection) {
      state.noUploadImagesTransitionToken = Number(state.noUploadImagesTransitionToken || 0) + 1;
    }
    state.pendingNoUploadImagesSelection = false;
    state.pendingNoUploadImagesPreviousMirrorFingerprint = null;
    state.pendingNoUploadImagesPreviousStyle = null;
    setNoUploadImagesTransitionHold(false);
  }

  function watchNoUploadImagesTransitionHold(transitionToken) {
    window.clearTimeout(state.noUploadImagesHoldTimer);
    state.noUploadImagesHoldTimer = window.setTimeout(() => {
      state.noUploadImagesHoldTimer = 0;
      if (!state.pendingNoUploadImagesSelection
        || transitionToken !== Number(state.noUploadImagesTransitionToken || 0)) return;
      const convergence = state.floatingPreviewConvergence;
      const adopted = convergence?.transitionToken === transitionToken;
      if (!adopted) {
        releaseNoUploadImagesTransitionHold({ invalidateToken: true });
        syncFloatingPreviewCanvasMirror();
        syncFloatingPreviewGate();
        syncFloatingPreviewActiveGate();
      }
    }, 1500);
  }

  function imageProcessingLanguage(method = chosenImageMethod()) {
    if (/logo/i.test(method)) return {
      preparing: 'Preparing your logo…',
      processing: 'Optimizing your logo…',
      settling: 'Finishing your optimized logo…',
      ready: 'Your logo is ready.',
      error: 'We couldn’t optimize your logo. Try another file.'
    };
    if (/face/i.test(method)) return {
      preparing: 'Preparing your image…',
      processing: 'Cropping your face…',
      settling: 'Finishing your face crop…',
      ready: 'Your face crop is ready.',
      error: 'We couldn’t crop the face. Try another image.'
    };
    if (/remove background/i.test(method)) return {
      preparing: 'Preparing your image…',
      processing: 'Removing the background…',
      settling: 'Finishing your background removal…',
      ready: 'Your background-free image is ready.',
      error: 'We couldn’t remove the background. Try another image.'
    };
    return {
      preparing: 'Preparing your image…',
      processing: 'Optimizing your image…',
      settling: 'Finishing your image…',
      ready: 'Your image is ready.',
      error: 'We couldn’t prepare your image. Try another file.'
    };
  }

  function imageFilterRequestObservedSince(startedAt) {
    if (state.floatingPreviewImageFilterInFlight > 0) return true;
    if (state.floatingPreviewImageFilterNetworkEntries.some((entry) => entry.startedAt >= startedAt)) return true;
    return state.floatingPreviewImageFilterEntries.some((entry) => entry.startTime >= startedAt);
  }

  function truthfulImageProcessingMessage(status) {
    const current = state.floatingPreviewConvergence;
    if (!current?.imageFlow) return '';
    const language = imageProcessingLanguage(current.method);
    if (status === 'ready') return language.ready;
    if (status === 'error') return language.error;
    if (status === 'ambiguous') return 'This is taking longer than expected. Try replacing the image.';
    if (status === 'settling') return language.settling;
    if (status !== 'processing') return '';
    if (current.mode === 'filter-terminal' && imageFilterRequestObservedSince(current.startedAt)) return language.processing;
    return language.preparing;
  }

  function syncProgressiveImageProcessingNotice(status, message) {
    const current = state.floatingPreviewConvergence;
    const uploadGroup = qs('[data-gs-progressive-role="upload"]', customilyRoot() || document);
    if (!uploadGroup || !current?.imageFlow) {
      qsa('.gs-progressive-image-processing-status').forEach((notice) => notice.remove());
      return false;
    }
    let notice = qs('.gs-progressive-image-processing-status', uploadGroup);
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'gs-progressive-image-processing-status';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      const indicator = document.createElement('span');
      indicator.className = 'gs-progressive-image-processing-status__indicator';
      indicator.setAttribute('aria-hidden', 'true');
      const copy = document.createElement('span');
      copy.className = 'gs-progressive-image-processing-status__copy';
      notice.append(indicator, copy);
      uploadGroup.appendChild(notice);
    }
    window.clearTimeout(state.progressiveImageProcessingNoticeTimer);
    state.progressiveImageProcessingNoticeTimer = 0;
    notice.dataset.status = status;
    const copy = qs('.gs-progressive-image-processing-status__copy', notice);
    if (copy) copy.textContent = message;
    notice.hidden = !message || status === 'idle';
    if (status === 'ready' && message) {
      const generation = current.generation;
      state.progressiveImageProcessingNoticeTimer = window.setTimeout(() => {
        if (state.floatingPreviewConvergence?.generation === generation && notice.isConnected) notice.hidden = true;
      }, 1800);
    }
    return !notice.hidden;
  }

  function setFloatingPreviewConvergenceStatus(status, message = '') {
    const html = document.documentElement;
    html.dataset.gsFloatingPreviewSyncStatus = status;
    const generation = state.floatingPreviewConvergence?.generation || state.floatingPreviewConvergenceGeneration || 0;
    html.dataset.gsFloatingPreviewSyncGeneration = String(generation);
    const truthfulMessage = truthfulImageProcessingMessage(status) || message;
    const inlineAnnounces = syncProgressiveImageProcessingNotice(status, truthfulMessage);
    // Serialize image operations while the source-truthed request/convergence
    // lifecycle is active. This prevents a shopper from starting a replacement
    // upload or changing the processing method while an older ImageFilter request
    // can still complete. We defer the DOM lock so the initiating native event
    // reaches Customily before its controls become temporarily unavailable.
    window.setTimeout(syncImageProcessingControlLock, 0);
    const holder = qs('#preview-canvas-popup2');
    if (holder) {
      let notice = qs('.gs-floating-preview__sync-status', holder);
      if (!notice) {
        notice = document.createElement('div');
        notice.className = 'gs-floating-preview__sync-status';
        holder.appendChild(notice);
      }
      if (inlineAnnounces) {
        notice.removeAttribute('role');
        notice.removeAttribute('aria-live');
        notice.setAttribute('aria-hidden', 'true');
      } else {
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        notice.removeAttribute('aria-hidden');
      }
      notice.dataset.status = status;
      notice.textContent = truthfulMessage;
      notice.hidden = !truthfulMessage || status === 'ready' || status === 'idle';
    }
    qsa('[data-gs-progressive-role="upload"] .gs-floating-preview__sync-inline').forEach((inline) => inline.remove());
  }

  function syncImageProcessingControlLock() {
    const current = state.floatingPreviewConvergence;
    const unresolvedAfterTerminal = (current?.status === 'error' || current?.status === 'ambiguous')
      && state.floatingPreviewImageFilterInFlight > 0;
    const locked = !!current?.imageFlow && hasDefiniteFileAttachment()
      && (current.status === 'processing' || current.status === 'settling' || unresolvedAfterTerminal);
    qsa(`${FILE_SELECTOR}, ${IMAGE_METHOD_SELECTOR}`).forEach((control) => {
      if (locked) {
        if (control.disabled || control.dataset.gsImageProcessingLocked === 'true') return;
        control.dataset.gsImageProcessingLocked = 'true';
        control.disabled = true;
        control.setAttribute('aria-disabled', 'true');
        return;
      }
      if (control.dataset.gsImageProcessingLocked !== 'true') return;
      control.disabled = false;
      control.removeAttribute('aria-disabled');
      delete control.dataset.gsImageProcessingLocked;
    });
  }

  function terminalThumbnailReady() {
    const image = qsa('#cl_optionsapp .customily-file-input-thumbnail img, #cl_optionsapp .customily-file-with-thumbnail img')
      .find((candidate) => candidate.complete && candidate.naturalWidth > 0);
    return !!image;
  }

  function isImageFilterResourceEntry(entry) {
    return !!entry && /\/api\/JSLib\/v2\/Image\/ImageFilter(?:\?|$)/i.test(entry.name || '') && entry.responseEnd > 0;
  }

  function recordImageFilterResourceEntry(entry) {
    if (!isImageFilterResourceEntry(entry)) return;
    const normalized = {
      name: entry.name || '',
      startTime: Number(entry.startTime || 0),
      responseEnd: Number(entry.responseEnd || 0),
      responseStatus: Number(entry.responseStatus || 0),
      duration: Number(entry.duration || 0)
    };
    const key = `${normalized.name}|${normalized.startTime}|${normalized.responseEnd}`;
    if (state.floatingPreviewImageFilterEntries.some((candidate) => candidate.key === key)) return;
    state.floatingPreviewImageFilterEntries.push({ ...normalized, key });
    if (state.floatingPreviewImageFilterEntries.length > 120) state.floatingPreviewImageFilterEntries.splice(0, state.floatingPreviewImageFilterEntries.length - 120);
  }

  function imageFilterRequestUrl(input) {
    try { return typeof input === 'string' ? input : (input?.url || ''); } catch (_) { return ''; }
  }

  function imageFilterRequestMatches(input) {
    return /\/api\/JSLib\/v2\/Image\/ImageFilter(?:\?|$)/i.test(imageFilterRequestUrl(input));
  }

  function recordInstrumentedImageFilterTerminal(name, startedAt, responseStatus, success) {
    const entry = {
      name: name || '', startedAt, responseEnd: performance.now(), responseStatus: Number(responseStatus || 0),
      success: success === true, statusKnown: Number(responseStatus || 0) > 0
    };
    state.floatingPreviewImageFilterNetworkEntries.push(entry);
    if (state.floatingPreviewImageFilterNetworkEntries.length > 120) state.floatingPreviewImageFilterNetworkEntries.splice(0, state.floatingPreviewImageFilterNetworkEntries.length - 120);
    state.floatingPreviewImageFilterInFlight = Math.max(0, state.floatingPreviewImageFilterInFlight - 1);
    window.setTimeout(syncImageProcessingControlLock, 0);
  }

  function ensureImageFilterNetworkInstrumentation() {
    if (state.floatingPreviewImageFilterInstrumentationInstalled) return;
    state.floatingPreviewImageFilterInstrumentationInstalled = true;
    if (typeof window.fetch === 'function') {
      const originalFetch = window.fetch;
      window.fetch = function instrumentedImageFilterFetch(input, init) {
        if (!imageFilterRequestMatches(input)) return originalFetch.apply(this, arguments);
        const name = imageFilterRequestUrl(input);
        const startedAt = performance.now();
        state.floatingPreviewImageFilterInFlight += 1;
        window.setTimeout(syncImageProcessingControlLock, 0);
        let finished = false;
        const finish = (status, success) => {
          if (finished) return;
          finished = true;
          recordInstrumentedImageFilterTerminal(name, startedAt, status, success);
        };
        try {
          return originalFetch.apply(this, arguments).then((response) => {
            try {
              response.clone().arrayBuffer().then(
                () => finish(response.status, response.ok),
                () => finish(response.status, response.ok)
              );
            } catch (_) {
              finish(response.status, response.ok);
            }
            return response;
          }, (error) => {
            finish(0, false);
            throw error;
          });
        } catch (error) {
          finish(0, false);
          throw error;
        }
      };
    }
    if (typeof XMLHttpRequest === 'function') {
      const originalOpen = XMLHttpRequest.prototype.open;
      const originalSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function instrumentedImageFilterOpen(method, url) {
        this.__gsImageFilterUrl = imageFilterRequestUrl(url);
        return originalOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function instrumentedImageFilterSend() {
        if (!imageFilterRequestMatches(this.__gsImageFilterUrl)) return originalSend.apply(this, arguments);
        const name = this.__gsImageFilterUrl;
        const startedAt = performance.now();
        state.floatingPreviewImageFilterInFlight += 1;
        window.setTimeout(syncImageProcessingControlLock, 0);
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          const status = Number(this.status || 0);
          recordInstrumentedImageFilterTerminal(name, startedAt, status, status >= 200 && status < 400);
        };
        this.addEventListener('loadend', finish, { once: true });
        try { return originalSend.apply(this, arguments); }
        catch (error) { finish(); throw error; }
      };
    }
  }

  function ensureImageFilterPerformanceObserver() {
    ensureImageFilterNetworkInstrumentation();
    try { performance.setResourceTimingBufferSize?.(5000); } catch (_) {}
    (performance.getEntriesByType?.('resource') || []).forEach(recordImageFilterResourceEntry);
    if (state.floatingPreviewImageFilterObserver || typeof PerformanceObserver !== 'function') return;
    try {
      state.floatingPreviewImageFilterObserver = new PerformanceObserver((list) => list.getEntries().forEach(recordImageFilterResourceEntry));
      state.floatingPreviewImageFilterObserver.observe({ type: 'resource', buffered: true });
    } catch (_) {
      state.floatingPreviewImageFilterObserver = null;
    }
  }

  function imageFilterTerminalSince(startedAt) {
    ensureImageFilterPerformanceObserver();
    const instrumented = state.floatingPreviewImageFilterNetworkEntries
      .filter((entry) => entry.startedAt >= startedAt && entry.responseEnd > 0)
      .sort((left, right) => left.responseEnd - right.responseEnd);
    if (instrumented.length) {
      const entry = instrumented[instrumented.length - 1];
      return {
        terminal: true, success: entry.success, statusKnown: entry.statusKnown,
        reason: entry.success ? '' : (entry.responseStatus ? `image-filter-http-${entry.responseStatus}` : 'image-filter-network-failure'),
        at: entry.responseEnd, name: entry.name
      };
    }
    const filters = state.floatingPreviewImageFilterEntries
      .filter((entry) => entry.startTime >= startedAt && entry.responseEnd > 0)
      .sort((left, right) => left.responseEnd - right.responseEnd);
    if (!filters.length) return { terminal: false };
    const entry = filters[filters.length - 1];
    const responseStatus = Number(entry.responseStatus || 0);
    if (responseStatus >= 400) return { terminal: true, success: false, reason: `image-filter-http-${responseStatus}`, at: entry.responseEnd };
    return {
      terminal: true,
      success: responseStatus >= 200 && responseStatus < 400 ? true : null,
      statusKnown: responseStatus > 0,
      at: entry.responseEnd,
      name: entry.name
    };
  }

  function finishFloatingPreviewConvergence(generation, outcome, message = '') {
    const current = state.floatingPreviewConvergence;
    if (!current || current.generation !== generation) return;
    window.clearTimeout(state.floatingPreviewConvergenceTimer);
    state.floatingPreviewConvergenceTimer = 0;
    current.status = outcome;
    if (current.imageFlow) {
      if (outcome === 'ready') {
        state.imagePreviewReady = true;
        confirmedUploadRecord({ ready: true });
        clearNativeEditorAnnouncement();
      } else if (outcome === 'error') {
        invalidateConfirmedUpload('error');
      } else if (!current.restoredFromConfirmedUpload) {
        state.imagePreviewReady = false;
      }
    }
    document.documentElement.dataset.gsFloatingPreviewSyncClassification = current.classification || outcome;
    setFloatingPreviewConvergenceStatus(outcome, message);
    syncFloatingPreviewGate();
    syncFloatingPreviewActiveGate();
  }

  function sampleFloatingPreviewConvergence(generation) {
    const current = state.floatingPreviewConvergence;
    if (!current || current.generation !== generation) return;
    const now = performance.now();
    if (current.mode === 'method-transition') {
      const requestObserved = imageFilterRequestObservedSince(current.startedAt);
      const targetUpload = confirmedUploadRecord();
      if (requestObserved) {
        current.imageFlow = true;
        current.mode = 'filter-terminal';
        current.deadlineAt = now + 45000;
        current.lastMaterialChangeAt = now;
        state.imagePreviewReady = false;
        invalidateFloatingPreviewMirror(generation);
        setFloatingPreviewConvergenceStatus('processing');
      } else if (targetUpload?.ready === true) {
        current.imageFlow = true;
        current.restoredFromConfirmedUpload = true;
        current.mode = 'image-terminal';
        current.deadlineAt = now + 12000;
        current.lastMaterialChangeAt = now;
        state.imagePreviewReady = true;
        invalidateFloatingPreviewMirror(generation);
        setFloatingPreviewConvergenceStatus('processing');
      } else if (now >= current.deadlineAt) {
        current.classification = 'method-no-upload';
        finishFloatingPreviewConvergence(generation, 'settled');
        return;
      }
    }
    const error = visibleCustomilyError();
    if (current.imageFlow && uploadAssociatedCustomilyError(error)) {
      finishFloatingPreviewConvergence(generation, 'error', 'We couldn’t update your preview. Try replacing the image.');
      return;
    }
    const sourceFingerprint = sampledCanvasFingerprint(authoritativeFloatingPreviewCanvas());
    if (sourceFingerprint.status === 'tainted') current.readable = 'tainted';
    else if (sourceFingerprint.status === 'readable') current.readable = 'yes';
    const changed = sourceFingerprint.status === 'readable' && !sameCanvasFingerprint(sourceFingerprint, current.lastFingerprint);
    if (changed) {
      current.materialChangeCount += 1;
      current.lastMaterialChangeAt = now;
      current.lastFingerprint = sourceFingerprint;
    }
    const knownBaseFingerprintMatch = current.baseImageFlow
      && !!state.noUploadImagesBaseFingerprint
      && sourceFingerprint.status === 'readable'
      && sourceFingerprint.hash === state.noUploadImagesBaseFingerprint;
    const awaitingFreshBaseFrame = current.baseImageFlow
      && current.requireFreshFrame
      && current.materialChangeCount === 0
      && !knownBaseFingerprintMatch;
    const copied = awaitingFreshBaseFrame
      ? { copied: false, parity: false, reason: 'awaiting-fresh-base-frame' }
      : syncFloatingPreviewCanvasMirror();
    if (copied?.parity) current.copiedFingerprint = copied.sourceFingerprint;
    if (current.baseImageFlow
      && current.transitionToken === Number(state.noUploadImagesTransitionToken || 0)
      && copied?.parity
      && (!current.requireFreshFrame || current.materialChangeCount > 0 || knownBaseFingerprintMatch)) {
      state.noUploadImagesBaseFingerprint = copied.sourceFingerprint?.hash || state.noUploadImagesBaseFingerprint || '';
      releaseNoUploadImagesTransitionHold();
    }
    const filterTerminal = current.mode === 'filter-terminal' ? imageFilterTerminalSince(current.startedAt) : null;
    const terminal = current.mode === 'filter-terminal'
      ? filterTerminal?.terminal
      : (current.mode === 'image-terminal' ? terminalThumbnailReady() : current.materialChangeCount > 0);
    const terminalResourceAt = Number(filterTerminal?.at || 0);
    if (terminal && (!current.terminalObservedAt || terminalResourceAt > (current.terminalResourceAt || 0))) {
      current.terminalObservedAt = now;
      current.terminalResourceAt = terminalResourceAt;
      current.terminalFingerprint = sourceFingerprint;
    }
    if (filterTerminal?.terminal && filterTerminal.success === false) {
      finishFloatingPreviewConvergence(generation, 'error', imageProcessingLanguage(current.method).error);
      return;
    }
    const quietAnchor = Math.max(current.lastMaterialChangeAt, current.terminalObservedAt || current.startedAt);
    const quiet = now - quietAnchor >= 750;
    const readableVerified = current.readable === 'yes' && copied?.parity && sameCanvasFingerprint(sourceFingerprint, copied.sourceFingerprint);
    const taintDowngradeVerified = current.readable === 'tainted' && copied?.copied === true;
    const verified = readableVerified || taintDowngradeVerified;
    const filterIdle = current.mode !== 'filter-terminal' || state.floatingPreviewImageFilterInFlight === 0;
    const unknownStatusNoOp = current.mode === 'filter-terminal' && filterTerminal?.statusKnown === false && current.materialChangeCount === 0;
    if (terminal && quiet && verified && filterIdle && !unknownStatusNoOp) {
      current.classification = current.materialChangeCount > 0 ? 'transformed' : 'no-op';
      if (taintDowngradeVerified) current.classification += '-taint-downgrade';
      finishFloatingPreviewConvergence(generation, 'ready');
      return;
    }
    if (now >= current.deadlineAt) {
      if (!current.imageFlow) finishFloatingPreviewConvergence(generation, 'settled');
      else finishFloatingPreviewConvergence(generation, 'ambiguous', 'Your preview is taking longer than expected. Try replacing the image.');
      return;
    }
    const filterStillInFlight = current.mode === 'filter-terminal' && state.floatingPreviewImageFilterInFlight > 0;
    current.status = terminal && !filterStillInFlight ? 'settling' : 'processing';
    setFloatingPreviewConvergenceStatus(current.status);
    state.floatingPreviewConvergenceTimer = window.setTimeout(() => sampleFloatingPreviewConvergence(generation), 150);
  }

  function startFloatingPreviewConvergence(request = {}) {
    window.clearTimeout(state.floatingPreviewConvergenceTimer);
    const generation = ++state.floatingPreviewConvergenceGeneration;
    const imagesSelected = chosenStyle() === 'Images';
    const confirmedUpload = imagesSelected ? confirmedUploadRecord() : null;
    const methodTransition = request.reason === 'image-method-change';
    const imageFlow = !methodTransition && imagesSelected && (confirmedUpload?.ready === true
      || hasDefiniteFileAttachment()
      || (!state.pendingNoUploadImagesSelection && hasFileAttached()));
    if (imageFlow && state.pendingNoUploadImagesSelection) releaseNoUploadImagesTransitionHold();
    const baseImageFlow = imagesSelected && !imageFlow && nativeEditorPopupMobileAllowed();
    const method = chosenImageMethod();
    const bootRestore = request.reason === 'boot-restore';
    const startedAt = Number(request.startedAt || performance.now());
    const initialFingerprint = sampledCanvasFingerprint(authoritativeFloatingPreviewCanvas());
    state.floatingPreviewConvergence = {
      generation, reason: request.reason || 'customization-change', imageFlow, baseImageFlow,
      restoredFromConfirmedUpload: confirmedUpload?.ready === true,
      transitionToken: Number(request.transitionToken || 0),
      // A prior mirror fingerprint is direct proof that Images is replacing a
      // personalized frame. Do not depend on presentation readiness here: other
      // capture listeners can lower that flag during the same click transaction.
      requireFreshFrame: baseImageFlow
        && !!request.previousMirrorFingerprint
        && !!request.previousStyle
        && request.previousStyle !== 'Images', method,
      mode: methodTransition
        ? 'method-transition'
        : (imageFlow ? (bootRestore ? 'image-terminal' : (/logo|face|remove background/i.test(method) ? 'filter-terminal' : 'image-terminal')) : 'quiet-only'),
      status: 'processing', startedAt, deadlineAt: startedAt + (methodTransition ? 1800 : (imageFlow ? 45000 : 12000)),
      lastFingerprint: initialFingerprint, lastMaterialChangeAt: startedAt,
      materialChangeCount: 0, copiedFingerprint: null, readable: initialFingerprint.status === 'readable' ? 'yes' : 'unknown'
    };
    if (request.baselineSample) state.floatingPreviewBaselineSample = request.baselineSample;
    if (methodTransition) {
      // The controls visible at the click edge still belong to the prior method.
      // Keep them from authorizing the target method while Customily remounts.
      invalidateFloatingPreviewMirror(generation);
      state.imagePreviewReady = false;
    } else if (imageFlow || baseImageFlow) {
      // Images never inherit a verified text, monogram, or prior-upload frame.
      // Keep the old pixels presentation-ineligible until this generation copies
      // a current base-product or uploaded-artwork frame with parity.
      invalidateFloatingPreviewMirror(generation);
      if (imageFlow && confirmedUpload?.ready !== true) state.imagePreviewReady = false;
    } else if (!state.pendingNoUploadImagesSelection) {
      carryForwardVerifiedFloatingPreviewMirror(generation);
    }
    setFloatingPreviewConvergenceStatus('processing');
    syncFloatingPreviewGate();
    sampleFloatingPreviewConvergence(generation);
  }

  function requestFloatingPreviewConvergence(reason = 'customization-change') {
    if (isGuided()) return;
    ensureImageFilterPerformanceObserver();
    const startedAt = performance.now();
    const baselineSample = captureFloatingPreviewDifferenceBaseline();
    const style = chosenStyle();
    if (style !== 'Images') releaseNoUploadImagesTransitionHold({ invalidateToken: true });
    const previousMirrorFingerprint = state.pendingNoUploadImagesPreviousMirrorFingerprint
      || qs('#preview-canvas-popup2')?.dataset.gsFloatingMirrorFingerprint
      || '';
    const previousStyle = state.pendingNoUploadImagesPreviousStyle || '';
    state.pendingNoUploadImagesPreviousMirrorFingerprint = null;
    state.pendingNoUploadImagesPreviousStyle = null;
    // Style changes reach this capture listener before the next paint. Invalidate
    // a no-upload Images mirror immediately so a prior text, monogram, or upload
    // frame cannot remain visible while the coalesced convergence request starts.
    if (style === 'Images' && nativeEditorPopupMobileAllowed() && !hasDefiniteFileAttachment() && !confirmedUploadRecord()) {
      state.pendingNoUploadImagesSelection = true;
      setNoUploadImagesTransitionHold(true);
      invalidateFloatingPreviewMirror();
      syncFloatingPreviewGate();
    }
    const pending = state.floatingPreviewConvergenceRequest;
    state.floatingPreviewConvergenceRequest = {
      reason,
      startedAt: pending ? Math.min(pending.startedAt, startedAt) : startedAt,
      baselineSample: pending?.baselineSample || baselineSample,
      previousMirrorFingerprint: pending?.previousMirrorFingerprint || previousMirrorFingerprint,
      previousStyle: pending?.previousStyle || previousStyle,
      transitionToken: state.pendingNoUploadImagesSelection ? Number(state.noUploadImagesTransitionToken || 0) : 0
    };
    if (state.floatingPreviewConvergenceRaf) return;
    state.floatingPreviewConvergenceRaf = window.requestAnimationFrame(() => {
      state.floatingPreviewConvergenceRaf = 0;
      const request = state.floatingPreviewConvergenceRequest || { reason, startedAt, baselineSample };
      state.floatingPreviewConvergenceRequest = null;
      startFloatingPreviewConvergence(request);
    });
  }

  function closeFloatingPreviewModal() {
    const modal = qs('.gs-floating-preview-modal');
    if (!modal) return;
    modal.classList.remove('is-open', 'is-zoomed', 'hint-faded');
    modal.hidden = true;
    document.documentElement.classList.remove('gs-floating-preview-modal-open');
  }

  // 2026-07-02 image-only adjust-placement CTA: the expanded floating preview
  // renders a mirror/clone, so Customily's native move/resize tools cannot work
  // inside it. For the Images flow only, a small secondary button collapses the
  // preview and returns the shopper to the real image tools on the PDP.
  // Custom Text and Monogram never show it (native image placement tools are
  // irrelevant there), and the whole affordance is progressive-lane only.
  function imageAdjustFlowActive() {
    const html = document.documentElement;
    const style = chosenStyle();
    // A prior Images upload can leave the preview-ready/canvas markers alive after
    // switching to Custom Text. Treat an explicit non-Images style as authoritative
    // so the native image editor never opens outside the Images flow; only fall
    // back to the marker during brief Customily/Vue restamps where style is absent.
    if (style && style !== 'Images') return false;
    const imageFlowMarked = html.dataset.gsProgressiveImageFlow === 'true';
    return !isGuided()
      && html.classList.contains('gs-customily-clubhouse-enabled')
      && (style === 'Images' || (!style && imageFlowMarked))
      // A base-product preview is useful before upload, but move/resize controls
      // are not. Keep editor access bound to a real, converged artwork preview.
      && hasImagePreviewReady();
  }

  function syncAdjustPlacementCtaGate() {
    const active = imageAdjustFlowActive() ? 'true' : 'false';
    if (document.documentElement.dataset.gsProgressiveImageFlow !== active) {
      document.documentElement.dataset.gsProgressiveImageFlow = active;
    }
  }

  function hasLayoutBox(node) {
    if (!node || !node.getBoundingClientRect) return false;
    const rect = node.getBoundingClientRect();
    const css = getComputedStyle(node);
    return rect.width > 12 && rect.height > 12 && css.display !== 'none' && css.visibility !== 'hidden';
  }

  function nativeEditorSurface(options = {}) {
    const medias = qsa('.main-product__media');
    const media = medias.find((candidate) =>
      qs('.cl-canvas-container', candidate)
      || qs('.canvas-container', candidate)
      || qs('#preview-canvas, canvas.lower-canvas', candidate)
      || qs('canvas.upper-canvas, .upper-canvas', candidate)
    ) || medias[0];
    if (!media) return null;
    const clContainer = qs('.cl-canvas-container', media);
    const canvasContainer = qs('.canvas-container', media);
    const previewCanvas = qs('#preview-canvas, canvas.lower-canvas', media);
    const upperCanvas = qs('canvas.upper-canvas, .upper-canvas', media);
    const anchor = clContainer || canvasContainer || previewCanvas;
    if (!anchor || !previewCanvas || !upperCanvas) return null;
    // Opening popup-active can make a wide Customily canvas layoutless for one
    // frame while Fabric remounts it. Initial open still requires a real box;
    // the lifecycle guard only requires the structurally valid native surface.
    if (!options.allowLayoutless
      && !hasLayoutBox(anchor)
      && !hasLayoutBox(previewCanvas)
      && !hasLayoutBox(upperCanvas)) return null;
    return { media, anchor, previewCanvas, upperCanvas };
  }

  function ensureNativeEditorBackdrop() {
    let backdrop = qs('#gs-native-editor-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.id = 'gs-native-editor-backdrop';
      backdrop.setAttribute('role', 'presentation');
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.tabIndex = -1;
      backdrop.style.position = 'fixed';
      backdrop.style.inset = '0';
      backdrop.style.background = 'rgba(15, 12, 8, 0.52)';
      backdrop.style.zIndex = '9997';
      backdrop.style.display = 'none';
      backdrop.style.border = '0';
      backdrop.style.padding = '0';
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }

  function syncNativeEditorBackgroundIsolation(media, backdrop) {
    const recorded = new Set(state.nativeEditorInertRestore.map(({ node }) => node));
    let current = media;
    while (current?.parentElement && current !== document.body) {
      const parent = current.parentElement;
      [...parent.children].forEach((sibling) => {
        if (sibling === current || sibling === backdrop || recorded.has(sibling)) return;
        state.nativeEditorInertRestore.push({ node: sibling, inert: !!sibling.inert });
        recorded.add(sibling);
        sibling.inert = true;
      });
      current = parent;
    }
  }

  function isolateNativeEditorBackground(media, backdrop) {
    state.nativeEditorInertRestore = [];
    syncNativeEditorBackgroundIsolation(media, backdrop);
  }

  function restoreNativeEditorBackground() {
    state.nativeEditorInertRestore.forEach(({ node, inert }) => {
      if (node) node.inert = inert;
    });
    state.nativeEditorInertRestore = [];
  }

  function nativeEditorPopupOpen() {
    return !!qs('.main-product__media.popup-active[data-gs-native-editor-popup-open="true"]');
  }

  function nativeEditorPopupMobileAllowed() {
    return !!window.matchMedia?.('(max-width: 749px)').matches;
  }

  function closeNativeEditorPopup(options = {}) {
    cancelNativeEditorOpenWait();
    if (state.nativeEditorPopupObserver) {
      state.nativeEditorPopupObserver.disconnect();
      state.nativeEditorPopupObserver = null;
    }
    if (state.nativeEditorPopupRaf) {
      cancelAnimationFrame(state.nativeEditorPopupRaf);
      state.nativeEditorPopupRaf = 0;
    }
    if (state.nativeEditorPopupWatchInterval) {
      clearInterval(state.nativeEditorPopupWatchInterval);
      state.nativeEditorPopupWatchInterval = 0;
    }
    const media = qs('.main-product__media.popup-active[data-gs-native-editor-popup-open="true"]') || qs('.main-product__media[data-gs-native-editor-popup-open="true"]');
    if (media) {
      media.classList.remove('popup-active');
      delete media.dataset.gsNativeEditorPopupOpen;
      const restore = state.nativeEditorDialogRestore;
      if (restore) {
        Object.entries(restore).forEach(([name, value]) => {
          if (value === null) media.removeAttribute(name);
          else media.setAttribute(name, value);
        });
      }
    }
    state.nativeEditorDialogRestore = null;
    delete document.documentElement.dataset.gsNativeEditorPopupOpen;
    // The theme's legacy product-media listener can open #popup-backdrop during
    // the same gesture that opens our native-editor surface. Close both overlay
    // owners atomically; otherwise our editor/card state can be correct while the
    // vendor blur remains until the shopper taps it separately.
    qsa('#gs-native-editor-backdrop, #popup-backdrop').forEach((backdrop) => {
      backdrop.style.display = 'none';
      backdrop.setAttribute('aria-hidden', 'true');
    });
    if (state.nativeEditorPreviousBodyOverflow !== null) {
      document.body.style.overflow = state.nativeEditorPreviousBodyOverflow;
      state.nativeEditorPreviousBodyOverflow = null;
    }
    restoreNativeEditorBackground();
    setFloatingPreviewMinimized(!!state.nativeEditorPreviewWasMinimized);
    state.nativeEditorPreviewWasMinimized = false;
    const returnFocus = state.nativeEditorReturnFocus;
    state.nativeEditorReturnFocus = null;
    if (options.restoreFocus === true) {
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
        const replacement = returnFocus?.classList?.contains('gs-floating-preview__adjust')
          ? qs('#preview-main-popup .gs-floating-preview__adjust')
          : (returnFocus?.classList?.contains('gs-floating-preview__expand-bar')
              ? qs('#preview-main-popup .gs-floating-preview__expand-bar')
              : null);
        const target = [returnFocus, replacement, qs('#preview-main-popup .gs-floating-preview__expand-bar'), qs('#preview-main-popup .gs-floating-preview__minimize')]
          .find((node) => node?.isConnected && !node.disabled && visible(node));
        target?.focus?.({ preventScroll: true });
      }));
    }
  }

  function ensureNativeEditorMinimizeControl(surface) {
    if (!surface?.media) return null;
    let button = qs('.gs-native-editor__minimize', surface.media);
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'gs-native-editor__minimize';
      button.setAttribute('aria-label', 'Minimize image editor');
      button.dataset.gsNativeEditorAction = 'collapse';
      button.innerHTML = '<svg viewBox="0 0 24 24" width="23" height="23" aria-hidden="true" focusable="false"><path d="m5.5 8.5 6.5 6.5 6.5-6.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      surface.media.appendChild(button);
    }
    if (button.dataset.gsNativeEditorMinimizeBound !== 'true') {
      button.dataset.gsNativeEditorMinimizeBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        closeNativeEditorPopup({ restoreFocus: true });
      }, true);
    }
    return button;
  }

  function scheduleNativeEditorPopupGuard(surface) {
    if (state.nativeEditorPopupRaf) return;
    state.nativeEditorPopupRaf = requestAnimationFrame(() => {
      state.nativeEditorPopupRaf = 0;
      const mediaStillOpen = surface?.media?.isConnected
        && surface.media.classList?.contains('popup-active')
        && surface.media.dataset.gsNativeEditorPopupOpen === 'true';
      const currentSurface = nativeEditorSurface({ allowLayoutless: true });
      if (!mediaStillOpen || !currentSurface || currentSurface.media !== surface.media) {
        closeNativeEditorPopup({ restoreFocus: true });
        return;
      }
      // Fabric may replace its lower/upper canvases during a valid remount. The
      // media owner stays stable; ensure all Polar/native controls stay bound.
      ensureNativeEditorMinimizeControl(currentSurface);
      bindNativeEditorVendorCloseControls(currentSurface.media);
      syncNativeEditorBackgroundIsolation(currentSurface.media, qs('#gs-native-editor-backdrop'));
    });
  }

  function bindNativeEditorVendorCloseControls(media) {
    if (!media || media.dataset.gsNativeEditorCloseDelegated === 'true') return;
    media.dataset.gsNativeEditorCloseDelegated = 'true';
    media.addEventListener('click', (event) => {
      if (!event.target?.closest?.('.customily-close-button')) return;
      window.setTimeout(() => closeNativeEditorPopup({ restoreFocus: true }), 0);
    }, true);
  }

  function bindNativeEditorPopupClose(surface, backdrop) {
    if (backdrop && backdrop.dataset.gsNativeEditorBackdropBound !== 'true') {
      backdrop.dataset.gsNativeEditorBackdropBound = 'true';
      backdrop.addEventListener('click', () => closeNativeEditorPopup({ restoreFocus: true }));
    }
    if (document.documentElement.dataset.gsNativeEditorEscapeBound !== 'true') {
      document.documentElement.dataset.gsNativeEditorEscapeBound = 'true';
      document.addEventListener('keydown', (event) => {
        if (!nativeEditorPopupOpen()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeNativeEditorPopup({ restoreFocus: true });
          return;
        }
        if (event.key !== 'Tab') return;
        const media = qs('.main-product__media.popup-active[data-gs-native-editor-popup-open="true"]');
        const focusable = qsa('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', media)
          .filter((node) => visible(node) && node.getAttribute('aria-hidden') !== 'true');
        if (!focusable.length) {
          event.preventDefault();
          media?.focus?.({ preventScroll: true });
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const activeOutside = !media?.contains(document.activeElement);
        if (activeOutside || (!event.shiftKey && document.activeElement === last)) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        }
      });
    }
    if (document.documentElement.dataset.gsNativeEditorResizeBound !== 'true') {
      document.documentElement.dataset.gsNativeEditorResizeBound = 'true';
      window.addEventListener('resize', () => {
        if (nativeEditorPopupOpen() && !nativeEditorPopupMobileAllowed()) closeNativeEditorPopup({ restoreFocus: true });
      }, { passive: true });
    }
    if (state.nativeEditorPopupObserver) state.nativeEditorPopupObserver.disconnect();
    state.nativeEditorPopupObserver = new MutationObserver(() => scheduleNativeEditorPopupGuard(surface));
    state.nativeEditorPopupObserver.observe(surface.media, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
    if (surface.media.parentElement) {
      state.nativeEditorPopupObserver.observe(surface.media.parentElement, { childList: true });
    }
    bindNativeEditorVendorCloseControls(surface.media);
    ensureNativeEditorMinimizeControl(surface);
    if (state.nativeEditorPopupWatchInterval) clearInterval(state.nativeEditorPopupWatchInterval);
    state.nativeEditorPopupWatchInterval = window.setInterval(() => scheduleNativeEditorPopupGuard(surface), 350);
    scheduleNativeEditorPopupGuard(surface);
  }

  function openNativeEditorPopup(event) {
    // Uploaded Images use one readiness-gated expanded owner: Customily's real
    // Fabric surface. Text/Monogram can still use the mirrored preview because
    // they do not expose image placement controls.
    const surface = nativeEditorSurface();
    if (nativeEditorPopupOpen()) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }
      return true;
    }
    if (!nativeEditorPopupMobileAllowed() || !surface || !imageAdjustFlowActive()) return false;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    setFloatingPreviewExpanded(false);
    state.nativeEditorPreviewWasMinimized = document.documentElement.dataset.gsProgressiveFloatingPreviewMinimized === 'true';
    setFloatingPreviewMinimized(true);
    const preview = qs('#preview-main-popup');
    if (preview) {
      preview.style.removeProperty('--gs-floating-preview-zoom-origin-x');
      preview.style.removeProperty('--gs-floating-preview-zoom-origin-y');
      syncFloatingPreviewExpandText(preview);
    }
    closeFloatingPreviewModal();
    const backdrop = ensureNativeEditorBackdrop();
    backdrop.setAttribute('aria-hidden', 'true');
    if (state.nativeEditorPreviousBodyOverflow === null) {
      state.nativeEditorPreviousBodyOverflow = document.body.style.overflow || '';
    }
    state.nativeEditorReturnFocus = event?.currentTarget instanceof Element
      ? event.currentTarget
      : document.activeElement;
    state.nativeEditorDialogRestore = {
      role: surface.media.getAttribute('role'),
      'aria-modal': surface.media.getAttribute('aria-modal'),
      'aria-label': surface.media.getAttribute('aria-label'),
      tabindex: surface.media.getAttribute('tabindex')
    };
    surface.media.setAttribute('role', 'dialog');
    surface.media.setAttribute('aria-modal', 'true');
    surface.media.setAttribute('aria-label', 'Resize and move image placement');
    surface.media.setAttribute('tabindex', '-1');
    surface.media.classList.add('popup-active');
    surface.media.dataset.gsNativeEditorPopupOpen = 'true';
    document.documentElement.dataset.gsNativeEditorPopupOpen = 'true';
    backdrop.style.display = 'block';
    document.body.style.overflow = 'hidden';
    isolateNativeEditorBackground(surface.media, backdrop);
    clearNativeEditorAnnouncement();
    bindNativeEditorPopupClose(surface, backdrop);
    window.requestAnimationFrame(() => ensureNativeEditorMinimizeControl(surface)?.focus?.({ preventScroll: true }));
    return true;
  }

  function adjustPlacementDestination() {
    // Asher correction 2026-07-02: the native placement tools are acceptable.
    // The CTA's job is to take the shopper back UP to the actual product image /
    // native Customily placement surface, not down to the upload block. Prefer
    // product-media containers even when they are above the viewport; only fall
    // back to the form controls if the media surface cannot be found.
    const mediaSelectors = [
      '.main-product__media.popup-active',
      '.main-product__media:has(#preview-main-popup)',
      '.main-product__media:has(#preview-canvas-popup2)',
      '.main-product__media:has(canvas)',
      '.product__media:has(canvas)',
      '.product__media-wrapper:has(canvas)',
      'product-media:has(canvas)',
      '.main-product__media',
      '.product__media-wrapper',
      '.product__media',
      'product-media'
    ];
    const mediaTarget = mediaSelectors.map((selector) => {
      try { return qs(selector); } catch (_) { return null; }
    }).find(hasLayoutBox);
    if (mediaTarget) return mediaTarget;

    const floatingPreview = qs('#preview-main-popup');
    const previewMedia = floatingPreview?.closest?.('.main-product__media, .product__media, .product__media-wrapper, product-media');
    if (previewMedia && hasLayoutBox(previewMedia)) return previewMedia;

    const nativePreview = qs('#preview-canvas-popup2, #preview-canvas-popup, #cloned-canvas2, #cloned-canvas');
    const nativeMedia = nativePreview?.closest?.('.main-product__media, .product__media, .product__media-wrapper, product-media');
    if (nativeMedia && hasLayoutBox(nativeMedia)) return nativeMedia;

    const upload = qs('[data-gs-progressive-role="upload"]');
    if (upload && visible(upload)) return upload;
    const fileGroup = allFileInputs()
      .map((input) => input.closest('.customily_option') || input.parentElement)
      .find((group) => group && visible(group));
    if (fileGroup) return fileGroup;
    const method = qs('[data-gs-progressive-role="method"]');
    if (method && visible(method)) return method;
    return customilyRoot();
  }

  function scrollToAdjustPlacementDestination(target) {
    if (!target?.getBoundingClientRect) return;
    const header = qs('sticky-header, .shopify-section-header-sticky, .section-header, header[role="banner"], header');
    const headerRect = header?.getBoundingClientRect?.();
    const headerOffset = headerRect && headerRect.height > 0 && headerRect.bottom > 0 ? Math.min(96, Math.round(headerRect.height)) : 0;
    const previewBarOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gs-shopify-preview-bar-offset'), 10) || 0;
    const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - previewBarOffset - 12;
    window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: 'smooth' });
  }

  function clearAdjustPlacementHighlight() {
    window.clearTimeout(state.adjustPlacementHighlightTimer);
    state.adjustPlacementHighlightTimer = 0;
    qsa('[data-gs-adjust-placement-highlight="true"]').forEach((node) => {
      delete node.dataset.gsAdjustPlacementHighlight;
    });
  }

  function announceNativeEditorUnavailable(message = 'Image placement tools are taking longer than expected. Please wait a moment and try again.') {
    let region = qs('[data-gs-native-editor-announcement]');
    if (!region) {
      region = document.createElement('span');
      region.className = 'visually-hidden';
      region.dataset.gsNativeEditorAnnouncement = 'true';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }
    region.textContent = '';
    window.requestAnimationFrame(() => {
      region.textContent = message;
    });
  }

  function clearNativeEditorAnnouncement() {
    const region = qs('[data-gs-native-editor-announcement]');
    if (region) region.textContent = '';
  }

  function stampExpandedRoute(route) {
    document.documentElement.dataset.gsExpandedRoute = route;
  }

  function cancelNativeEditorOpenWait() {
    const wait = state.nativeEditorOpenWait;
    if (!wait) return;
    if (wait.interval) window.clearInterval(wait.interval);
    if (wait.timeout) window.clearTimeout(wait.timeout);
    wait.observer?.disconnect?.();
    state.nativeEditorOpenWait = null;
  }

  function requestNativeEditorOpen(event) {
    if (openNativeEditorPopup(event)) {
      stampExpandedRoute('native-editor');
      return true;
    }
    cancelNativeEditorOpenWait();
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    const wait = { startedAt: performance.now(), nudged: false, interval: 0, timeout: 0, observer: null };
    state.nativeEditorOpenWait = wait;
    document.documentElement.dataset.gsNudge = '0';
    document.documentElement.dataset.gsNudgeGeneration = '';
    stampExpandedRoute('blocked-processing');
    const attempt = () => {
      if (state.nativeEditorOpenWait !== wait) return;
      if (chosenStyle() !== 'Images' || confirmedUploadRecord()?.ready !== true) {
        cancelNativeEditorOpenWait();
        return;
      }
      if (openNativeEditorPopup()) {
        stampExpandedRoute('native-editor-waited');
        cancelNativeEditorOpenWait();
        return;
      }
      if (!wait.nudged && performance.now() - wait.startedAt >= 700) {
        wait.nudged = true;
        const method = qsa(IMAGE_METHOD_SELECTOR).find((input) => input.checked);
        const generationBefore = Number(state.floatingPreviewConvergenceGeneration || 0);
        if (method) {
          const nudgeEvent = new Event('change', { bubbles: true });
          Object.defineProperty(nudgeEvent, '__gsSurfaceNudge', { value: true });
          method.dispatchEvent(nudgeEvent);
        }
        const generationAfter = Number(state.floatingPreviewConvergenceGeneration || 0);
        document.documentElement.dataset.gsNudge = '1';
        document.documentElement.dataset.gsNudgeGeneration = `${generationBefore}:${generationAfter}`;
      }
    };
    wait.interval = window.setInterval(attempt, 50);
    const observeRoot = qs('.main-product__media')?.parentElement || document.body;
    wait.observer = new MutationObserver(attempt);
    wait.observer.observe(observeRoot, { childList: true, subtree: true });
    wait.timeout = window.setTimeout(() => {
      if (state.nativeEditorOpenWait !== wait) return;
      stampExpandedRoute(`blocked-surface-timeout:${wait.nudged ? 'nudged' : 'unnudged'}`);
      cancelNativeEditorOpenWait();
      announceNativeEditorUnavailable();
    }, 2100);
    attempt();
    return true;
  }

  function openReadyImageEditorOrBlock(event) {
    const style = chosenStyle();
    if (style !== 'Images') {
      stampExpandedRoute('mirror-non-image');
      return false;
    }
    const confirmed = confirmedUploadRecord();
    if (!confirmed) {
      if (hasFileAttached()) {
        stampExpandedRoute('blocked-processing');
        announceNativeEditorUnavailable('Your uploaded image is still processing. Please wait a moment.');
        return true;
      }
      stampExpandedRoute('mirror-no-upload');
      return false;
    }
    if (confirmed.ready !== true && !hasImagePreviewReady()) {
      stampExpandedRoute('blocked-processing');
      announceNativeEditorUnavailable('Your uploaded image is still processing. Please wait a moment.');
      return true;
    }
    return requestNativeEditorOpen(event);
  }

  function handleAdjustPlacementAction(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (openReadyImageEditorOrBlock(event)) return;
    const preview = qs('#preview-main-popup');
    // Collapse out of expanded/zoomed state and clear zoom/pan leftovers so the
    // next expand starts clean.
    setFloatingPreviewExpanded(false);
    if (preview) {
      preview.style.removeProperty('--gs-floating-preview-zoom-origin-x');
      preview.style.removeProperty('--gs-floating-preview-zoom-origin-y');
      syncFloatingPreviewExpandText(preview);
    }
    closeFloatingPreviewModal();
    const target = adjustPlacementDestination();
    if (!target) return;
    scrollToAdjustPlacementDestination(target);
    // Temporary highlight so the shopper understands why the page moved.
    clearAdjustPlacementHighlight();
    target.dataset.gsAdjustPlacementHighlight = 'true';
    state.adjustPlacementHighlightTimer = window.setTimeout(clearAdjustPlacementHighlight, 2100);
  }

  function ensureFloatingPreviewControls() {
    if (isGuided()) return;
    ensurePreviewSurfaceStyles();
    const preview = qs('#preview-main-popup');
    if (preview) {
      let minimize = qs('.gs-floating-preview__minimize', preview);
      if (!minimize) {
        minimize = document.createElement('button');
        minimize.type = 'button';
        minimize.className = 'gs-floating-preview__minimize';
        minimize.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (state.floatingPreviewExpanded) {
            setFloatingPreviewViewState('collapsed', { reason: 'expanded-chevron-minimize' });
          } else {
            setFloatingPreviewMinimized(true);
            window.requestAnimationFrame(() => qs('.gs-floating-preview-restore')?.focus?.({ preventScroll: true }));
          }
        });
        preview.appendChild(minimize);
      }
      syncFloatingPreviewMinimizeControl(preview);

      // Customily can render multiple native expand labels. Keep one Polar-owned
      // collapsed-card action and a separate expanded zoom toolbar.
      qsa('.canvas-expand-label', preview).forEach((label) => {
        if (label.dataset.gsFloatingNativeExpandHidden === 'true') return;
        label.dataset.gsFloatingNativeExpandHidden = 'true';
        label.setAttribute('aria-hidden', 'true');
        label.style.setProperty('display', 'none', 'important');
        label.style.setProperty('visibility', 'hidden', 'important');
        label.style.setProperty('pointer-events', 'none', 'important');
      });
      let expand = qs('.gs-floating-preview__expand-bar', preview);
      if (!expand) {
        expand = document.createElement('button');
        expand.type = 'button';
        expand.className = 'gs-floating-preview__expand-bar';
        preview.appendChild(expand);
      }
      syncFloatingPreviewExpandText(preview);
      if (expand && !expand.__gsFloatingPreviewBound) {
        // Cloned DOM keeps data-* attributes but not event listeners. A
        // non-serialized property guarantees a replacement node is rebound.
        expand.__gsFloatingPreviewBound = true;
        const open = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          if (openReadyImageEditorOrBlock(event)) return;
          setFloatingPreviewMinimized(false);
          if (!state.floatingPreviewExpanded) {
            setFloatingPreviewViewState('fit', { reason: 'expand-control' });
            window.requestAnimationFrame(() => qs('#preview-main-popup .gs-floating-preview__minimize')?.focus?.({ preventScroll: true }));
          } else cycleFloatingPreviewZoomAt();
          closeFloatingPreviewModal();
        };
        expand.addEventListener('click', open, true);
      }

      let zoomControls = qs('.gs-floating-preview__zoom-controls', preview);
      if (!zoomControls) {
        zoomControls = document.createElement('div');
        zoomControls.className = 'gs-floating-preview__zoom-controls';
        zoomControls.setAttribute('aria-label', 'Preview zoom controls');
        zoomControls.innerHTML = `
          <button type="button" data-gs-floating-zoom-out aria-label="Zoom out">−</button>
          <output data-gs-floating-zoom-level aria-hidden="true">100%</output>
          <button type="button" data-gs-floating-zoom-in aria-label="Zoom in">+</button>
          <button type="button" data-gs-floating-zoom-reset aria-label="Fit preview">Fit</button>
          <span class="visually-hidden" id="gs-floating-preview-zoom-instructions">Tap the image to zoom where you point. Drag or pinch to inspect. Keyboard: use plus or minus to zoom, arrow keys to move, and zero or Home to fit.</span>
          <span class="visually-hidden" data-gs-floating-zoom-announcement aria-live="polite" aria-atomic="true">Zoom 100 percent</span>
        `;
        preview.appendChild(zoomControls);
      }

      if (!qs('.gs-floating-preview__adjust', preview)) {
        const adjust = document.createElement('button');
        adjust.type = 'button';
        adjust.className = 'gs-floating-preview__adjust';
        adjust.setAttribute('aria-label', 'Resize and move image placement');
        adjust.innerHTML = '<span class="gs-floating-preview__adjust-icon" aria-hidden="true">✎</span><span>Resize &amp; Move</span>';
        adjust.addEventListener('click', handleAdjustPlacementAction, true);
        preview.appendChild(adjust);
      }
      bindFloatingPreviewZoomPan(preview);
    }
    let restore = qs('.gs-floating-preview-restore');
    if (!restore) {
      restore = document.createElement('button');
      restore.type = 'button';
      restore.className = 'gs-floating-preview-restore';
      restore.setAttribute('aria-label', 'Show preview');
      restore.textContent = 'Preview';
      restore.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setFloatingPreviewMinimized(false);
        setFloatingPreviewExpanded(false);
        syncFloatingPreviewExpandText();
        window.requestAnimationFrame(() => qs('#preview-main-popup .gs-floating-preview__minimize')?.focus?.({ preventScroll: true }));
      });
      document.body.appendChild(restore);
    }
  }

  function expandedPopup() {
    return qs('.main-product__media.popup-active, [id^="MediaGallery"].popup-active');
  }

  function setExpandedPopupZoomed(popup, zoomed, event) {
    if (!popup) return;
    state.expandedPopupZoomed = !!zoomed;
    popup.classList.toggle('gs-popup-zoomed', state.expandedPopupZoomed);
    if (event) {
      const rect = popup.getBoundingClientRect();
      const x = rect.width ? clamp(((event.clientX - rect.left) / rect.width) * 100, 12, 88) : 50;
      const y = rect.height ? clamp(((event.clientY - rect.top) / rect.height) * 100, 12, 88) : 50;
      popup.style.setProperty('--gs-popup-zoom-origin-x', `${x}%`);
      popup.style.setProperty('--gs-popup-zoom-origin-y', `${y}%`);
    }
    const button = qs('.gs-popup-zoom-toggle', popup);
    if (button) {
      button.textContent = state.expandedPopupZoomed ? 'Reset zoom' : 'Tap to zoom';
      button.setAttribute('aria-pressed', state.expandedPopupZoomed ? 'true' : 'false');
    }
  }

  function syncExpandedPopupFixes() {
    qsa('.gs-popup-zoom-toggle').forEach((button) => button.remove());
    qsa('.gs-popup-zoomed').forEach((node) => node.classList.remove('gs-popup-zoomed'));
    state.expandedPopupZoomed = false;
    return;
    ensurePreviewSurfaceStyles();
    const popup = expandedPopup();
    if (!popup) return;
    qsa('.main-product__media--features, product-media-info, .product__media--info, .product__media--info-marquee, [class*="badge"]', popup).forEach((node) => {
      node.dataset.gsPopupSuppressed = 'true';
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
    });
    qsa('button, a, div, span, p, strong, em', popup).forEach((node) => {
      if (node.classList?.contains('gs-popup-zoom-toggle')) return;
      const text = norm(node.textContent);
      const className = String(node.className || '');
      if (/badge|media-info|feat-media-info/i.test(className) || /^top\s*seller$/i.test(text)) {
        node.dataset.gsPopupSuppressed = 'true';
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
      }
      if (text.length <= 32 && /click\s*here\s*to\s*zoom/i.test(text)) {
        node.dataset.gsNativeZoomSuppressed = 'true';
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
      }
    });
    if (!qs('.gs-popup-zoom-toggle', popup)) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gs-popup-zoom-toggle';
      button.textContent = 'Tap to zoom';
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setExpandedPopupZoomed(popup, !popup.classList.contains('gs-popup-zoomed'), event);
      });
      popup.appendChild(button);
    }
  }

  function syncImageMethodOrder() {
    const root = customilyRoot();
    if (!root || isTeeAdapter()) return;
    ensureImageMethodOrderStyles();
    qsa(IMAGE_METHOD_SELECTOR, root).forEach((input) => {
      const meta = METHOD_META[input.value] || { title: input.value, order: 9 };
      const order = String(meta.order || 9);
      const targets = new Set([
        cardFor(input),
        labelFor(input),
        input.closest('.customily-swatch'),
        input.closest('.swatch'),
        input.closest('.swatch-container > *')
      ].filter(Boolean));
      setDatasetIfChanged(input, 'gsImageMethodTitle', meta.title);
      setDatasetIfChanged(input, 'gsImageMethodOrder', order);
      targets.forEach((card) => {
        setDatasetIfChanged(card, 'gsImageMethodTitle', meta.title);
        setDatasetIfChanged(card, 'gsImageMethodOrder', order);
        setStyleIfChanged(card, 'order', order);
      });
      const displayTitle = meta.title;
      const applyMobileMethodLayout = (targetLabel, targetLabelText) => {
        if (!targetLabel || !targetLabelText) return;
        const isCompactMobile = !!window.matchMedia?.('(max-width: 749px)').matches;
        if (!isCompactMobile) {
          // Only remove geometry that this function previously stamped while
          // the same label was mobile. Desktop/intermediate geometry belongs to
          // syncClubhouseTileIconGeometry(). Unconditionally stripping it here
          // made the delayed title/restamp timers alternate every method card
          // between the 42px contained state and the 59px wide-desktop state.
          if (targetLabel.dataset.gsMobileMethodLayout !== 'true') return;
          ['display', 'grid-template-columns', 'grid-template-rows', 'column-gap', 'row-gap', 'align-items', 'justify-content', 'justify-items', 'height', 'min-height', 'padding', 'text-align'].forEach((property) => removeStyleIfPresent(targetLabel, property));
          const staleIconBox = targetLabel.querySelector('.csh-image-container');
          ['grid-column', 'grid-row', 'align-self', 'justify-self', 'width', 'height', 'min-width', 'min-height', 'max-width', 'max-height'].forEach((property) => removeStyleIfPresent(staleIconBox, property));
          ['grid-column', 'grid-row', 'align-self', 'justify-self', 'width', 'font-size', 'line-height', 'margin-top', 'white-space', 'overflow', 'word-break', 'overflow-wrap', 'text-align', 'color'].forEach((property) => removeStyleIfPresent(targetLabelText, property));
          const staleImage = targetLabel.querySelector('img');
          ['grid-column', 'grid-row', 'align-self', 'justify-self', 'width', 'height', 'min-width', 'min-height', 'max-width', 'max-height', 'padding', 'object-fit', 'transform'].forEach((property) => removeStyleIfPresent(staleImage, property));
          delete targetLabel.dataset.gsMobileMethodLayout;
          return;
        }
        targetLabel.dataset.gsMobileMethodLayout = 'true';
        const checked = !!input.checked;
        // Mobile-only horizontal pill orientation. Desktop method cards are left
        // to their existing rules. This also re-applies selected styling after
        // Customily's late Vue repaint, which was overriding BG Remove.
        setStyleIfChanged(targetLabel, 'display', 'grid');
        setStyleIfChanged(targetLabel, 'grid-template-columns', '54px minmax(0, 1fr)');
        setStyleIfChanged(targetLabel, 'grid-template-rows', 'auto');
        setStyleIfChanged(targetLabel, 'column-gap', '10px');
        setStyleIfChanged(targetLabel, 'row-gap', '0');
        setStyleIfChanged(targetLabel, 'align-items', 'center');
        setStyleIfChanged(targetLabel, 'justify-content', 'start');
        setStyleIfChanged(targetLabel, 'justify-items', 'start');
        setStyleIfChanged(targetLabel, 'overflow', 'visible');
        setStyleIfChanged(targetLabel, 'box-sizing', 'border-box');
        setStyleIfChanged(targetLabel, 'height', '76px');
        setStyleIfChanged(targetLabel, 'min-height', '76px');
        setStyleIfChanged(targetLabel, 'padding', '10px 12px');
        setStyleIfChanged(targetLabel, 'text-align', 'left');
        setStyleIfChanged(targetLabel, 'border-style', 'solid');
        setStyleIfChanged(targetLabel, 'border-width', checked ? '2px' : '1px');
        setStyleIfChanged(targetLabel, 'border-color', checked ? '#D0B985' : '#E7E7E7');
        setStyleIfChanged(targetLabel, 'background-color', '#FFFFFF');
        const iconBox = targetLabel.querySelector('.csh-image-container');
        if (iconBox) {
          setStyleIfChanged(iconBox, 'grid-column', '1');
          setStyleIfChanged(iconBox, 'grid-row', '1');
          setStyleIfChanged(iconBox, 'align-self', 'center');
          setStyleIfChanged(iconBox, 'justify-self', 'start');
          setStyleIfChanged(iconBox, 'width', '54px');
          setStyleIfChanged(iconBox, 'height', '54px');
          setStyleIfChanged(iconBox, 'min-width', '54px');
          setStyleIfChanged(iconBox, 'min-height', '54px');
          setStyleIfChanged(iconBox, 'max-width', '54px');
          setStyleIfChanged(iconBox, 'max-height', '54px');
        }
        setStyleIfChanged(targetLabelText, 'grid-column', '2');
        setStyleIfChanged(targetLabelText, 'grid-row', '1');
        setStyleIfChanged(targetLabelText, 'align-self', 'center');
        setStyleIfChanged(targetLabelText, 'justify-self', 'start');
        setStyleIfChanged(targetLabelText, 'width', '100%');
        setStyleIfChanged(targetLabelText, 'font-size', '14px');
        setStyleIfChanged(targetLabelText, 'line-height', '1.12');
        setStyleIfChanged(targetLabelText, 'margin-top', '0');
        setStyleIfChanged(targetLabelText, 'white-space', 'normal');
        setStyleIfChanged(targetLabelText, 'overflow', 'visible');
        setStyleIfChanged(targetLabelText, 'word-break', 'normal');
        setStyleIfChanged(targetLabelText, 'overflow-wrap', 'normal');
        setStyleIfChanged(targetLabelText, 'text-align', 'left');
        setStyleIfChanged(targetLabelText, 'color', checked ? '#151515' : '#565656');
        const img = targetLabel.querySelector('img');
        if (img) {
          // Standard products keep the icon inside .csh-image-container, while
          // both drinkware adapters mount the provided icon directly under the
          // label. Explicitly own the direct-image grid cell so the browser does
          // not create a third implicit column that collapses/overlaps the copy.
          if (img.parentElement === targetLabel) {
            setStyleIfChanged(img, 'grid-column', '1');
            setStyleIfChanged(img, 'grid-row', '1');
            setStyleIfChanged(img, 'align-self', 'center');
            setStyleIfChanged(img, 'justify-self', 'start');
          }
          setStyleIfChanged(img, 'width', '54px');
          setStyleIfChanged(img, 'height', '54px');
          setStyleIfChanged(img, 'min-width', '54px');
          setStyleIfChanged(img, 'min-height', '54px');
          setStyleIfChanged(img, 'max-width', '54px');
          setStyleIfChanged(img, 'max-height', '54px');
          setStyleIfChanged(img, 'padding', '7px');
          setStyleIfChanged(img, 'object-fit', 'contain');
          setStyleIfChanged(img, 'transform', 'none');
        }
      };
      const syncDisplayTitle = () => {
        // Customily/Vue can replace the label node after a click. Re-resolve the
        // current label/text every time instead of closing over a stale .label-txt;
        // this is the BG Remove stability fix.
        const freshLabel = labelFor(input);
        const freshLabelText = freshLabel?.querySelector?.('.label-txt');
        if (freshLabelText && freshLabelText.textContent !== displayTitle) freshLabelText.textContent = displayTitle;
        if (freshLabelText) {
          setDatasetIfChanged(freshLabelText, 'gsImageMethodTitle', displayTitle);
          if (freshLabelText.dataset.gsImageMethodTitleObserver !== '1') {
            freshLabelText.dataset.gsImageMethodTitleObserver = '1';
            const titleObserver = new MutationObserver(() => {
              if (freshLabelText.textContent !== displayTitle) freshLabelText.textContent = displayTitle;
              applyMobileMethodLayout(freshLabel, freshLabelText);
            });
            titleObserver.observe(freshLabelText, { childList: true, characterData: true, subtree: true });
          }
        }
        if (freshLabel) {
          const checked = !!input.checked;
          setAttrIfChanged(freshLabel, 'data-gs-image-method-title', displayTitle);
          setAttrIfChanged(freshLabel, 'aria-label', displayTitle);
          setAttrIfChanged(freshLabel, 'title', displayTitle);
          setStyleIfChanged(freshLabel, 'position', 'relative');
          setStyleIfChanged(freshLabel, 'overflow', 'visible');
          setStyleIfChanged(freshLabel, 'box-sizing', 'border-box');
          setStyleIfChanged(freshLabel, 'background-color', '#FFFFFF');
          setStyleIfChanged(freshLabel, 'border-style', 'solid');
          setStyleIfChanged(freshLabel, 'border-width', checked ? '2px' : '1px');
          setStyleIfChanged(freshLabel, 'border-color', checked ? '#D0B985' : '#E7E7E7');
          setStyleIfChanged(freshLabel, 'box-shadow', 'none');
        }
        applyMobileMethodLayout(freshLabel, freshLabelText);
        return { freshLabel, freshLabelText };
      };
      const { freshLabel: label, freshLabelText: labelText } = syncDisplayTitle();
      // Customily/Vue can repaint the native label text/style after our role/order
      // stamp. Restamp through the known repaint windows so the shopper-visible
      // label settles as BG Remove without changing the underlying input value.
      if (labelText) {
        window.requestAnimationFrame(syncDisplayTitle);
        [120, 300, 520, 900, 1350, 1900, 2600, 3600, 5000].forEach((delay) => window.setTimeout(syncDisplayTitle, delay));
      }
    });
  }

  function hardenProgressiveFontMedia() {
    const root = customilyRoot();
    if (!root || isGuided()) return;
    const names = Object.keys(PROGRESSIVE_OPTION_ORDERS || {});
    names.forEach((name) => {
      qsa(`input[type="radio"][name="${name}"]`, root).forEach((input) => {
        const label = labelFor(input);
        const card = cardFor(input) || input.closest('.customily-swatch');
        if (!label) return;
        setAttrIfChanged(label, 'data-gs-option-value', input.value || '');
        const img = label.querySelector('img');
        if (!img) return;
        setAttrIfChanged(img, 'loading', 'eager');
        setAttrIfChanged(img, 'decoding', 'sync');
        setAttrIfChanged(img, 'alt', input.value || '');
        const swatchState = img.closest('.csh-image-container')?.dataset.gsSwatchState || '';
        if (['loading', 'retained', 'error'].includes(swatchState)) {
          setStyleIfChanged(img, 'visibility', 'hidden');
          setStyleIfChanged(img, 'opacity', '0');
        } else {
          setStyleIfChanged(img, 'visibility', 'visible');
          removeStyleIfPresent(img, 'opacity');
          setStyleIfChanged(img, 'display', 'block');
        }
        const src = img.currentSrc || img.src || img.getAttribute('src');
        if (src && !state.preloadedFontImages.has(src)) {
          state.preloadedFontImages.add(src);
          const pre = new Image();
          pre.decoding = 'sync';
          pre.src = src;
        }
        if (card) setDatasetIfChanged(card, 'gsFontMediaReady', img.complete && img.naturalWidth > 8 ? 'true' : 'loading');
      });
    });
  }

  function renderStatusRail() {
    if (!state.statusHost) return;
    const style = chosenStyle();
    const method = chosenImageMethod();
    const rows = [
      ['Path', style || 'Choose one'],
      ['Method', style === 'Images' ? (method || 'Choose method') : (style ? 'Not needed' : 'Pending')],
      ['Artwork', style === 'Images' ? (hasFileAttached() ? 'Uploaded' : 'Needed') : (style ? 'Handled below' : 'Pending')]
    ];
    if (style === 'Images' && consentRequired()) rows.push(['Rights', consentChecked() ? 'Confirmed' : 'Required']);
    state.statusHost.innerHTML = rows.map(([key, value]) => `
      <span class="gs-shell-status__item${/Needed|Required|Choose|Pending/.test(value) ? '' : ' is-done'}">
        <span class="gs-shell-status__key">${escapeHtml(key)}</span>
        <span class="gs-shell-status__value">${escapeHtml(value)}</span>
      </span>
    `).join('');
  }

  // ---- Live preview: mirror genuine Customily output when available. ----
  function syncPreview() {
    if (!state.previewHost) return;
    const canvas = previewCanvas();
    const body = state.previewHost.querySelector('.gs-shell-preview__body');
    const attached = hasFileAttached();
    if (chosenStyle() === 'Images' && !attached) {
      body.querySelector('img.gs-shell-preview__img')?.remove();
      body.classList.remove('has-preview');
      return;
    }
    const uploadedImg = uploadedPreviewImage();
    const img = body.querySelector('img.gs-shell-preview__img') || document.createElement('img');
    img.className = 'gs-shell-preview__img';
    if (uploadedImg && uploadedImg.src) {
      img.src = uploadedImg.src;
      if (!img.parentElement) body.appendChild(img);
      body.classList.add('has-preview');
      return;
    }
    if (canvas && !body.contains(canvas) && !canvas.dataset.gsGuidedPreview) {
      // Snapshot only when the browser allows it; Customily canvases may be tainted.
      try {
        const data = canvas.toDataURL ? canvas.toDataURL('image/png') : '';
        if (data) { img.src = data; if (!img.parentElement) body.appendChild(img); body.classList.add('has-preview'); }
      } catch (_) {}
    }
  }

  function syncShopifyPreviewBarOffset() {
    const candidates = qsa('#PBarNextFrameWrapper, [id*="PBar"], iframe[src*="preview_bar"], iframe[title*="preview" i]');
    let height = 0;
    candidates.forEach((node) => {
      const rect = node.getBoundingClientRect?.();
      const css = getComputedStyle(node);
      if (!rect || css.display === 'none' || css.visibility === 'hidden' || rect.width <= 20 || rect.height <= 8) return;
      if (rect.top < (window.innerHeight || 0) * 0.72) return;
      height = Math.max(height, Math.min(72, Math.round(rect.height)));
    });
    document.documentElement.style.setProperty('--gs-shopify-preview-bar-offset', `${height}px`);
  }

  function hasVisualPreviewSurface() {
    const preview = qs('#preview-main-popup');
    const holder = qs('#preview-canvas-popup2') || preview;
    const media = holder ? qs('canvas.gs-floating-preview__canvas-mirror', holder) : null;
    // CSS intentionally hides this holder until visual-ready + active are true.
    // Readiness therefore comes from the authoritative synchronized mirror,
    // never from presentation geometry or an arbitrary stale canvas/image.
    if (!preview || !holder || !media?.isConnected || !media.width || !media.height) return false;
    const generation = state.floatingPreviewConvergence?.generation || state.floatingPreviewConvergenceGeneration || 0;
    if (holder.dataset.gsFloatingMirrorReady !== 'true'
      || holder.dataset.gsFloatingMirrorGeneration !== String(generation)
      || !holder.dataset.gsFloatingMirrorFingerprint) return false;
    const mirrorFingerprint = sampledCanvasFingerprint(media);
    return mirrorFingerprint.status === 'readable'
      && mirrorFingerprint.paintedPixels > 0
      && mirrorFingerprint.hash === holder.dataset.gsFloatingMirrorFingerprint;
  }

  function syncFloatingPreviewGate() {
    if (!enhancementEnabled()) return;
    const ready = hasFloatingPreviewReadyContent();
    const visualReady = ready && hasVisualPreviewSurface();
    document.documentElement.dataset.gsProgressivePreviewReady = ready ? 'true' : 'false';
    document.documentElement.dataset.gsProgressivePreviewVisualReady = visualReady ? 'true' : 'false';

    syncAdjustPlacementCtaGate();
  }

  function setFloatingPreviewActive(active) {
    document.documentElement.dataset.gsProgressiveCustomizerActive = active ? 'true' : 'false';
    if (!active) setFloatingPreviewExpanded(false);
  }

  // CVR-06 rework 2026-07-02: the old gate hid the card whenever its fixed
  // bottom-left candidate rect overlapped ANY product element
  // (collidesWithProductBoundary), so downstream elements scrolling INTO the
  // rect caused premature hide + flicker while the shopper was still editing.
  // New model:
  //  - PRIMARY: show while the active customizer zone is on screen — any
  //    visible progressive group (gsProgressiveVisible=true) intersects the
  //    viewport band, or the customizer root itself does.
  //  - Hide only once the shopper has scrolled DOWNSTREAM of the customizer
  //    (root bottom above ~15% of viewport height) or has not reached it yet
  //    (root top below ~92%), not because a description entered the rect.
  //  - HYSTERESIS: while the card is shown, the band is widened by 56px on
  //    both edges, so the shopper must scroll 56px past the show boundary
  //    before it hides — show/hide cannot oscillate within a few px.
  function shouldShowFloatingPreviewInViewport() {
    const root = customilyRoot();
    if (!root || !hasFloatingPreviewReadyContent() || !hasVisualPreviewSurface()) return false;
    const vh = window.innerHeight || document.documentElement.clientHeight || 800;
    const vw = window.innerWidth || document.documentElement.clientWidth || 390;
    if (vw >= 750) return false;
    if (qs('.gs-approval-modal.is-open, .gs-approval-zoom.is-open, .gs-shell-review.is-open')) return false;
    const shownNow = document.documentElement.dataset.gsProgressiveCustomizerActive === 'true';
    const slack = shownNow ? 56 : 0;
    const bandTop = vh * 0.15 - slack;
    const bandBottom = vh * 0.92 + slack;
    const inBand = (rect) => !!rect && rect.height > 1 && rect.bottom > bandTop && rect.top < bandBottom;
    const rootRect = root.getBoundingClientRect();
    return inBand(rootRect)
      || qsa('[data-gs-progressive-role]', root).some((node) => node.dataset.gsProgressiveVisible === 'true' && inBand(node.getBoundingClientRect()));
  }

  function syncFloatingPreviewActiveGate() {
    if (enhancementEnabled()) {
      setFloatingPreviewActive(shouldShowFloatingPreviewInViewport());
      return;
    }
    if (isGuided()) return;
    const root = customilyRoot();
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (!root || !isMobile || !hasPreviewReadyContent()) {
      if (state.previewObserver) {
        state.previewObserver.disconnect();
        state.previewObserver = null;
        state.previewObservedRoot = null;
      }
      setFloatingPreviewActive(false);
      return;
    }
    if (state.previewObserver && state.previewObservedRoot === root) return;
    if (state.previewObserver) state.previewObserver.disconnect();
    state.previewObservedRoot = root;
    setFloatingPreviewActive(false);
    state.previewObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      setFloatingPreviewActive(!!entry && entry.isIntersecting && entry.intersectionRatio > 0.04);
    }, {
      root: null,
      rootMargin: '-96px 0px -18% 0px',
      threshold: [0, 0.04, 0.16]
    });
    state.previewObserver.observe(root);
  }

  // ---- Step / shell view state ----
  function activeStepView() {
    if (isTeeAdapter()) return 'detail';
    const style = chosenStyle();
    if (!style) return 'path';
    if (style === 'Images') return 'image';
    return 'detail';
  }

  function setShellView() {
    if (!state.shell) return;
    const view = activeStepView();
    state.shell.dataset.view = view;
    state.shell.dataset.style = isTeeAdapter() ? 'tee-text' : (lower(chosenStyle()) || 'none');
    // consent only relevant for Images path with a real consent group present.
    state.consentHost && (state.consentHost.hidden = !consentRequired());
  }

  function setProgress() {
    const result = validation();
    const step = stepNumber();
    state.stepBadge.textContent = `Step ${step} of 3`;
    state.progress.style.width = `${Math.max(20, step * 33)}%`;
    state.stepTitle.textContent = stepTitle(step);
    const hint = result.ok ? 'Looks good — review your design.' : result.issues[0];
    state.footerHint.textContent = hint;
    state.footer.dataset.state = result.ok ? 'ready' : 'blocked';
    state.footerBtn.textContent = result.ok ? 'Review design' : 'Continue';
  }

  function stepTitle(step) {
    if (isTeeAdapter()) {
      if (step <= 1) return 'Add your tee text';
      if (step === 2) return 'Choose font and imprint color';
      return 'Review your tee design';
    }
    if (step <= 1) return 'How do you want to personalize?';
    const style = chosenStyle();
    if (style === 'Images') return step >= 3 ? 'Confirm your artwork' : 'Add your logo or image';
    if (style === 'Custom Text') return 'Add your text';
    if (style === 'Monogram') return 'Choose your monogram';
    return 'Personalize your product';
  }

  // ---- Review bottom sheet ----
  function propertySummary() {
    if (isTeeAdapter()) {
      const rows = [['Personalization', 'Tee text'], ['Text', visibleTextValue() || 'Needs text']];
      rows.push(['Font', selectedFontStyle() || 'Choose font']);
      rows.push([selectedDesignColorPropertyName(), selectedDesignColor() || 'Choose color']);
      return rows;
    }
    const style = chosenStyle() || 'Not selected';
    const method = chosenImageMethod() || 'Not selected';
    let detail = 'Not ready';
    if (style === 'Images') detail = hasImagePreviewReady() ? 'Artwork uploaded' : 'Needs artwork';
    if (style === 'Custom Text') detail = visibleTextValue() || 'Needs text';
    if (style === 'Monogram') detail = selectedMonogram() || 'Needs monogram style';
    const rows = [['Personalization', style]];
    if (style === 'Images') rows.push(['Method', method]);
    rows.push(['Details', detail]);
    if (consentRequired()) rows.push(['Rights', consentChecked() ? 'Confirmed' : 'Required']);
    return rows;
  }

  function fillReview() {
    if (!state.reviewList || !state.reviewError || !state.reviewSubmit) return;
    state.reviewList.innerHTML = propertySummary().map(([key, value]) => `
      <div class="gs-shell-review__row">
        <span class="gs-shell-review__key">${escapeHtml(key)}</span>
        <span class="gs-shell-review__value">${escapeHtml(value)}</span>
      </div>
    `).join('');
    const result = validation();
    state.reviewError.hidden = result.ok;
    state.reviewError.innerHTML = result.ok ? '' : '<strong>Almost there</strong><ul>' +
      result.issues.map((i) => `<li>${escapeHtml(i)}</li>`).join('') + '</ul>';
    state.reviewSubmit.disabled = !result.ok;
  }

  // ---- Progressive approval modal: blocks cart submit until the shopper confirms terms + preview.
  function buildApprovalModal() {
    const modal = document.createElement('aside');
    modal.className = 'gs-approval-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'gs-approval-title');
    modal.innerHTML = `
      <div class="gs-approval-modal__overlay" data-gs-approval-close></div>
      <div class="gs-approval-modal__panel">
        <div class="gs-approval-modal__grab"></div>
        <div class="gs-approval-modal__header">
          <div>
            <div class="gs-approval-modal__eyebrow">Final check</div>
            <h3 class="gs-approval-modal__title" id="gs-approval-title">Approve your preview</h3>
          </div>
          <button type="button" class="gs-approval-modal__close" aria-label="Close" data-gs-approval-close>×</button>
        </div>
        <div class="gs-approval-modal__preview" data-gs-approval-preview>
          <span class="gs-approval-modal__preview-empty">Preview loading…</span>
        </div>
        <div class="gs-approval-modal__summary"></div>
        <div class="gs-approval-modal__checks">
          <label class="gs-approval-modal__check" data-gs-approval-terms-row>
            <input type="checkbox" data-gs-approval-terms>
            <span class="gs-approval-modal__check-copy">
              <strong>Content standards</strong>
              <em data-gs-approval-terms-copy>I agree to the terms.</em>
            </span>
          </label>
          <label class="gs-approval-modal__check">
            <input type="checkbox" data-gs-approval-preview-check>
            <span class="gs-approval-modal__check-copy">
              <strong>Production approval</strong>
              <em data-gs-approval-preview-copy>I reviewed the preview and approve this customization for production.</em>
            </span>
          </label>
        </div>
        <div class="gs-approval-modal__error" hidden></div>
        <button type="button" class="gs-approval-modal__confirm" disabled>Confirm & add to cart</button>
      </div>
    `;
    return modal;
  }

  function buildApprovalZoomModal() {
    const modal = document.createElement('aside');
    modal.className = 'gs-approval-zoom';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Zoom customization preview');
    modal.innerHTML = `
      <div class="gs-approval-zoom__overlay" data-gs-zoom-close></div>
      <div class="gs-approval-zoom__panel">
        <div class="gs-approval-zoom__bar">
          <strong>Zoom preview</strong>
          <button type="button" data-gs-zoom-close aria-label="Close zoom">×</button>
        </div>
        <div class="gs-approval-zoom__viewport" data-gs-zoom-viewport tabindex="0" role="region" aria-describedby="gs-approval-zoom-instructions">
          <img alt="Zoomed customization preview" draggable="false">
        </div>
        <p class="gs-approval-zoom__instructions" id="gs-approval-zoom-instructions">Click or tap the image to zoom where you point. Drag or pinch to inspect. Keyboard: use + or − to zoom, arrow keys to move, and 0 or Home to fit.</p>
        <div class="gs-approval-zoom__controls" aria-label="Preview zoom controls">
          <button type="button" data-gs-zoom-out aria-label="Zoom out">−</button>
          <output class="gs-approval-zoom__level" data-gs-zoom-level aria-hidden="true">100%</output>
          <button type="button" data-gs-zoom-in aria-label="Zoom in">+</button>
          <button type="button" data-gs-zoom-reset aria-label="Fit preview">Fit</button>
        </div>
        <span class="gs-approval-zoom__announcement" data-gs-zoom-announcement aria-live="polite" aria-atomic="true">Zoom 100 percent</span>
      </div>
    `;
    return modal;
  }

  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

  function approvalZoomStagePoint(clientX, clientY) {
    const rect = state.approvalZoomViewport?.getBoundingClientRect?.();
    if (!rect) return { x: 0, y: 0 };
    return { x: clientX - rect.left - rect.width / 2, y: clientY - rect.top - rect.height / 2 };
  }

  function approvalZoomPointInsideImage(clientX, clientY) {
    const rect = state.approvalZoomImage?.getBoundingClientRect?.();
    return !!rect && clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
  }

  function clampApprovalZoomTranslation() {
    const viewport = state.approvalZoomViewport;
    const image = state.approvalZoomImage;
    if (!viewport || !image) return;
    const maxX = Math.max(0, (image.offsetWidth * state.zoomScale - viewport.clientWidth) / 2);
    const maxY = Math.max(0, (image.offsetHeight * state.zoomScale - viewport.clientHeight) / 2);
    state.zoomX = clamp(state.zoomX || 0, -maxX, maxX);
    state.zoomY = clamp(state.zoomY || 0, -maxY, maxY);
    if (state.zoomScale === 1) { state.zoomX = 0; state.zoomY = 0; }
  }

  function scheduleApprovalZoomAnnouncement(percent) {
    if (!state.approvalZoomAnnouncement || state.approvalZoomAnnouncement.textContent === `Zoom ${percent} percent` || state.zoomAnnouncementPendingPercent === percent) return;
    state.zoomAnnouncementPendingPercent = percent;
    window.clearTimeout(state.zoomAnnouncementTimer);
    state.zoomAnnouncementTimer = window.setTimeout(() => {
      state.zoomAnnouncementTimer = 0;
      state.zoomAnnouncementPendingPercent = null;
      state.approvalZoomAnnouncement.textContent = `Zoom ${percent} percent`;
    }, 300);
  }

  function applyApprovalZoomTransform() {
    state.zoomScale = clamp(state.zoomScale || 1, 1, 2);
    clampApprovalZoomTranslation();
    if (!state.approvalZoomImage) return;
    setStylePlainIfChanged(state.approvalZoomImage, 'transform', `translate3d(${state.zoomX}px, ${state.zoomY}px, 0) scale(${state.zoomScale})`);
    const percent = Math.round(state.zoomScale * 100);
    const viewport = state.approvalZoomViewport;
    if (viewport) {
      setDatasetIfChanged(viewport, 'zoomed', state.zoomScale > 1 ? 'true' : 'false');
      setDatasetIfChanged(viewport, 'panning', state.zoomDragging ? 'true' : 'false');
      setDatasetIfChanged(viewport, 'pinching', state.zoomPinchStart ? 'true' : 'false');
      setDatasetIfChanged(viewport, 'zoomPercent', String(percent));
      setAttrIfChanged(viewport, 'aria-label', state.zoomScale > 1
        ? `Approval preview at ${percent} percent. Move the image with a pointer, touch, or the arrow keys; use the zoom controls or keyboard shortcuts to change zoom.`
        : 'Approval preview at fit. Use the image surface, zoom controls, or keyboard shortcuts to zoom.');
    }
    if (state.approvalZoomLevel && state.approvalZoomLevel.textContent !== `${percent}%`) state.approvalZoomLevel.textContent = `${percent}%`;
    scheduleApprovalZoomAnnouncement(percent);
    const zoomOut = state.approvalZoomModal?.querySelector('[data-gs-zoom-out]');
    const zoomIn = state.approvalZoomModal?.querySelector('[data-gs-zoom-in]');
    const fit = state.approvalZoomModal?.querySelector('[data-gs-zoom-reset]');
    if (zoomOut && zoomOut.disabled !== (state.zoomScale <= 1)) zoomOut.disabled = state.zoomScale <= 1;
    if (zoomIn && zoomIn.disabled !== (state.zoomScale >= 2)) zoomIn.disabled = state.zoomScale >= 2;
    const fitDisabled = state.zoomScale === 1 && state.zoomX === 0 && state.zoomY === 0;
    if (fit && fit.disabled !== fitDisabled) fit.disabled = fitDisabled;
  }

  function requestApprovalZoomTransform() {
    if (state.zoomTransformFrame) return;
    state.zoomTransformFrame = window.requestAnimationFrame(() => {
      state.zoomTransformFrame = 0;
      applyApprovalZoomTransform();
    });
  }

  function setApprovalZoomScale(next, clientX, clientY) {
    const viewport = state.approvalZoomViewport;
    if (!viewport || !state.approvalZoomImage) return;
    const boundedScale = clamp(next, 1, 2);
    const rect = viewport.getBoundingClientRect();
    const focusX = Number.isFinite(clientX) ? clientX : rect.left + rect.width / 2;
    const focusY = Number.isFinite(clientY) ? clientY : rect.top + rect.height / 2;
    const point = approvalZoomStagePoint(focusX, focusY);
    const ratio = boundedScale / state.zoomScale;
    state.zoomX = point.x - (point.x - state.zoomX) * ratio;
    state.zoomY = point.y - (point.y - state.zoomY) * ratio;
    state.zoomScale = boundedScale;
    requestApprovalZoomTransform();
  }

  function cycleApprovalZoomAt(clientX, clientY) {
    if (state.zoomScale < 1.25) setApprovalZoomScale(1.5, clientX, clientY);
    else if (state.zoomScale < 1.75) setApprovalZoomScale(2, clientX, clientY);
    else resetApprovalZoom();
  }

  function resetApprovalZoom() {
    for (const pointerId of state.zoomPointers.keys()) {
      if (state.approvalZoomViewport?.hasPointerCapture?.(pointerId)) state.approvalZoomViewport.releasePointerCapture(pointerId);
    }
    state.zoomScale = 1;
    state.zoomX = 0;
    state.zoomY = 0;
    state.zoomPointers.clear();
    state.zoomDragStart = null;
    state.zoomPinchStart = null;
    state.zoomDragging = false;
    state.zoomGestureHadMultiTouch = false;
    requestApprovalZoomTransform();
  }

  function openApprovalZoom(opener) {
    if (!state.approvalZoomModal || !state.approvalZoomImage || !state.approvalPreviewImageSrc) return;
    if (state.approvalZoomCloseTimer) window.clearTimeout(state.approvalZoomCloseTimer);
    state.approvalZoomCloseTimer = 0;
    state.zoomReturnFocus = opener || document.activeElement;
    if (state.approvalModal) state.approvalModal.inert = true;
    state.approvalZoomImage.src = state.approvalPreviewImageSrc;
    state.approvalZoomModal.hidden = false;
    state.approvalZoomModal.classList.add('is-open');
    document.documentElement.classList.add('gs-approval-zoom-open');
    resetApprovalZoom();
    if (state.approvalZoomFocusFrame) window.cancelAnimationFrame(state.approvalZoomFocusFrame);
    state.approvalZoomFocusFrame = window.requestAnimationFrame(() => {
      state.approvalZoomFocusFrame = 0;
      if (state.approvalZoomModal?.classList.contains('is-open')) {
        state.approvalZoomModal.querySelector('[data-gs-zoom-close]')?.focus?.({ preventScroll: true });
      }
    });
  }

  function closeApprovalZoom() {
    if (!state.approvalZoomModal) return;
    if (state.approvalZoomCloseTimer) window.clearTimeout(state.approvalZoomCloseTimer);
    if (state.approvalZoomFocusFrame) window.cancelAnimationFrame(state.approvalZoomFocusFrame);
    state.approvalZoomFocusFrame = 0;
    state.approvalZoomModal.classList.remove('is-open');
    document.documentElement.classList.remove('gs-approval-zoom-open');
    if (state.approvalModal) state.approvalModal.inert = false;
    resetApprovalZoom();
    const returnFocus = state.zoomReturnFocus;
    state.zoomReturnFocus = null;
    state.approvalZoomCloseTimer = window.setTimeout(() => {
      state.approvalZoomCloseTimer = 0;
      if (state.approvalZoomModal?.classList.contains('is-open')) return;
      state.approvalZoomModal.hidden = true;
      returnFocus?.focus?.({ preventScroll: true });
    }, 180);
  }

  function approvalZoomMovementThreshold(pointer) {
    return pointer?.type === 'touch' ? 12 : 5;
  }

  function approvalZoomPointerDown(event) {
    if (!state.approvalZoomModal?.classList.contains('is-open') || event.button > 0) return;
    const pointer = {
      x: event.clientX,
      y: event.clientY,
      startX: event.clientX,
      startY: event.clientY,
      type: event.pointerType,
      startedAt: performance.now(),
      startedOnImage: approvalZoomPointInsideImage(event.clientX, event.clientY)
    };
    state.zoomPointers.set(event.pointerId, pointer);
    if (state.zoomPointers.size === 2) {
      state.zoomGestureHadMultiTouch = true;
      for (const pointerId of state.zoomPointers.keys()) state.approvalZoomViewport?.setPointerCapture?.(pointerId);
      const [a, b] = [...state.zoomPointers.values()];
      const midpoint = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      const point = approvalZoomStagePoint(midpoint.x, midpoint.y);
      state.zoomPinchStart = {
        distance: Math.hypot(a.x - b.x, a.y - b.y) || 1,
        scale: state.zoomScale,
        contentX: (point.x - state.zoomX) / state.zoomScale,
        contentY: (point.y - state.zoomY) / state.zoomScale
      };
      state.zoomDragStart = null;
      state.zoomDragging = false;
      setDatasetIfChanged(state.approvalZoomViewport, 'pinching', 'true');
      event.preventDefault();
    } else {
      state.zoomDragStart = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        translateX: state.zoomX,
        translateY: state.zoomY
      };
      if (state.zoomScale > 1) {
        state.approvalZoomViewport?.setPointerCapture?.(event.pointerId);
        event.preventDefault();
      }
    }
    requestApprovalZoomTransform();
  }

  function approvalZoomPointerMove(event) {
    if (!state.zoomPointers.has(event.pointerId)) return;
    const prior = state.zoomPointers.get(event.pointerId);
    const samples = event.getCoalescedEvents?.() || [];
    const pointEvent = samples[samples.length - 1] || event;
    state.zoomPointers.set(event.pointerId, { ...prior, x: pointEvent.clientX, y: pointEvent.clientY });
    if (state.zoomPointers.size >= 2 && state.zoomPinchStart) {
      event.preventDefault();
      const [a, b] = [...state.zoomPointers.values()];
      const midpoint = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
      const point = approvalZoomStagePoint(midpoint.x, midpoint.y);
      const distance = Math.hypot(a.x - b.x, a.y - b.y) || 1;
      state.zoomScale = clamp(state.zoomPinchStart.scale * distance / state.zoomPinchStart.distance, 1, 2);
      state.zoomX = point.x - state.zoomPinchStart.contentX * state.zoomScale;
      state.zoomY = point.y - state.zoomPinchStart.contentY * state.zoomScale;
      requestApprovalZoomTransform();
      return;
    }
    if (state.zoomPointers.size === 1 && state.zoomDragStart?.pointerId === event.pointerId && state.zoomScale > 1) {
      const movement = Math.hypot(pointEvent.clientX - state.zoomDragStart.x, pointEvent.clientY - state.zoomDragStart.y);
      const threshold = approvalZoomMovementThreshold(prior);
      if (movement > threshold) state.zoomDragging = true;
      if (!state.zoomDragging) return;
      event.preventDefault();
      setDatasetIfChanged(state.approvalZoomViewport, 'panning', 'true');
      state.zoomX = state.zoomDragStart.translateX + pointEvent.clientX - state.zoomDragStart.x;
      state.zoomY = state.zoomDragStart.translateY + pointEvent.clientY - state.zoomDragStart.y;
      requestApprovalZoomTransform();
    }
  }

  function approvalZoomPointerEnd(event, cancelled = false) {
    const pointer = state.zoomPointers.get(event.pointerId);
    const hadMultiple = state.zoomGestureHadMultiTouch || state.zoomPointers.size > 1;
    const movement = pointer ? Math.hypot(event.clientX - pointer.startX, event.clientY - pointer.startY) : Infinity;
    const duration = pointer ? performance.now() - pointer.startedAt : Infinity;
    const threshold = approvalZoomMovementThreshold(pointer);
    const wasDragging = state.zoomDragging;
    state.zoomPointers.delete(event.pointerId);
    if (state.approvalZoomViewport?.hasPointerCapture?.(event.pointerId)) state.approvalZoomViewport.releasePointerCapture(event.pointerId);
    if (!cancelled && pointer?.startedOnImage && !hadMultiple && !wasDragging && movement <= threshold && duration < 500) {
      cycleApprovalZoomAt(event.clientX, event.clientY);
    }
    state.zoomPinchStart = null;
    state.zoomDragStart = null;
    state.zoomDragging = false;
    if (state.zoomPointers.size === 1) {
      const [pointerId, remaining] = [...state.zoomPointers.entries()][0];
      state.zoomDragStart = { pointerId, x: remaining.x, y: remaining.y, translateX: state.zoomX, translateY: state.zoomY };
    } else if (state.zoomPointers.size === 0) {
      state.zoomGestureHadMultiTouch = false;
    }
    requestApprovalZoomTransform();
    if (state.zoomPointers.size === 0) flushRefreshDeferredForPan();
  }

  function approvalZoomKeyDown(event) {
    const key = event.key;
    if (key === 'Escape') { event.preventDefault(); closeApprovalZoom(); }
    else if (key === '+' || key === '=') { event.preventDefault(); setApprovalZoomScale(state.zoomScale + 0.5); }
    else if (key === '-') { event.preventDefault(); setApprovalZoomScale(state.zoomScale - 0.5); }
    else if (key === '0' || key === 'Home') { event.preventDefault(); resetApprovalZoom(); }
    else if (state.zoomScale > 1 && ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(key)) {
      event.preventDefault();
      const step = 48;
      if (key === 'ArrowLeft') state.zoomX += step;
      if (key === 'ArrowRight') state.zoomX -= step;
      if (key === 'ArrowUp') state.zoomY += step;
      if (key === 'ArrowDown') state.zoomY -= step;
      requestApprovalZoomTransform();
    }
  }

  function attachApprovalZoomHandlers() {
    if (!state.approvalZoomModal || !state.approvalZoomViewport) return;
    qsa('[data-gs-zoom-close]', state.approvalZoomModal).forEach((button) => button.addEventListener('click', closeApprovalZoom));
    state.approvalZoomModal.querySelector('[data-gs-zoom-in]')?.addEventListener('click', () => setApprovalZoomScale(state.zoomScale + 0.5));
    state.approvalZoomModal.querySelector('[data-gs-zoom-out]')?.addEventListener('click', () => setApprovalZoomScale(state.zoomScale - 0.5));
    state.approvalZoomModal.querySelector('[data-gs-zoom-reset]')?.addEventListener('click', resetApprovalZoom);
    state.approvalZoomModal.addEventListener('keydown', approvalZoomKeyDown);
    state.approvalZoomViewport.addEventListener('pointerdown', approvalZoomPointerDown);
    state.approvalZoomViewport.addEventListener('pointermove', approvalZoomPointerMove);
    state.approvalZoomViewport.addEventListener('pointerup', (event) => approvalZoomPointerEnd(event));
    state.approvalZoomViewport.addEventListener('pointercancel', (event) => approvalZoomPointerEnd(event, true));
    state.approvalZoomViewport.addEventListener('dblclick', (event) => event.preventDefault());
    state.approvalZoomImage?.addEventListener('load', requestApprovalZoomTransform);
    if (window.ResizeObserver) {
      state.approvalZoomResizeObserver = new ResizeObserver(requestApprovalZoomTransform);
      state.approvalZoomResizeObserver.observe(state.approvalZoomViewport);
    }
    applyApprovalZoomTransform();
  }

  function approvalTermsRequired() {
    if (isTeeAdapter()) return true;
    const style = chosenStyle();
    if (style === 'Monogram') return false;
    return style === 'Images' || style === 'Custom Text' || !!style;
  }

  function approvalTermsText() {
    const style = chosenStyle();
    const termsLink = '<a href="/policies/terms-of-service" target="_blank" rel="noopener">terms</a>';
    if (isTeeAdapter()) return `I confirm my tee text does not include hate speech, slurs, harassment, or other content that violates our ${termsLink}.`;
    if (style === 'Custom Text') return `I confirm my text does not include hate speech, slurs, harassment, or other content that violates our ${termsLink}.`;
    if (style === 'Images') return `I confirm I have the right to use this artwork, logo, or photo. It does not include explicit adult content, hate speech, slurs, harassment, or trademarked material, and it follows our ${termsLink}.`;
    return `I confirm this customization follows our ${termsLink} and does not include inappropriate content.`;
  }

  function approvalPreviewText() {
    if (isTeeAdapter()) return 'I reviewed the preview and approve this tee text customization for production.';
    if (chosenStyle() === 'Monogram') return 'I reviewed the preview and approve this monogram for production.';
    if (chosenStyle() === 'Custom Text') return 'I reviewed the preview and approve this text customization for production.';
    if (chosenStyle() === 'Images') return 'I reviewed the preview and approve this artwork placement for production.';
    return 'I reviewed the preview and approve this customization for production.';
  }

  function syncApprovalCopy() {
    const needsTerms = approvalTermsRequired();
    if (state.approvalTermsRow) {
      state.approvalTermsRow.hidden = !needsTerms;
      state.approvalTermsRow.style.display = needsTerms ? '' : 'none';
    }
    if (state.approvalTerms) {
      state.approvalTerms.required = needsTerms;
      if (!needsTerms) state.approvalTerms.checked = false;
    }
    if (state.approvalTermsCopy) state.approvalTermsCopy.innerHTML = approvalTermsText();
    if (state.approvalPreviewCopy) state.approvalPreviewCopy.textContent = approvalPreviewText();
  }

  function syncApprovalConfirmState() {
    if (!state.approvalConfirm) return;
    const termsOk = !approvalTermsRequired() || !!state.approvalTerms?.checked;
    const ready = termsOk && !!state.approvalPreviewCheck?.checked && validation().ok;
    state.approvalConfirm.disabled = !ready || state.approvalSubmitting;
  }

  function setApprovalProcessing(message = 'Processing your customization…') {
    if (!state.approvalModal || !state.approvalConfirm) return;
    state.approvalModal.classList.add('is-processing');
    if (state.approvalError) { state.approvalError.hidden = true; state.approvalError.textContent = ''; }
    state.approvalConfirm.disabled = true;
    state.approvalConfirm.innerHTML = `<span class="gs-approval-modal__spinner" aria-hidden="true"></span><span>${escapeHtml(message)}</span>`;
  }

  function resetApprovalButton() {
    if (!state.approvalConfirm) return;
    state.approvalModal?.classList.remove('is-processing');
    state.approvalConfirm.textContent = 'Confirm & add to cart';
    syncApprovalConfirmState();
  }

  function cleanupApprovalTerminalWatchers() {
    window.clearTimeout(state.approvalTimeout);
    state.approvalTimeout = null;
    state.approvalDrawerObserver?.disconnect?.();
    state.approvalDrawerObserver = null;
    state.approvalUnsubscribers.splice(0).forEach((unsub) => { try { unsub?.(); } catch (_) {} });
  }

  function finishApprovalFlow() {
    if (!state.approvalSubmitting) return;
    state.approvalSubmitting = false;
    state.approvalVisibleClickConsumed = false;
    state.approvalNativeClickConsumed = false;
    cleanupApprovalTerminalWatchers();
    closeApprovalModal();
    window.setTimeout(resetApprovalButton, 260);
  }

  function failApprovalProcessing() {
    if (!state.approvalSubmitting) return;
    // An 18 second silence is ambiguous, not a known failure. Keep the commit
    // latch closed so a second action cannot replay an add that may have landed.
    state.approvalAmbiguous = true;
    cleanupApprovalTerminalWatchers();
    state.approvalModal?.classList.remove('is-processing');
    if (state.approvalError) {
      state.approvalError.hidden = false;
      state.approvalError.setAttribute('role', 'status');
      state.approvalError.setAttribute('aria-live', 'polite');
      state.approvalError.textContent = 'Cart status is unclear. Check your cart before trying again.';
    }
    if (state.approvalConfirm) {
      state.approvalConfirm.disabled = true;
      state.approvalConfirm.textContent = 'Check cart to continue';
    }
  }

  function cartDrawerLooksOpen() {
    return qsa('cart-drawer, cart-notification, #CartDrawer, .cart-drawer').some((drawer) => (
      drawer.hasAttribute('open')
      || drawer.classList.contains('active')
      || drawer.classList.contains('animate')
      || drawer.classList.contains('is-open')
      || drawer.classList.contains('is-visible')
      || drawer.getAttribute('aria-hidden') === 'false'
    ));
  }

  function syncFloatingPreviewForCartDrawer() {
    const open = window.matchMedia('(max-width: 749px)').matches && cartDrawerLooksOpen();
    setDatasetIfChanged(document.documentElement, 'gsProgressiveCartDrawerOpen', open ? 'true' : 'false');
    const restore = qs('.gs-floating-preview-restore');
    if (restore) {
      if (open) {
        setDatasetIfChanged(restore, 'gsHiddenForCartDrawer', 'true');
        setStyleIfChanged(restore, 'display', 'none');
        setAttrIfChanged(restore, 'aria-hidden', 'true');
        if (restore.tabIndex !== -1) restore.tabIndex = -1;
      } else if (restore.dataset.gsHiddenForCartDrawer === 'true') {
        delete restore.dataset.gsHiddenForCartDrawer;
        removeStyleIfPresent(restore, 'display');
        restore.removeAttribute('aria-hidden');
        if (restore.tabIndex !== 0) restore.tabIndex = 0;
      }
    }
    if (!open) return false;
    setFloatingPreviewMinimized(true);
    setDatasetIfChanged(document.documentElement, 'gsProgressiveFloatingPreviewTransitionReason', 'cart-drawer-open');
    return true;
  }

  function watchApprovalTerminalSignals() {
    cleanupApprovalTerminalWatchers();
    const finish = () => window.setTimeout(finishApprovalFlow, 140);
    document.addEventListener('cart:refresh', finish, { once: true });
    document.addEventListener('cart:updated', finish, { once: true });
    document.addEventListener('cartUpdate', finish, { once: true });
    state.approvalUnsubscribers.push(() => document.removeEventListener('cart:refresh', finish));
    state.approvalUnsubscribers.push(() => document.removeEventListener('cart:updated', finish));
    state.approvalUnsubscribers.push(() => document.removeEventListener('cartUpdate', finish));
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.cartUpdate) {
        state.approvalUnsubscribers.push(subscribe(PUB_SUB_EVENTS.cartUpdate, finish));
        if (PUB_SUB_EVENTS.cartError) state.approvalUnsubscribers.push(subscribe(PUB_SUB_EVENTS.cartError, failApprovalProcessing));
      }
    } catch (_) {}
    const drawer = qs('cart-drawer, cart-notification, #CartDrawer, .cart-drawer');
    if (drawer && window.MutationObserver) {
      state.approvalDrawerObserver = new MutationObserver(() => { if (cartDrawerLooksOpen()) finish(); });
      state.approvalDrawerObserver.observe(drawer, { attributes: true, childList: true, subtree: false, attributeFilter: ['class', 'open', 'aria-hidden'] });
    }
    state.approvalTimeout = window.setTimeout(failApprovalProcessing, 18000);
  }

  function fillApprovalSummary() {
    if (!state.approvalSummary) return;
    state.approvalSummary.innerHTML = propertySummary().map(([key, value]) => `
      <div class="gs-approval-modal__summary-row">
        <span>${escapeHtml(key)}</span><strong>${escapeHtml(value)}</strong>
      </div>
    `).join('');
  }

  function fillApprovalPreview() {
    if (!state.approvalPreview) return;
    state.approvalPreviewImageSrc = '';
    state.approvalPreview.innerHTML = '<span class="gs-approval-modal__preview-empty">Preview unavailable. Review the live preview on the page before confirming.</span>';
    const canvas = previewCanvas();
    if (!canvas) return;
    try {
      const data = canvas.toDataURL ? canvas.toDataURL('image/png') : '';
      if (!data) return;
      state.approvalPreviewImageSrc = data;
      const img = document.createElement('img');
      img.alt = 'Customization preview';
      img.src = data;
      const zoomButton = document.createElement('button');
      zoomButton.type = 'button';
      zoomButton.className = 'gs-approval-modal__zoom-open';
      zoomButton.dataset.gsApprovalZoomOpen = 'true';
      zoomButton.innerHTML = '<span aria-hidden="true">⌕</span> Zoom preview';
      state.approvalPreview.innerHTML = '';
      state.approvalPreview.appendChild(img);
      state.approvalPreview.appendChild(zoomButton);
    } catch (_) {
      state.approvalPreviewImageSrc = '';
    }
  }

  function openApprovalModal() {
    const result = validation();
    if (!result.ok) { showProgressiveValidationNotice(result); focusRealNext(); return; }
    state.approvalSubmitting = false;
    state.approvalAmbiguous = false;
    state.approvalReturnFocus = document.activeElement;
    state.approvalVisibleClickConsumed = false;
    state.approvalNativeClickConsumed = false;
    cleanupApprovalTerminalWatchers();
    if (!state.approvalModal) return;
    resetApprovalButton();
    fillApprovalPreview();
    fillApprovalSummary();
    syncApprovalCopy();
    if (state.approvalTerms) state.approvalTerms.checked = false;
    if (state.approvalPreviewCheck) state.approvalPreviewCheck.checked = false;
    if (state.approvalError) { state.approvalError.hidden = true; state.approvalError.textContent = ''; }
    syncApprovalConfirmState();
    state.approvalModal.hidden = false;
    state.approvalModal.classList.add('is-open');
    document.documentElement.classList.add('gs-approval-modal-open');
    const focusTarget = approvalTermsRequired() ? state.approvalTerms : state.approvalPreviewCheck;
    window.setTimeout(() => focusTarget?.focus?.({ preventScroll: true }), 60);
  }

  function closeApprovalModal() {
    if (!state.approvalModal) return;
    // Once an add is delegated, dismissal would hide the only truthful commit
    // status and invite a second attempt from the underlying PDP controls.
    if (state.approvalSubmitting || state.approvalAmbiguous) return;
    closeApprovalZoom();
    state.approvalModal.classList.remove('is-open');
    document.documentElement.classList.remove('gs-approval-modal-open');
    window.setTimeout(() => { if (!state.approvalModal?.classList.contains('is-open')) state.approvalModal.hidden = true; }, 220);
    window.setTimeout(() => state.approvalReturnFocus?.focus?.({ preventScroll: true }), 230);
  }

  function blockForApproval(evt) {
    evt?.preventDefault?.();
    evt?.stopImmediatePropagation?.();
    const result = validation();
    if (!result.ok) { showProgressiveValidationNotice(result); focusRealNext(); return; }
    openApprovalModal();
  }

  function syncHiddenArtworkConsentForApproval() {
    const box = artworkConsent();
    if (chosenStyle() !== 'Images' || !box) return Promise.resolve();
    state.approvalSyncingHiddenConsent = true;
    box.checked = true;
    box.dispatchEvent(new Event('input', { bubbles: true }));
    box.dispatchEvent(new Event('change', { bubbles: true }));
    state.approvalSyncingHiddenConsent = false;
    return new Promise((resolve) => window.requestAnimationFrame(() => window.setTimeout(resolve, 0)));
  }

  async function confirmApprovalAndSubmit() {
    // Synchronous guard covers pointer, Enter and Space before the first await.
    if (state.approvalSubmitting || state.approvalAmbiguous) return;
    if (!validation().ok) { showProgressiveValidationNotice(validation()); openApprovalModal(); return; }
    if ((approvalTermsRequired() && !state.approvalTerms?.checked) || !state.approvalPreviewCheck?.checked) {
      syncApprovalConfirmState();
      return;
    }
    state.approvalSubmitting = true;
    state.approvalVisibleClickConsumed = false;
    state.approvalNativeClickConsumed = false;
    markFinalConfirmReviewed();
    syncGatingCheckboxesForApproval();
    setApprovalProcessing();
    await syncHiddenArtworkConsentForApproval();
    watchApprovalTerminalSignals();
    window.setTimeout(() => {
      (customilyCartButton() || realSubmitButton())?.click();
    }, 80);
  }

  function installApprovalModal() {
    if (state.approvalModal || isGuided()) return;
    state.approvalModal = buildApprovalModal();
    document.body.appendChild(state.approvalModal);
    state.approvalPreview = state.approvalModal.querySelector('[data-gs-approval-preview]');
    state.approvalSummary = state.approvalModal.querySelector('.gs-approval-modal__summary');
    state.approvalError = state.approvalModal.querySelector('.gs-approval-modal__error');
    state.approvalTermsRow = state.approvalModal.querySelector('[data-gs-approval-terms-row]');
    state.approvalTerms = state.approvalModal.querySelector('[data-gs-approval-terms]');
    state.approvalTermsCopy = state.approvalModal.querySelector('[data-gs-approval-terms-copy]');
    state.approvalPreviewCheck = state.approvalModal.querySelector('[data-gs-approval-preview-check]');
    state.approvalPreviewCopy = state.approvalModal.querySelector('[data-gs-approval-preview-copy]');
    state.approvalConfirm = state.approvalModal.querySelector('.gs-approval-modal__confirm');
    state.approvalZoomModal = buildApprovalZoomModal();
    document.body.appendChild(state.approvalZoomModal);
    state.approvalZoomImage = state.approvalZoomModal.querySelector('img');
    state.approvalZoomViewport = state.approvalZoomModal.querySelector('[data-gs-zoom-viewport]');
    state.approvalZoomLevel = state.approvalZoomModal.querySelector('[data-gs-zoom-level]');
    state.approvalZoomAnnouncement = state.approvalZoomModal.querySelector('[data-gs-zoom-announcement]');
    attachApprovalZoomHandlers();
    qsa('[data-gs-approval-close]', state.approvalModal).forEach((button) => button.addEventListener('click', closeApprovalModal));
    state.approvalPreview?.addEventListener('click', (event) => {
      const opener = event.target.closest?.('[data-gs-approval-zoom-open]');
      if (opener) openApprovalZoom(opener);
    });
    state.approvalPreview?.addEventListener('touchstart', (event) => {
      if (event.touches?.length >= 2) {
        event.preventDefault();
        openApprovalZoom(state.approvalPreview.querySelector('[data-gs-approval-zoom-open]'));
      }
    }, { passive: false });
    state.approvalPreview?.addEventListener('touchmove', (event) => {
      if (event.touches?.length >= 2) event.preventDefault();
    }, { passive: false });
    state.approvalTerms?.addEventListener('change', syncApprovalConfirmState);
    state.approvalPreviewCheck?.addEventListener('change', syncApprovalConfirmState);
    state.approvalConfirm?.addEventListener('click', confirmApprovalAndSubmit);
  }

  // ---- Inline progressive PDP variant ----
  function setOptionRole(node, role) {
    if (!node) return;
    setDatasetIfChanged(node, 'gsProgressiveRole', role);
  }

  function progressiveGroupFor(selector) {
    const input = qs(selector);
    return input ? (input.closest('.customily_option') || input.closest('[role="radiogroup"]') || input.parentElement) : null;
  }

  function applyProgressiveRoles() {
    const root = customilyRoot();
    if (!root) return;
    qsa('.customily_option, [data-gs-progressive-role]', root).forEach((node) => {
      setDatasetIfChanged(node, 'gsProgressiveVisible', 'false');
    });
    qsa(MONOGRAM_INITIALS_SELECTOR, root).forEach((field) => {
      const group = field.closest('.customily_option') || field.parentElement;
      if (group?.dataset.gsProgressiveRole === 'initials') delete group.dataset.gsProgressiveRole;
    });
    setOptionRole(progressiveGroupFor(CUSTOMIZATION_METHOD_SELECTOR), 'customization-method');
    setOptionRole(progressiveGroupFor(STYLE_SELECTOR), 'style');
    setOptionRole(progressiveGroupFor(IMAGE_METHOD_SELECTOR), 'method');
    const fileInput = qs(FILE_SELECTOR);
    setOptionRole(fileInput ? (fileInput.closest('.customily_option') || fileInput.parentElement) : null, 'upload');
    setOptionRole(progressiveGroupFor(TEXT_SELECTOR), 'text');
    setOptionRole(progressiveGroupFor(FONT_STYLE_SELECTOR), 'font-style');
    setOptionRole(activeFontFamilyGroup(), 'font-family');
    setOptionRole(activeDesignColorGroup(), 'color');
    setOptionRole(progressiveGroupFor(MONOGRAM_SELECTOR), 'monogram');
    setOptionRole(activeMonogramInitialGroup(), 'initials');
    const rights = artworkConsent();
    setOptionRole(rights ? (rights.closest('.customily_option') || rights.parentElement) : null, 'rights');
    const final = finalConfirmBox();
    if (final) setOptionRole(final.closest('.customily_option') || final.closest('.main-preview-with-checkbox') || final.parentElement, 'final');
  }

  function firstRadioByOrder(selector, metaMap) {
    return qsa(selector)
      .filter((input) => !input.disabled)
      .sort((a, b) => (metaMap?.[a.value]?.order || 9) - (metaMap?.[b.value]?.order || 9))[0] || null;
  }

  function nativeOrderForInput(input, index) {
    const card = cardFor(input);
    const label = labelFor(input);
    const raw = card?.style?.getPropertyValue('order')
      || label?.style?.getPropertyValue('order')
      || (card ? getComputedStyle(card).order : '')
      || (label ? getComputedStyle(label).order : '');
    const parsed = Number.parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : index;
  }

  function orderIndexForInput(input, index) {
    const values = PROGRESSIVE_OPTION_ORDERS[input.name] || [];
    const direct = values.indexOf(norm(input.value));
    return direct >= 0 ? direct : nativeOrderForInput(input, index);
  }

  function optionContainerFor(input) {
    return input?.closest?.('.swatch-container, [role="radiogroup"]') || null;
  }

  function directOptionCardFor(input) {
    const container = optionContainerFor(input);
    if (!container) return cardFor(input);
    let node = input;
    while (node && node.parentElement !== container) node = node.parentElement;
    return node && node.parentElement === container ? node : cardFor(input);
  }

  function syncProgressiveOptionOrder() {
    const root = customilyRoot();
    if (!root || isGuided()) return;
    Object.keys(PROGRESSIVE_OPTION_ORDERS).forEach((name) => {
      const inputs = qsa(`input[type=\"radio\"][name=\"${name}\"]`, root);
      const byContainer = new Map();
      inputs.forEach((input, index) => {
        const container = optionContainerFor(input);
        const card = directOptionCardFor(input);
        if (!container || !card || card.parentElement !== container) return;
        const order = orderIndexForInput(input, index) + 1;
        setDatasetIfChanged(input, 'gsProgressiveOptionOrder', String(order));
        setDatasetIfChanged(card, 'gsProgressiveOptionOrder', String(order));
        // Keep DOM nodes in Customily's native order, but give CSS grid/flex a
        // live-UI visual order. Moving font/monogram nodes has previously broken
        // Customily's value/index wiring; CSS order preserves each input+label pair.
        const orderTargets = new Set([
          card,
          labelFor(input),
          cardFor(input),
          input.closest('.customily-swatch'),
          input.closest('.swatch'),
          input.closest('.text-swatch'),
          input.closest('.swatch-container > *')
        ].filter(Boolean));
        orderTargets.forEach((node) => {
          setStyleIfChanged(node, 'order', String(order));
          setDatasetIfChanged(node, 'gsProgressiveOptionOrder', String(order));
        });
        if (!byContainer.has(container)) byContainer.set(container, []);
        byContainer.get(container).push({ card, order, index });
      });
      // Intentionally no appendChild reordering. Visual order is CSS-only so
      // click targets and underlying Customily property values stay paired.
    });
  }


  function firstRadioByProgressiveOrder(selector) {
    return qsa(selector)
      .filter((input) => !input.disabled)
      .sort((a, b) => orderIndexForInput(a, 0) - orderIndexForInput(b, 0))[0] || null;
  }

  function firstRadioInGroupByProgressiveOrder(group) {
    if (!group) return null;
    return qsa('input[type=\"radio\"]', group)
      .filter((input) => !input.disabled)
      .sort((a, b) => orderIndexForInput(a, 0) - orderIndexForInput(b, 0))[0] || null;
  }

  function resetHiddenOrMisorderedDefault(group) {
    if (!group) return;
    const checked = qsa('input[type=\"radio\"]', group).find((input) => input.checked);
    const first = firstRadioInGroupByProgressiveOrder(group);
    if (!first || !checked) return;
    const checkedNode = cardFor(checked);
    if (checkedNode?.hidden || checkedNode?.dataset?.gsCompactChoiceHidden === 'true') clickRealInput(first);
  }

  function ensureBrowseFirstDependentSelections() {
    if (isGuided() || isTeeAdapter()) return;
    const style = chosenStyle();
    // Browse-first UX: choosing the top-level path should expose the useful
    // downstream controls immediately. We select the first/default dependent
    // option behind the scenes so Customily mounts the relevant DOM, while final
    // validation still blocks until the shopper supplies the required content.
    if (style === 'Images' && !chosenImageMethod()) {
      clickRealInput(firstRadioByOrder(IMAGE_METHOD_SELECTOR, METHOD_META));
    }
    if (style === 'Custom Text' && !selectedFontStyle()) {
      clickRealInput(firstRadioByOrder(FONT_STYLE_SELECTOR));
    }
    if (style === 'Custom Text' && selectedFontStyle()) {
      resetHiddenOrMisorderedDefault(activeFontFamilyGroup());
    }
    if (style === 'Monogram' && !selectedMonogram()) {
      clickRealInput(firstRadioByProgressiveOrder(MONOGRAM_SELECTOR));
    }
  }

  function shouldShowRole(role) {
    if (isTeeAdapter()) {
      if (role === 'text' || role === 'font-style' || role === 'color') return true;
      if (role === 'final') return validation().ok;
      return false;
    }
    if (isMethodGatedDrinkwareAdapter()) {
      if (role === 'customization-method') return true;
      if (!chosenCustomizationMethod()) return false;
    } else if (role === 'customization-method') {
      return false;
    }
    const style = chosenStyle();
    if (role === 'style') return true;
    if (!style) return false;
    if (style === 'Images') {
      // Browse-first flow: once the shopper chooses Images, show both the image
      // method cards and upload controls immediately. Validation still requires
      // a real method/file before final approval/add-to-cart can pass.
      if (role === 'method' || role === 'upload') return true;
      if (role === 'rights') return consentRequired();
      if (role === 'final') return validation().ok;
      return false;
    }
    if (style === 'Custom Text') {
      // Browse-first flow: expose the text box, font-style tabs, font choices,
      // and font color as soon as Custom Text is selected. This removes the
      // awkward half-state where font cards can appear before the tabs/color.
      if (role === 'text' || role === 'font-style' || role === 'font-family' || role === 'color') return true;
      if (role === 'final') return validation().ok;
      return false;
    }
    if (style === 'Monogram') {
      // Same browse-first principle for Monogram: show the style, initials, and
      // color controls immediately; validation still blocks incomplete choices.
      if (role === 'monogram' || role === 'initials' || role === 'color') return true;
      if (role === 'final') return validation().ok;
    }
    return false;
  }

  function applyProgressiveVisibility() {
    const root = customilyRoot();
    if (!root) return;
    setDatasetIfChanged(root, 'gsStyle', isTeeAdapter() ? 'tee-text' : (lower(chosenStyle()) || 'none'));
    setDatasetIfChanged(root, 'gsCustomizationMethod', lower(chosenCustomizationMethod()) || 'none');
    setDatasetIfChanged(root, 'gsMethod', lower(chosenImageMethod()) || 'none');
    setDatasetIfChanged(root, 'gsFile', hasFileAttached() ? 'true' : 'false');
    const ready = validation().ok;
    setDatasetIfChanged(root, 'gsReady', ready ? 'true' : 'false');
    setDatasetIfChanged(document.documentElement, 'gsProgressiveReady', ready ? 'true' : 'false');
    let cardGroupRevealed = false;
    qsa('[data-gs-progressive-role]', root).forEach((node) => {
      const show = shouldShowRole(node.dataset.gsProgressiveRole);
      // ISSUE 1b -- detect a card group transitioning hidden->visible so we
      // can re-stamp the grid/label caps on the next frame (the freshly-revealed
      // DOM otherwise renders one frame with the shared repeat(3)/native label).
      // Glitch A fix: generalized from monogram-only to also cover font-style and
      // font-family. Those font groups (first open + every Sports/Signature/Minimal
      // tab switch, which re-assigns role=font-family) otherwise waited for the next
      // generic observer tick → the white card painted before the preview img was
      // re-pointed → grey flash. Fires ONCE per reveal (same as the monogram path).
      const role = node.dataset.gsProgressiveRole;
      if ((role === 'monogram' || role === 'font-style' || role === 'font-family') && node.hidden && show) cardGroupRevealed = true;
      setDatasetIfChanged(node, 'gsProgressiveVisible', show ? 'true' : 'false');
      setHiddenIfChanged(node, !show);
    });
    if (cardGroupRevealed) {
      // Re-stamp on the next frame so the just-revealed group's DOM gets its
      // inline grid + compact-label stamp immediately. Reuses existing helpers.
      window.requestAnimationFrame(() => {
        syncProgressiveChoiceGridCaps();
        syncProgressiveFontCards();
      });
    }
  }

  function syncProgressiveUploadControls() {
    const root = customilyRoot();
    if (!root || isGuided()) return;
    const kind = /logo/i.test(chosenImageMethod()) ? 'logo' : 'image';
    qsa('[data-gs-progressive-role="upload"]', root).forEach((group) => {
      const hasImage = !!qsa('.customily-file-with-thumbnail .customily-file-input-thumbnail img', group).find(visible);
      setDatasetIfChanged(group, 'gsUploadKind', kind);
      setDatasetIfChanged(group, 'gsUploadHasImage', hasImage ? 'true' : 'false');
      qsa('.customily-download-button', group).forEach((button) => {
        const label = hasImage ? `Replace uploaded ${kind}` : `Select ${kind}`;
        setAttrIfChanged(button, 'aria-label', label);
        setAttrIfChanged(button, 'title', label);
        if (CLUBHOUSE_ENABLED) {
          setStyleIfChanged(button, 'background', '#FFFFFF');
          setStyleIfChanged(button, 'background-color', '#FFFFFF');
          setStyleIfChanged(button, 'border', '1.25px solid #000000');
          setStyleIfChanged(button, 'color', '#000000');
          setStyleIfChanged(button, 'box-shadow', 'none');
          setStyleIfChanged(button, 'font-family', 'var(--gs-font, Poppins, sans-serif)');
          setStyleIfChanged(button, 'font-size', '14px');
          setStyleIfChanged(button, 'font-weight', '850');
          setStyleIfChanged(button, 'letter-spacing', '-0.02em');
          setStyleIfChanged(button, 'text-transform', 'none');
        }
      });
      qsa('.cl_remove-image', group).forEach((button) => {
        const label = `Remove uploaded ${kind}`;
        setAttrIfChanged(button, 'aria-label', label);
        setAttrIfChanged(button, 'title', label);
      });
    });
  }


  function syncProgressiveCustomizationMethodCards() {
    const root = customilyRoot();
    if (!root || isGuided() || !isMethodGatedDrinkwareAdapter()) return;
    const group = qs('[data-gs-progressive-role="customization-method"]', root);
    if (!group) return;
    const heading = qs('.option_name', group);
    if (heading && heading.textContent.trim() !== 'Choose Personalization Method') {
      heading.textContent = 'Choose Personalization Method';
    }
    if (heading) {
      setStyleIfChanged(heading, 'color', '#65706E');
      setStyleIfChanged(heading, 'font-family', 'var(--gs-font, Poppins, sans-serif)');
      setStyleIfChanged(heading, 'font-size', '12px');
      setStyleIfChanged(heading, 'font-weight', '850');
      setStyleIfChanged(heading, 'line-height', '1');
      setStyleIfChanged(heading, 'letter-spacing', window.matchMedia?.('(min-width: 431px)').matches ? '0.22em' : '0.18em');
      setStyleIfChanged(heading, 'text-transform', 'uppercase');
    }
    qsa(CUSTOMIZATION_METHOD_SELECTOR, group).forEach((input) => {
      const meta = CUSTOMIZATION_METHOD_COPY[input.value];
      const label = labelFor(input);
      if (!meta || !label) return;
      setDatasetIfChanged(label, 'gsCustomizationMethodCard', lower(input.value).replace(/\s+/g, '-'));
      setAttrIfChanged(label, 'aria-label', `${meta.title}. ${meta.note}`);
      // Customily stamps 50px !important inline dimensions on text-swatch labels.
      // Replace those native constraints with natural-height cards so customer
      // copy cannot paint outside the selected method card.
      setStyleIfChanged(label, 'box-sizing', 'border-box');
      setStyleIfChanged(label, 'width', '100%');
      setStyleIfChanged(label, 'min-width', '0');
      setStyleIfChanged(label, 'max-width', 'none');
      // Fill the grid row so both methods share one visual baseline when one
      // description wraps; the row itself can still expand with larger text.
      setStyleIfChanged(label, 'height', '100%');
      // Customily owns a 50px inline !important floor and zero/15px padding.
      // Runtime must release that ownership; scoped CSS carries the same values
      // as the stable fallback and visual contract.
      setStyleIfChanged(label, 'min-height', '95px');
      setStyleIfChanged(label, 'max-height', 'none');
      setStyleIfChanged(label, 'padding', '10px 12px');
      // Keep a compact, content-expandable footprint and center the title/note
      // stack so the visible top and bottom breathing room match.
      // This also defeats Customily's inline flex-start ownership idempotently.
      setStyleIfChanged(label, 'align-items', 'center');
      setStyleIfChanged(label, 'justify-content', 'center');
      let copy = qs('.gs-customization-method__copy', label);
      if (!copy) {
        copy = document.createElement('span');
        copy.className = 'gs-customization-method__copy';
        copy.innerHTML = '<span class="gs-customization-method__title"></span><span class="gs-customization-method__note"></span>';
        label.appendChild(copy);
      }
      const title = qs('.gs-customization-method__title', copy);
      const note = qs('.gs-customization-method__note', copy);
      if (title && title.textContent !== meta.title) title.textContent = meta.title;
      if (note && note.textContent !== meta.note) note.textContent = meta.note;
    });
  }

  function syncNativeVariantSelectedLabels() {
    if (isGuided()) return;
    qsa('product-info[id^="MainProduct-"] .product__variant-picker fieldset.product__variant-options').forEach((group) => {
      const selectedValue = qs('[data-selected-value]', group);
      const checked = qs('input[type="radio"]:checked', group);
      if (!selectedValue || !checked) return;
      const value = norm(checked.value);
      if (value && selectedValue.textContent.trim() !== value) selectedValue.textContent = value;
    });
  }

  function syncProgressiveColorControls() {
    const root = customilyRoot();
    if (!root || isGuided()) return;
    syncDesignColorCapabilityGuard();
    const mobile = !!window.matchMedia?.('(max-width: 749px)').matches;
    qsa('[data-gs-progressive-role="color"]', root).forEach((group) => {
      if (CLUBHOUSE_ENABLED) {
        qsa('.swatch-container, [role="radiogroup"]', group).forEach((container) => {
          setStyleIfChanged(container, 'display', 'grid');
          setStyleIfChanged(container, 'grid-template-columns', mobile ? 'repeat(7, minmax(0, 1fr))' : 'repeat(14, minmax(0, 1fr))');
          setStyleIfChanged(container, 'gap', mobile ? '5px 6px' : '8px 6px');
          setStyleIfChanged(container, 'align-items', 'center');
          setStyleIfChanged(container, 'justify-items', 'center');
        });
        const swatchCellSize = mobile ? '36px' : '28px';
        qsa('.customily-swatch.swatch', group).forEach((swatch) => {
          ['width', 'min-width', 'max-width', 'height', 'min-height', 'max-height'].forEach((prop) => {
            setStyleIfChanged(swatch, prop, swatchCellSize);
          });
        });
      }
      qsa('.customily-swatch.swatch label', group).forEach((label) => {
        const swatch = label.closest('.customily-swatch');
        const forInput = label.htmlFor ? document.getElementById(label.htmlFor) : null;
        const input = forInput || swatch?.querySelector('input[type="radio"]') || (label.previousElementSibling?.matches?.('input[type="radio"]') ? label.previousElementSibling : null);
        const checked = !!input?.checked;
        /* The color value must match Customily's preview. Use the exact served
           Customily/admin swatch map first, because Customily paints the checked
           label white in some states; native/computed color remains a fallback
           for future/unmapped colors only. */
        const nativeColor = label.style.backgroundColor || getComputedStyle(label).backgroundColor;
        const nativeUsable = nativeColor && !/transparent|rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*0\s*\)/i.test(nativeColor);
        const mappedColor = DESIGN_COLOR_SWATCHES[norm(input?.value || '')] || label.style.getPropertyValue('--gs-color-swatch') || (nativeUsable ? nativeColor : '');
        const selectedSwatchRing = (() => {
          const color = mappedColor || '';
          const rgbMatch = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
          if (rgbMatch) {
            const r = Number(rgbMatch[1]);
            const g = Number(rgbMatch[2]);
            const b = Number(rgbMatch[3]);
            const luma = (r * 299 + g * 587 + b * 114) / 1000;
            return luma > 238 ? '#C6C6C0' : color;
          }
          return color || '#D0B985';
        })();
        if (mappedColor) {
          setStylePlainIfChanged(label, '--gs-color-swatch', mappedColor);
          setStylePlainIfChanged(label, '--gs-selected-swatch-ring', selectedSwatchRing);
          setStyleIfChanged(label, 'background', mappedColor);
          setStyleIfChanged(label, 'background-color', mappedColor);
        }
        const swatchSize = CLUBHOUSE_ENABLED ? (mobile ? '34px' : '26px') : '38px';
        ['width', 'min-width', 'max-width', 'height', 'min-height', 'max-height'].forEach((prop) => {
          setStyleIfChanged(label, prop, swatchSize);
        });
        setStyleIfChanged(label, 'padding', '0');
        setStyleIfChanged(label, 'box-sizing', 'border-box');
        setStyleIfChanged(label, 'border-style', 'solid');
        setStyleIfChanged(label, 'border-width', '1px');
        setStyleIfChanged(label, 'border-color', CLUBHOUSE_ENABLED ? (checked ? selectedSwatchRing : '#E1E1DE') : 'rgba(20, 17, 11, 0.18)');
        setStyleIfChanged(label, 'border', CLUBHOUSE_ENABLED ? `1px solid ${checked ? selectedSwatchRing : '#E1E1DE'}` : '1px solid rgba(20, 17, 11, 0.18)');
        setStyleIfChanged(label, 'border-radius', '999px');
        if (CLUBHOUSE_ENABLED) {
          setStyleIfChanged(label, 'box-shadow', checked ? `0 0 0 2px #FFFFFF, 0 0 0 4px ${selectedSwatchRing}` : 'none');
        }
      });
      const checked = activeDesignColorInputs(group).find((input) => input.checked);
      const checkedLabel = checked ? qs(`label[for="${checked.id}"]`, group) : null;
      const rawSelectedName = norm(checked?.value || checkedLabel?.textContent || 'Color');
      const selectedName = rawSelectedName.toLowerCase().replace(/(^|[\s/-])([a-z])/g, (_, prefix, letter) => prefix + letter.toUpperCase());
      const selectedHost = qs('.selected-color-name', group);
      const toggle = qs('.change-color-btn', group);
      const accordion = qs('.cl-option-content, [id^="cl-option-accordion"]', group);
      const expanded = !!accordion && getComputedStyle(accordion).display !== 'none';
      const colorSource = checkedLabel || checked?.nextElementSibling;
      const mappedSelectedColor = DESIGN_COLOR_SWATCHES[norm(checked?.value || '')] || '';
      const colorValue = mappedSelectedColor || (colorSource ? (colorSource.style.backgroundColor || colorSource.style.getPropertyValue('--gs-color-swatch') || getComputedStyle(colorSource).backgroundColor) : '');
      setDatasetIfChanged(group, 'gsColorExpanded', expanded ? 'true' : 'false');
      setDatasetIfChanged(group, 'gsColorName', selectedName);
      if (selectedHost && selectedHost.textContent.trim() !== selectedName) selectedHost.textContent = selectedName;
      if (colorValue) setStylePlainIfChanged(group, '--gs-selected-design-color', colorValue);
      if (toggle) {
        setAttrIfChanged(toggle, 'role', 'button');
        setAttrIfChanged(toggle, 'tabindex', '0');
        setAttrIfChanged(toggle, 'aria-expanded', expanded ? 'true' : 'false');
        setAttrIfChanged(toggle, 'aria-label', expanded ? 'Hide design colors' : 'Change design color');
        setAttrIfChanged(toggle, 'title', expanded ? 'Hide design colors' : 'Change design color');
      }
    });
  }

  function syncProgressiveChoiceGridCaps() {
    const root = customilyRoot();
    if (!root || isGuided()) return;
    ensureCompactChoiceGridStyles();
    const roles = isTeeAdapter() ? ['font-style'] : ['font-family', 'monogram'];
    roles.forEach((role) => {
      const group = qs(`[data-gs-progressive-role="${role}"]`, root);
      if (!group) return;
      qsa('.swatch-container, [role="radiogroup"]', group).forEach((container) => {
        setStyleIfChanged(container, 'display', 'grid');
        setStyleIfChanged(container, 'grid-template-columns', 'repeat(4, minmax(0, 1fr))');
        setStyleIfChanged(container, 'gap', isTeeAdapter() ? '8px' : '10px');
        setStyleIfChanged(container, 'align-items', 'stretch');
      });
      const swatches = qsa('.customily-swatch.swatch', group)
        .map((swatch, index) => ({ swatch, index, input: qs('input[type="radio"]', swatch) }))
        .sort((a, b) => orderIndexForInput(a.input, a.index) - orderIndexForInput(b.input, b.index));
      let firstVisibleInput = null;
      swatches.forEach(({ swatch, input }) => {
        const allowedList = isTeeAdapter() && role === 'font-style'
          ? TEE_FONT_STYLE_ORDER
          : (isMethodGatedDrinkwareAdapter() && role === 'monogram'
              ? METHOD_GATED_DRINKWARE_MONOGRAM_ORDER
              : PROGRESSIVE_OPTION_ORDERS[input?.name || '']);
        const allowed = !allowedList || allowedList.some((value) => lower(value) === lower(input?.value || ''));
        setDatasetIfChanged(swatch, 'gsCompactChoiceHidden', allowed ? 'false' : 'true');
        setHiddenIfChanged(swatch, !allowed);
        setStyleIfChanged(swatch, 'display', allowed ? 'block' : 'none');
        if (allowed && !firstVisibleInput) firstVisibleInput = input;
      });
      const checked = swatches.find(({ input, swatch }) => input?.checked && swatch?.dataset.gsCompactChoiceHidden !== 'true');
      if (!checked && firstVisibleInput) clickRealInput(firstVisibleInput);
    });
  }

  function syncProgressiveFontCardFallback(label, input, imageReady) {
    if (!label || !input || isTeeAdapter()) return null;
    const compactGroup = label.closest('[data-gs-progressive-role="font-family"], [data-gs-progressive-role="monogram"]');
    if (!compactGroup) return null;
    const isFontFamily = !!label.closest('[data-gs-progressive-role="font-family"]');
    let fallback = qs('.gs-font-card-fallback', label);
    // PR69 font-switch hardening: the text fallback is worse than a blank/loading
    // font card in the accepted Clubhouse design. On first Sports -> Signature,
    // Customily can briefly reveal both the image and fallback name, creating the
    // large label/row shift Asher caught. Font-family cards must stay image-only.
    if (CLUBHOUSE_ENABLED && isFontFamily) {
      if (!fallback) {
        fallback = document.createElement('span');
        fallback.className = 'gs-font-card-fallback';
        fallback.setAttribute('aria-hidden', 'true');
        label.appendChild(fallback);
      }
      if (fallback.textContent !== (input.value || '')) fallback.textContent = input.value || '';
      setStyleIfChanged(fallback, 'display', 'none');
      setStyleIfChanged(fallback, 'visibility', 'hidden');
      setStyleIfChanged(fallback, 'opacity', '0');
      setAttrIfChanged(fallback, 'aria-hidden', 'true');
      qsa('.label-txt', label).forEach((node) => {
        setStyleIfChanged(node, 'display', 'none');
        setStyleIfChanged(node, 'visibility', 'hidden');
        setStyleIfChanged(node, 'opacity', '0');
        setAttrIfChanged(node, 'aria-hidden', 'true');
      });
      return fallback;
    }
    if (!fallback) {
      fallback = document.createElement('span');
      fallback.className = 'gs-font-card-fallback';
      fallback.setAttribute('aria-hidden', 'true');
      label.appendChild(fallback);
    }
    if (fallback.textContent !== (input.value || '')) fallback.textContent = input.value || '';
    const showFallback = !imageReady;
    setStyleIfChanged(fallback, 'display', showFallback ? 'flex' : 'none');
    setStyleIfChanged(fallback, 'align-items', 'center');
    setStyleIfChanged(fallback, 'justify-content', 'center');
    setStyleIfChanged(fallback, 'width', '100%');
    setStyleIfChanged(fallback, 'height', '100%');
    setStyleIfChanged(fallback, 'min-height', '0');
    setStyleIfChanged(fallback, 'padding', '2px');
    setStyleIfChanged(fallback, 'box-sizing', 'border-box');
    setStyleIfChanged(fallback, 'color', '#151515');
    setStyleIfChanged(fallback, 'font-family', 'var(--gs-font, Poppins, sans-serif)');
    setStyleIfChanged(fallback, 'font-size', '10px');
    setStyleIfChanged(fallback, 'font-weight', '850');
    setStyleIfChanged(fallback, 'line-height', '1.05');
    setStyleIfChanged(fallback, 'letter-spacing', '-0.03em');
    setStyleIfChanged(fallback, 'text-align', 'center');
    setStyleIfChanged(fallback, 'white-space', 'normal');
    setStyleIfChanged(fallback, 'overflow-wrap', 'break-word');
    return fallback;
  }

  function syncProgressiveSwatchTransitionFrame() {
    if (!CLUBHOUSE_ENABLED || isGuided()) return;
    const roots = customilyRoots();
    if (!roots.length) return;
    const mobile = !!window.matchMedia?.('(max-width: 749px)').matches;
    const fontPreviewHeight = '52px';
    const stampGroup = (group, cardHeight, stabilizeFontGroup = false) => {
      if (!group) return;
      if (stabilizeFontGroup) {
        if (isTeeAdapter()) {
          // Tee section rhythm belongs to Adapter rhythm contract v4. Releasing
          // these old inline !important values preserves the canonical 24/32px
          // section gaps instead of producing 13px before font + 14px after it.
          ['box-sizing', 'width', 'margin', 'padding'].forEach((prop) => removeStyleIfPresent(group, prop));
        } else {
          setStyleIfChanged(group, 'box-sizing', 'border-box');
          setStyleIfChanged(group, 'width', mobile ? 'calc(100% - 28px)' : '100%');
          setStyleIfChanged(group, 'margin', mobile ? '0 14px' : '0');
          setStyleIfChanged(group, 'padding', '13px 0 14px');
        }
      }
      const grid = qs('.swatch-container, [role="radiogroup"]', group);
      if (grid) {
        setStyleIfChanged(grid, 'display', 'grid');
        setStyleIfChanged(grid, 'grid-template-columns', 'repeat(4, minmax(0, 1fr))');
        setStyleIfChanged(grid, 'gap', isTeeAdapter() ? '8px' : '10px');
        setStyleIfChanged(grid, 'align-items', 'stretch');
      }
      qsa('.customily-swatch.swatch', group).forEach((card) => {
        setStyleIfChanged(card, 'width', 'auto');
        setStyleIfChanged(card, 'min-width', '0');
        removeStyleIfPresent(card, 'max-width');
        setStyleIfChanged(card, 'height', 'auto');
        setStyleIfChanged(card, 'margin', '0');
        setStyleIfChanged(card, 'background', 'transparent');
        const label = qs('label', card);
        if (!label) return;
        setStyleIfChanged(label, 'box-sizing', 'border-box');
        setStyleIfChanged(label, 'width', '100%');
        setStyleIfChanged(label, 'min-width', '0');
        removeStyleIfPresent(label, 'max-width');
        setStyleIfChanged(label, 'height', cardHeight);
        setStyleIfChanged(label, 'min-height', cardHeight);
        removeStyleIfPresent(label, 'max-height');
        setStyleIfChanged(label, 'padding', stabilizeFontGroup ? '3px' : '8px');
      });
    };

    // These are Customily's own stable group classes and exist in the same DOM
    // mutation that creates the new swatches, before our semantic role pass.
    roots.forEach((root) => {
      qsa('.customily_option.sports-font-family', root).forEach((group) => stampGroup(group, fontPreviewHeight, true));
      qsa('.customily_option.monogram-style', root).forEach((group) => stampGroup(group, '74px'));
    });
  }

  function ensureProgressiveFontSwatchImage(label, input) {
    if (!CLUBHOUSE_ENABLED || !label?.isConnected || !input?.isConnected) return null;
    const group = input.closest('.customily_option.sports-font-family');
    const allowedValues = PROGRESSIVE_OPTION_ORDERS[input.name || ''] || [];
    const allowed = allowedValues.some((value) => lower(value) === lower(input.value || ''));
    const card = input.closest('.customily-swatch');
    if (!group || !allowed || !visible(group) || !visible(card) || group.dataset.gsProgressiveRole !== 'font-family') return null;
    const targetUrl = progressiveFontSwatchUrlForInput(input);
    const container = qs('.csh-image-container', label);
    if (!targetUrl || !container?.isConnected) return null;

    const images = qsa('img', container);
    const nativeImage = images.find((img) => img.dataset.gsOwnedFontSwatch !== 'true') || null;
    const ownedImages = images.filter((img) => img.dataset.gsOwnedFontSwatch === 'true');
    if (nativeImage) {
      ownedImages.forEach((owned) => {
        if (owned.dataset.gsSwatchRequest) delete owned.dataset.gsSwatchRequest;
        owned.remove();
      });
      return nativeImage;
    }

    const owned = ownedImages.shift() || document.createElement('img');
    ownedImages.forEach((duplicate) => duplicate.remove());
    if (!owned.isConnected) {
      owned.className = 'gs-progressive-font-swatch-image';
      owned.alt = '';
      owned.decoding = 'async';
      owned.draggable = false;
      owned.setAttribute('aria-hidden', 'true');
      owned.dataset.gsOwnedFontSwatch = 'true';
      container.appendChild(owned);
    }
    setDatasetIfChanged(container, 'gsSwatchOwner', 'golf-swag');
    return owned;
  }

  function queueProgressiveSwatchReconcile() {
    if (!CLUBHOUSE_ENABLED || isGuided() || state.swatchReconcileRaf) return;
    state.swatchReconcileRaf = window.requestAnimationFrame(() => {
      state.swatchReconcileRaf = 0;
      syncProgressiveSwatchTransitionFrame();
      syncProgressiveFontCards();
    });
  }

  function installProgressiveSwatchLifecycle(root) {
    if (!CLUBHOUSE_ENABLED || isGuided() || !root?.isConnected) return;
    const scope = root.closest('product-form') || root.closest('form[action*="/cart/add"]');
    if (!scope) return;
    if (state.swatchLifecycleScope !== scope) {
      state.swatchLifecycleObserver?.disconnect();
      state.swatchLifecycleScope = scope;
      state.swatchLifecycleObserver = new MutationObserver((records) => {
        const relevant = records.some((record) => {
          if (record.type === 'attributes') return !!record.target?.closest?.('.customily_option.sports-font-family');
          return [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 && (
            node.matches?.('#cl_optionsapp, .customily_option.sports-font-family, .csh-image-container, img')
            || node.querySelector?.('#cl_optionsapp, .customily_option.sports-font-family, .csh-image-container, img')
          ));
        });
        if (relevant) {
          // Geometry-only stamping is safe in the mutation callback and lands
          // before paint; image ownership remains rAF-batched below.
          syncProgressiveSwatchTransitionFrame();
          queueProgressiveSwatchReconcile();
        }
      });
      state.swatchLifecycleObserver.observe(scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset']
      });
    }
    if (!state.swatchLoadErrorBound) {
      state.swatchLoadErrorBound = true;
      const reconcileLoadedSwatch = (event) => {
        if (event.target?.matches?.('img') && event.target.closest?.('.customily_option.sports-font-family')) {
          queueProgressiveSwatchReconcile();
        }
      };
      document.addEventListener('load', reconcileLoadedSwatch, true);
      document.addEventListener('error', reconcileLoadedSwatch, true);
    }
    queueProgressiveSwatchReconcile();
  }

  function syncProgressiveFontCards() {
    const root = customilyRoot();
    if (!root || isGuided()) return;
    const fontCardSelector = isTeeAdapter()
      ? '[data-gs-progressive-role="font-style"] .customily-swatch.swatch label'
      : '[data-gs-progressive-role="font-style"] .customily-swatch.swatch label, [data-gs-progressive-role="font-family"] .customily-swatch.swatch label, [data-gs-progressive-role="monogram"] .customily-swatch.swatch label';
    qsa(fontCardSelector, root).forEach((label) => {
      const isFontStyle = !!label.closest('[data-gs-progressive-role="font-style"]');
      const isTeeFontCard = isTeeAdapter() && isFontStyle;
      const isCompactStandard = !isTeeAdapter() && !!label.closest('[data-gs-progressive-role="font-family"], [data-gs-progressive-role="monogram"]');
      const isCompactCard = isCompactStandard || isTeeFontCard;
      const isMonogram = !!label.closest('[data-gs-progressive-role="monogram"]');
      const isFontFamilyCard = !!label.closest('[data-gs-progressive-role="font-family"]');
      const mobile = !!window.matchMedia?.('(max-width: 749px)').matches;
      const fontPreviewHeight = '52px';
      const cardHeight = CLUBHOUSE_ENABLED
        ? (isCompactCard ? (isMonogram ? '74px' : fontPreviewHeight) : (isFontStyle ? (mobile ? '42px' : '48px') : '82px'))
        : (isCompactCard ? (isMonogram ? '74px' : '62px') : (isFontStyle ? '56px' : '82px'));
      const card = label.closest('.customily-swatch');
      const cardInputs = qsa('input[type="radio"]', card);
      const input = (label.htmlFor ? cardInputs.find((candidate) => candidate.id === label.htmlFor) : null) || cardInputs[0] || null;
      if (isFontStyle && input) {
        setStyleIfChanged(input, 'position', 'absolute');
        setStyleIfChanged(input, 'opacity', '0');
        setStyleIfChanged(input, 'pointer-events', 'none');
        setStyleIfChanged(input, 'width', '1px');
        setStyleIfChanged(input, 'height', '1px');
        setStyleIfChanged(input, 'margin', '0');
      }
      setStyleIfChanged(label, 'display', 'flex');
      setStyleIfChanged(label, 'width', '100%');
      setStyleIfChanged(label, 'min-width', '0');
      removeStyleIfPresent(label, 'max-width');
      setStyleIfChanged(label, 'height', cardHeight);
      setStyleIfChanged(label, 'min-height', cardHeight);
      removeStyleIfPresent(label, 'max-height');
      setStyleIfChanged(label, 'padding', CLUBHOUSE_ENABLED ? (isCompactCard ? (isMonogram ? '8px' : '3px') : (isFontStyle ? (mobile ? '0' : '0 16px') : '10px')) : (isCompactCard ? '6px' : (isFontStyle ? '9px 10px' : '10px')));
      setStyleIfChanged(label, 'background-color', '#ffffff');
      setStyleIfChanged(label, 'border-color', input?.checked ? (CLUBHOUSE_ENABLED ? '#D0B985' : '#151515') : (CLUBHOUSE_ENABLED ? '#E1E1DE' : '#E7E4DE'));
      setStyleIfChanged(label, 'border-radius', CLUBHOUSE_ENABLED && isCompactCard ? '20px' : '12px');
      setStyleIfChanged(label, 'box-shadow', CLUBHOUSE_ENABLED ? 'none' : '0 1px 2px rgba(20, 18, 14, 0.05)');
      if (isFontStyle && !isTeeFontCard) {
        const checked = !!input?.checked;
        if (CLUBHOUSE_ENABLED) {
          // Sprint 2026-07-04: match Asher's Choose Font Style reference.
          // Desktop = selected rounded-top tab connected to a light divider;
          // mobile = plain text tab with black underline. Gated to Clubhouse so
          // the non-Clubhouse progressive lane keeps its prior tab treatment.
          setStyleIfChanged(label, 'align-items', 'center');
          setStyleIfChanged(label, 'justify-content', mobile ? 'flex-start' : 'center');
          setStyleIfChanged(label, 'background-color', checked && !mobile ? '#ffffff' : 'transparent');
          setStyleIfChanged(label, 'border-style', 'solid');
          setStyleIfChanged(label, 'border-width', mobile ? '0 0 4px 0' : '1px');
          setStyleIfChanged(label, 'border-color', checked && !mobile ? '#E1E1DE' : 'transparent');
          setStyleIfChanged(label, 'border-bottom-color', mobile ? (checked ? '#151515' : 'transparent') : (checked ? '#ffffff' : 'transparent'));
          setStyleIfChanged(label, 'border-radius', mobile ? '0' : '18px 18px 0 0');
          setStyleIfChanged(label, 'box-shadow', 'none');
          if (checked && !mobile) {
            setStyleIfChanged(label, 'margin-bottom', '-1px');
            setStyleIfChanged(label, 'z-index', '2');
            setStyleIfChanged(label, 'position', 'relative');
          } else {
            removeStyleIfPresent(label, 'margin-bottom');
            removeStyleIfPresent(label, 'z-index');
          }
          const labelText = label.querySelector('.label-txt');
          if (labelText) {
            setStyleIfChanged(labelText, 'color', checked ? '#151515' : '#969692');
            setStyleIfChanged(labelText, 'font-size', mobile ? '16px' : '18px');
            setStyleIfChanged(labelText, 'font-weight', '900');
            setStyleIfChanged(labelText, 'line-height', '1.05');
            setStyleIfChanged(labelText, 'letter-spacing', '-0.04em');
            setStyleIfChanged(labelText, 'white-space', 'nowrap');
          }
        } else {
          setStyleIfChanged(label, 'background-color', checked ? '#ffffff' : 'transparent');
          setStyleIfChanged(label, 'border-color', checked ? '#151515' : '#E7E4DE');
          setStyleIfChanged(label, 'border-radius', '16px 16px 0 0');
          setStyleIfChanged(label, 'box-shadow', 'none');
          if (checked) {
            setStyleIfChanged(label, 'border-bottom-color', '#ffffff');
            setStyleIfChanged(label, 'margin-bottom', '-1px');
            setStyleIfChanged(label, 'z-index', '2');
            setStyleIfChanged(label, 'position', 'relative');
          } else {
            setStyleIfChanged(label, 'border-bottom-color', '#E7E4DE');
            removeStyleIfPresent(label, 'margin-bottom');
            removeStyleIfPresent(label, 'z-index');
          }
        }
      }
      setStyleIfChanged(label, 'color', isTeeFontCard ? 'transparent' : (isFontStyle ? (CLUBHOUSE_ENABLED ? (input?.checked ? '#151515' : '#969692') : '#151515') : 'transparent'));
      let hasReadyImage = false;
      const syncFallback = () => {
        const ready = qsa('img', label).some((candidate) => candidate.complete && candidate.naturalWidth > 0 && candidate.dataset.gsIconReady === 'true');
        syncProgressiveFontCardFallback(label, input, ready);
      };
      const ownedOrNativeFontImage = isFontFamilyCard ? ensureProgressiveFontSwatchImage(label, input) : null;
      const cardImages = ownedOrNativeFontImage ? [ownedOrNativeFontImage] : qsa('img', label);
      cardImages.forEach((img) => {
        const imageSize = isCompactCard ? (isMonogram ? '84%' : '82%') : '94%';
        setStyleIfChanged(img, 'width', imageSize);
        setStyleIfChanged(img, 'height', imageSize);
        setStyleIfChanged(img, 'max-width', imageSize);
        setStyleIfChanged(img, 'max-height', imageSize);
        setStyleIfChanged(img, 'object-fit', 'contain');
        setStyleIfChanged(img, 'transform', isCompactCard ? 'scale(1)' : 'scale(1.18)');
        if (CLUBHOUSE_ENABLED && isFontFamilyCard) {
          const transparentFontSwatchUrl = transparentFontSwatchUrlFor(img, input);
          if (transparentFontSwatchUrl) {
            const currentFontSwatchSrc = img.currentSrc || img.src || img.getAttribute('src') || '';
            if (!img.dataset.gsOriginalFontSwatchSrc) setDatasetIfChanged(img, 'gsOriginalFontSwatchSrc', currentFontSwatchSrc);
            setDatasetIfChanged(img, 'gsTransparentFontSwatch', 'true');
          }
          setStyleIfChanged(img, 'mix-blend-mode', 'multiply');
          setStyleIfChanged(img, 'filter', 'contrast(2.4) brightness(1.08)');
          setStyleIfChanged(img, 'background-color', 'transparent');
        }
        const targetUrl = (CLUBHOUSE_ENABLED && isFontFamilyCard ? transparentFontSwatchUrlFor(img, input) : '') || progressiveSwatchSrc(img);
        if (stabilizeProgressiveSwatchImage(img, input, targetUrl, syncFallback)) hasReadyImage = true;
      });
      syncProgressiveFontCardFallback(label, input, hasReadyImage);
    });
  }

  function syncMonogramInitialClearOnFocus() {
    const placeholders = new Set(['A', 'AB', 'ABC', 'X', 'XX', 'XXX', 'XYZ', '123']);
    qsa(MONOGRAM_INITIALS_SELECTOR).forEach((field) => {
      if (field.dataset.gsMonogramClearBound === '1') return;
      field.dataset.gsMonogramClearBound = '1';
      field.addEventListener('focus', () => {
        const value = norm(field.value).toUpperCase();
        if (!placeholders.has(value)) return;
        field.value = '';
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
        refreshSoon();
      }, true);
    });
  }

  function nextActionLabel(result) {
    if (result.ok) return 'Review design below, then Add to Cart.';
    return result.issues[0] || 'Finish the next required step.';
  }

  function buildInline() {
    const section = document.createElement('section');
    section.className = 'gs-progressive';
    section.innerHTML = `
      <div class="gs-progressive__eyebrow">Guided personalization</div>
      <div class="gs-progressive__head">
        <h2 class="gs-progressive__title">Build your customization step by step</h2>
        <span class="gs-progressive__step">Step 1 of 3</span>
      </div>
      <div class="gs-progressive__bar"><span></span></div>
      <div class="gs-progressive__status"></div>
      <div class="gs-progressive__next">
        <span>Choose a personalization path.</span>
        <button type="button">Continue</button>
      </div>
    `;
    return section;
  }

  function renderInline() {
    if (!state.inline) return;
    const result = validation();
    const step = stepNumber();
    state.inline.dataset.ready = result.ok ? 'true' : 'false';
    state.inline.querySelector('.gs-progressive__step').textContent = `Step ${step} of 3`;
    state.inlineTitle.textContent = isTeeAdapter() ? 'Build your custom tees step by step' : stepTitle(step);
    state.inlineProgress.style.width = `${Math.max(20, step * 33)}%`;
    state.inlineStatus.innerHTML = propertySummary().map(([key, value]) => `
      <span class="gs-progressive__status-item">
        <span>${escapeHtml(key)}</span><strong>${escapeHtml(value)}</strong>
      </span>
    `).join('');
    state.inlineNext.querySelector('span').textContent = nextActionLabel(result);
    state.inlineBtn.textContent = result.ok ? 'Review below' : 'Next required step';
  }

  function progressiveContinue() {
    const result = validation();
    if (result.ok) {
      markFinalConfirmReviewed();
      (finalConfirmBox()?.closest('.main-preview-with-checkbox') || realSubmitButton())?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    showProgressiveValidationNotice(result);
    focusRealNext();
  }

  // ---- R2-D01/R2-D02 (round 2, 2026-07-02): Clubhouse tile icon geometry ----
  // Customily's Vue stamps inline `width/height/min/max: 44px !important` on
  // every .csh-image-container while the theme/asset stylesheets size the img
  // INSIDE it, so the icon painted larger than its 44px flow box. Measured on
  // the served draft (analysis/round2-probe-before/): Choose Style segments
  // carried ~10px phantom inset per side (icon->text gap 18px vs the designed
  // 8px, systematic off-centre bias), and the method-card icon painted 75.4px
  // in a 44px flow slot, overlapping the caption by 5.2px on every card.
  // Stylesheets cannot beat Customily's inline !important, so the container
  // and img geometry are stamped at this (the winning) layer via the
  // diff-before-write helpers; the stylesheet keeps the SAME values as a
  // pre-stamp fallback (keep them in lockstep). Clubhouse lane only.
  function syncClubhouseTileIconGeometry() {
    if (!CLUBHOUSE_ENABLED || isGuided()) return;
    const root = customilyRoot();
    if (!root) return;
    const mobile = !!window.matchMedia?.('(max-width: 749px)').matches;
    const rootWidth = root.getBoundingClientRect().width;
    const intermediate = !mobile && rootWidth > 0 && rootWidth <= 560;
    const stampContainer = (box, fixedSize = '') => {
      // Wrap the img so flow box == painted box (kills Customily's 44px pin).
      setStyleIfChanged(box, 'width', fixedSize || 'auto');
      setStyleIfChanged(box, 'height', fixedSize || 'auto');
      setStyleIfChanged(box, 'min-width', fixedSize || '0');
      setStyleIfChanged(box, 'min-height', fixedSize || '0');
      setStyleIfChanged(box, 'max-width', fixedSize || 'none');
      setStyleIfChanged(box, 'max-height', fixedSize || 'none');
      setStyleIfChanged(box, 'display', 'flex');
      setStyleIfChanged(box, 'align-items', 'center');
      setStyleIfChanged(box, 'justify-content', 'center');
      setStyleIfChanged(box, 'flex', '0 0 auto');
    };
    const stampIcon = (img, size, pad) => {
      setStyleIfChanged(img, 'box-sizing', 'border-box');
      setStyleIfChanged(img, 'width', size);
      setStyleIfChanged(img, 'height', size);
      setStyleIfChanged(img, 'min-width', size);
      setStyleIfChanged(img, 'min-height', size);
      setStyleIfChanged(img, 'max-width', size);
      setStyleIfChanged(img, 'max-height', size);
      setStyleIfChanged(img, 'padding', pad);
      setStyleIfChanged(img, 'margin', '0');
      setStyleIfChanged(img, 'object-fit', 'contain');
      // Painted box must equal flow box: the 2026-06-30 desktop rule kept
      // transform:scale(1.45) on the method icon, so a 60px layout box still
      // painted 87px and overlapped the caption by 5.5px (round2-probe-after,
      // first pass). The visible mark size is preserved by an honest bigger
      // layout box instead of a scale hack.
      setStyleIfChanged(img, 'transform', 'none');
    };
    qsa('[data-gs-progressive-role="style"] .customily-swatch.swatch label', root).forEach((label) => {
      const input = label.htmlFor ? document.getElementById(label.htmlFor) : label.closest('.customily-swatch')?.querySelector('input[type="radio"]');
      const selected = !!input?.checked;
      setStyleIfChanged(label, 'background', '#ffffff');
      setStyleIfChanged(label, 'border', `${selected ? '2px' : '1px'} solid ${selected ? '#D0B985' : '#E7E7E7'}`);
      setStyleIfChanged(label, 'color', '#000000');
      setStyleIfChanged(label, 'position', 'relative');
      setStyleIfChanged(label, 'overflow', 'visible');
      setStyleIfChanged(label, 'box-sizing', 'border-box');
      const labelText = label.querySelector('.label-txt');
      if (labelText) setStyleIfChanged(labelText, 'color', '#000000');
      if (intermediate) {
        label.dataset.gsIntermediateChoiceLayout = 'true';
        setStyleIfChanged(label, 'display', 'grid');
        setStyleIfChanged(label, 'grid-template-columns', '1fr');
        setStyleIfChanged(label, 'grid-template-rows', '32px auto');
        setStyleIfChanged(label, 'place-items', 'center');
        setStyleIfChanged(label, 'row-gap', '4px');
        setStyleIfChanged(label, 'height', '66px');
        setStyleIfChanged(label, 'min-height', '66px');
        setStyleIfChanged(label, 'padding', '6px 4px');
        if (labelText) {
          setStyleIfChanged(labelText, 'grid-column', '1');
          setStyleIfChanged(labelText, 'grid-row', '2');
          setStyleIfChanged(labelText, 'width', '100%');
          setStyleIfChanged(labelText, 'min-width', '0');
          setStyleIfChanged(labelText, 'margin', '0');
          setStyleIfChanged(labelText, 'text-align', 'center');
          setStyleIfChanged(labelText, 'white-space', 'normal');
        }
      } else if (label.dataset.gsIntermediateChoiceLayout === 'true') {
        delete label.dataset.gsIntermediateChoiceLayout;
        ['display', 'grid-template-columns', 'grid-template-rows', 'place-items', 'row-gap', 'height', 'min-height', 'padding'].forEach((property) => removeStyleIfPresent(label, property));
        ['grid-column', 'grid-row', 'width', 'min-width', 'margin', 'text-align', 'white-space'].forEach((property) => removeStyleIfPresent(labelText, property));
      }
      const box = label.querySelector('.csh-image-container');
      if (box) stampContainer(box);
      // R2-D01: 28px at every width (mobile CSS already used 28px; desktop
      // goes 24 -> 28 per Asher's "slightly bigger" ask).
      const img = label.querySelector('img.gs-customily-provided-icon');
      if (img) {
        stampIcon(img, intermediate ? '30px' : '28px', '0px');
        if (intermediate) {
          setStyleIfChanged(img, 'grid-column', '1');
          setStyleIfChanged(img, 'grid-row', '1');
          setStyleIfChanged(img, 'align-self', 'center');
          setStyleIfChanged(img, 'justify-self', 'center');
        } else {
          ['grid-column', 'grid-row', 'align-self', 'justify-self'].forEach((property) => removeStyleIfPresent(img, property));
        }
      }
    });
    qsa('[data-gs-progressive-role="method"] .customily-swatch.swatch label', root).forEach((label) => {
      const box = label.querySelector('.csh-image-container');
      // Keep this in lockstep with the responsive containment CSS. At a
      // constrained desktop component width, both wrapper and image are 42px;
      // wide desktop remains 59px and mobile remains 54px.
      const methodSize = intermediate ? '42px' : (mobile ? '54px' : '59px');
      if (box) stampContainer(box, methodSize);
      // Mobile remains the approved 54px box. Owner-directed 2026-07-16:
      // desktop Images icons are 30% smaller (84px -> 59px) so the cards can
      // tighten vertically without changing the mobile presentation.
      const img = label.querySelector('img.gs-customily-provided-icon');
      if (img) stampIcon(img, methodSize, mobile ? '7px' : '0px');
    });
  }



  function syncTextEntryFieldDepth() {
    if (isGuided()) return;
    const root = customilyRoot();
    if (!root) return;
    qsa('[data-gs-progressive-role="text"] textarea, [data-gs-progressive-role="text"] input[type="text"], [data-gs-progressive-role="text"] .custom-textarea, [data-gs-progressive-role="initials"] textarea, [data-gs-progressive-role="initials"] input[type="text"]', root).forEach((field) => {
      setStyleIfChanged(field, 'box-shadow', 'inset 1px 0 0 rgba(255,255,255,.78), inset 0 1px 0 rgba(255,255,255,.82), -2px 4px 10px rgba(43,34,15,.045), 0 7px 16px rgba(43,34,15,.035)');
      field.dataset.gsTextEntryDepth = 'true';
    });
  }

  function syncProgressiveRadioAccessibility() {
    if (isGuided()) return;
    const root = customilyRoot();
    if (!root) return;
    const radios = qsa('input[type="radio"]', root).filter((input) => !input.disabled && input.name);
    const groups = new Map();
    radios.forEach((input) => {
      if (!groups.has(input.name)) groups.set(input.name, []);
      groups.get(input.name).push(input);
    });
    groups.forEach((inputs) => {
      const selected = inputs.find((input) => input.checked) || inputs[0];
      inputs.forEach((input) => {
        const labelSelector = input.id ? `label[for="${CSS.escape(input.id)}"]` : '';
        const label = (labelSelector && qs(labelSelector, input.closest('.customily-swatch, .swatch') || input.parentElement))
          || (labelSelector && qs(labelSelector, root))
          || input.closest('label');
        if (!label) return;
        const accessibleName = String(
          label.getAttribute('aria-label')
          || label.innerText
          || qs('img[alt]', label)?.getAttribute('alt')
          || input.value
          || 'Customization option'
        ).replace(/\s+/g, ' ').trim();
        label.dataset.gsProgressiveRadioKeyboard = 'true';
        label.setAttribute('role', 'radio');
        label.setAttribute('aria-checked', input.checked ? 'true' : 'false');
        label.setAttribute('aria-label', accessibleName);
        label.tabIndex = input === selected ? 0 : -1;
        if (label.__gsProgressiveRadioKeyboardBound === true) return;
        label.__gsProgressiveRadioKeyboardBound = true;
        label.addEventListener('keydown', (event) => {
          const activation = event.key === 'Enter' || event.key === ' ';
          const direction = ['ArrowRight', 'ArrowDown'].includes(event.key)
            ? 1
            : ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 0;
          if (!activation && !direction) return;
          event.preventDefault();
          if (activation) {
            label.click();
            refreshSoon();
            return;
          }
          const currentInputs = qsa('input[type="radio"]', root).filter((candidate) => !candidate.disabled && candidate.name === input.name);
          const index = currentInputs.indexOf(input);
          if (index < 0 || currentInputs.length < 2) return;
          const next = currentInputs[(index + direction + currentInputs.length) % currentInputs.length];
          const nextValue = next.value;
          const nextName = next.name;
          const nextSelector = next.id ? `label[for="${CSS.escape(next.id)}"]` : '';
          const nextLabel = (nextSelector && qs(nextSelector, next.closest('.customily-swatch, .swatch') || next.parentElement))
            || (nextSelector && qs(nextSelector, root))
            || next.closest('label');
          nextLabel?.focus();
          nextLabel?.click();
          window.setTimeout(() => {
            syncProgressiveRadioAccessibility();
            const liveInput = qsa('input[type="radio"]', customilyRoot() || document).find((candidate) => candidate.name === nextName && candidate.value === nextValue);
            const liveSelector = liveInput?.id ? `label[for="${CSS.escape(liveInput.id)}"]` : '';
            const liveLabel = (liveSelector && qs(liveSelector, liveInput?.closest('.customily-swatch, .swatch') || liveInput?.parentElement))
              || (liveSelector && qs(liveSelector, customilyRoot() || document))
              || liveInput?.closest('label');
            liveLabel?.focus();
          }, 0);
        });
      });
      const group = inputs[0]?.closest('[role="radiogroup"], .swatch-container');
      if (group && !group.getAttribute('aria-label') && !group.getAttribute('aria-labelledby')) {
        const option = group.closest('.customily_option');
        const heading = qs('.option_name, .font-color-label, [data-gs-option-heading]', option || root);
        const groupName = String(heading?.textContent || inputs[0]?.name || 'Customization options').replace(/^properties\[|\]$/g, '').trim();
        group.setAttribute('aria-label', groupName);
      }
    });
  }

  function syncProductGalleryInteractionGate() {
    const gallery = qs('swiper-product-gallery[handle="product-gallery"]');
    const swiper = gallery?.instance;
    if (!gallery || !swiper || swiper.destroyed) return;
    const customilyMounted = document.documentElement.classList.contains('gs-customily-progressive-enabled')
      && !!gallery.closest('.main-product__media')?.querySelector('.cl-canvas-container');
    if (customilyMounted) {
      if (!gallery.dataset.gsCustomilyOriginalAllowTouchMove) {
        gallery.dataset.gsCustomilyOriginalAllowTouchMove = swiper.allowTouchMove === false ? 'false' : 'true';
      }
      swiper.allowTouchMove = false;
      gallery.dataset.gsCustomilyInteractionLocked = 'true';
      return;
    }
    if (gallery.dataset.gsCustomilyInteractionLocked === 'true') {
      swiper.allowTouchMove = gallery.dataset.gsCustomilyOriginalAllowTouchMove !== 'false';
      delete gallery.dataset.gsCustomilyInteractionLocked;
      delete gallery.dataset.gsCustomilyOriginalAllowTouchMove;
    }
  }

  // ---- Refresh / sync ----
  function refresh() {
    if (!state.booted) return;
    syncImagePreviewMemory();
    syncShopifyPreviewBarOffset();
    ensurePreviewSurfaceStyles();
    syncFloatingPreviewCanvasMirror();
    syncFloatingPreviewGate();
    syncFloatingPreviewActiveGate();
    syncProductGalleryInteractionGate();
    ensureFloatingPreviewControls();
    syncExpandedPopupFixes();
    syncFinalConfirmForProgressive();
    if (!isGuided()) {
      applyProgressiveRoles();
      ensureBrowseFirstDependentSelections();
      applyProgressiveRoles();
      syncImageMethodOrder();
      syncProgressiveOptionOrder();
      applyProgressiveVisibility();
      syncProgressiveCustomizationMethodCards();
      syncNativeVariantSelectedLabels();
      syncProgressiveUploadControls();

      syncProgressiveChoiceGridCaps();
      syncClubhouseTileIconGeometry();
      syncTextEntryFieldDepth();
      syncProgressiveFontCards();
      hardenProgressiveFontMedia();
      syncProgressiveOptionOrder();
      syncProgressiveColorControls();
      syncProgressiveRadioAccessibility();
      syncMonogramInitialClearOnFocus();
      ensureSingleSelectionBadgeStyles();
      renderInline();
      ensureMobileInitialUiVisible();
      if (!state.floatingPreviewBootRestoreRequested
        && chosenStyle() === 'Images'
        && hasFileAttached()
        && !state.floatingPreviewConvergence
        && !state.floatingPreviewConvergenceRequest) {
        state.floatingPreviewBootRestoreRequested = true;
        requestFloatingPreviewConvergence('boot-restore');
      }
      return;
    }
    relocateRealGroups();
    const hash = [chosenStyle(), chosenImageMethod(), hasFileAttached(), visibleTextValue(), selectedMonogram(), consentChecked(), fileInputs().length, qsa(STYLE_SELECTOR).length, qsa(IMAGE_METHOD_SELECTOR).length].join('|');
    if (hash !== state.lastHash) {
      state.lastHash = hash;
      renderPathCards();
      renderMethodChips();
    }
    renderConsentProxy();
    renderStatusRail();
    setShellView();
    setProgress();
    syncPreview();
    if (state.review && state.review.classList.contains('is-open')) fillReview();
  }

  function refreshSoon() {
    // R2-D08/R2-D09 (round 2, 2026-07-02): Customily re-render storms (color
    // switch = ~2900 mutation records; boot = hundreds) used to queue one full
    // refresh() per observer callback with no gating, stacking redundant rAF
    // refreshes back-to-back (measured max 115ms per run). Coalesce to at most
    // ONE queued refresh per animation frame; behavior is unchanged because
    // refresh() is a full idempotent resync.
    const directManipulationActive = state.floatingPreviewDragging
      || !!state.floatingPreviewPinchStart
      || state.zoomDragging
      || !!state.zoomPinchStart
      || !!qs('.customily-cart-preview__stage[data-panning="true"], .customily-cart-preview__stage[data-pinching="true"]');
    if (directManipulationActive) {
      state.refreshDeferredForPan = true;
      return;
    }
    if (state.refreshRafQueued) return;
    state.refreshRafQueued = true;
    window.requestAnimationFrame(() => {
      state.refreshRafQueued = false;
      const panStarted = state.floatingPreviewDragging
        || !!state.floatingPreviewPinchStart
        || state.zoomDragging
        || !!state.zoomPinchStart
        || !!qs('.customily-cart-preview__stage[data-panning="true"], .customily-cart-preview__stage[data-pinching="true"]');
      if (panStarted) {
        state.refreshDeferredForPan = true;
        return;
      }
      state.refreshDeferredForPan = false;
      // Restore supplied icon ownership before the larger progressive refresh.
      // A cold, unselected form can stop that refresh before the old post-call.
      if (typeof window.__gsCustomilySaneHydrate === 'function') window.__gsCustomilySaneHydrate();
      refresh();
      syncProgressiveSwatchTransitionFrame();
    });
  }

  function flushRefreshDeferredForPan() {
    if (!state.refreshDeferredForPan) return;
    state.refreshDeferredForPan = false;
    window.requestAnimationFrame(refreshSoon);
  }

  function scheduleProgressiveCardRestampBurst() {
    if (isGuided()) return;
    // PR69 visual lock: Customily/Vue can replace Choose Style, Images method,
    // and active font-family groups after the native click/change event. A
    // single observer tick can sample an intermediate card/font state before
    // our layout, height, badge, and image hardening restamps land. Keep this
    // scoped to the known card/group controls and re-run the already-idempotent
    // sync pipeline after the known repaint windows; no broad selectors or
    // color writes are added.
    state.progressiveCardRestampTimers.splice(0).forEach((timer) => window.clearTimeout(timer));
    refreshSoon();
    [90, 220, 520, 900, 1350].forEach((delay) => {
      state.progressiveCardRestampTimers.push(window.setTimeout(refreshSoon, delay));
    });
  }

  function ensureMobileInitialUiVisible() {
    if (!isTeeAdapter() || state.mobileInitialUiScrollDone) return;
    if (!window.matchMedia?.('(max-width: 749px)').matches) return;
    const root = customilyRoot();
    if (!root) return;
    state.mobileInitialUiScrollDone = true;
    const scrollIfStillBuried = () => {
      // If the customer has already moved meaningfully, do not fight them.
      if (window.scrollY > 120) return;
      const rect = root.getBoundingClientRect();
      const buriedBelowFold = rect.top > window.innerHeight * 0.58;
      const hiddenAboveFold = rect.bottom < 80;
      if (buriedBelowFold || hiddenAboveFold) root.scrollIntoView({ behavior: 'auto', block: 'center' });
    };
    state.mobileInitialUiScrollTimers.splice(0).forEach((timer) => window.clearTimeout(timer));
    state.mobileInitialUiScrollTimers.push(window.setTimeout(scrollIfStillBuried, 650));
    state.mobileInitialUiScrollTimers.push(window.setTimeout(scrollIfStillBuried, 1700));
  }

  // ---- Studio open/close ----
  function openStudio() {
    state.open = true;
    state.shell.classList.add('is-open');
    state.shell.hidden = false;
    document.documentElement.classList.add('gs-customily-guided-studio-open');
    refreshSoon();
  }
  function closeStudio() {
    state.open = false;
    state.shell.classList.remove('is-open');
    closeReview();
    document.documentElement.classList.remove('gs-customily-guided-studio-open');
  }

  function focusRealNext() {
    if (isTeeAdapter()) {
      let target = null;
      if (hasPlaceholderText()) target = textFields()[0] || qs(TEXT_SELECTOR);
      else if (!selectedFontStyle()) target = qs(FONT_STYLE_SELECTOR);
      else if (!selectedDesignColor()) target = selectedDesignColorInput() || activeDesignColorInputs()[0];
      const scrollTarget = target ? (cardFor(target) || labelFor(target) || target) : customilyRoot();
      scrollTarget?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target?.focus?.({ preventScroll: true });
      return;
    }
    const style = chosenStyle();
    let target = null;
    if (!style) target = radioByValue(STYLE_SELECTOR, 'Images') || qs(STYLE_SELECTOR);
    else if (style === 'Images' && !chosenImageMethod()) target = radioByValue(IMAGE_METHOD_SELECTOR, 'Upload Image') || qs(IMAGE_METHOD_SELECTOR);
    else if (style === 'Images' && !hasImagePreviewReady()) target = fileInputs()[0] || qs(FILE_SELECTOR);
    else if (style === 'Images' && consentRequired() && !consentChecked()) target = artworkConsent();
    else if (style === 'Custom Text' && hasPlaceholderText()) target = textFields()[0] || qs(TEXT_SELECTOR);
    else if (style === 'Monogram' && !selectedMonogram()) target = qs(MONOGRAM_SELECTOR);
    else if (style === 'Monogram' && hasPlaceholderInitials()) target = monogramInitialFields()[0] || qs(MONOGRAM_INITIALS_SELECTOR);
    const scrollTarget = target ? (cardFor(target) || labelFor(target) || target) : state.shell;
    scrollTarget?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target?.focus?.({ preventScroll: true });
  }

  function openReview() {
    if (!validation().ok) { const result = validation(); showProgressiveValidationNotice(result); focusRealNext(); return; }
    fillReview();
    state.review.classList.add('is-open');
    state.review.hidden = false;
    document.documentElement.classList.add('gs-customily-guided-studio-review-open');
  }
  function closeReview() {
    state.review.classList.remove('is-open');
    document.documentElement.classList.remove('gs-customily-guided-studio-review-open');
  }

  function guardedSubmit(evt) {
    if (!enhancementEnabled()) return;
    syncImagePreviewMemory();
    const guardedResult = validation();
    if (!guardedResult.ok) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (isGuided() && !state.open) openStudio();
      showProgressiveValidationNotice(guardedResult);
      focusRealNext();
      return;
    }
    if (isGuided()) { markFinalConfirmReviewed(); return; }
    if (state.approvalSubmitting) {
      if (state.approvalNativeClickConsumed) {
        markFinalConfirmReviewed();
        return;
      }
      evt.preventDefault();
      evt.stopImmediatePropagation();
      return;
    }
    blockForApproval(evt);
  }

  function isVisibleCustomilyButton(el) {
    const button = el?.closest?.('button, [type="button"], [name="add"]') || el;
    return !!button && button.id === 'customily-cart-btn';
  }

  function isNativeProductSubmit(el) {
    const button = el?.closest?.('button, [type="submit"], [name="add"]') || el;
    if (!button) return false;
    return button !== customilyCartButton()
      && button.matches?.('[type="submit"][name="add"], button[type="submit"]')
      && !!button.closest?.('form[action*="/cart/add"]');
  }

  function isAddButtonTarget(target) {
    return !!(target && target.closest && target.closest('button[name="add"], [type="submit"][name="add"], form[action*="/cart/add"] button[name="add"]'));
  }

  function guardAddButtonActivation(evt) {
    if (!enhancementEnabled() || !isAddButtonTarget(evt.target)) return;
    syncImagePreviewMemory();
    const activationResult = validation();
    if (!activationResult.ok) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (isGuided() && !state.open) openStudio();
      showProgressiveValidationNotice(activationResult);
      focusRealNext();
      return;
    }
    if (isGuided()) {
      markFinalConfirmReviewed();
      return;
    }
    if (state.approvalSubmitting) {
      if (evt.type === 'click' && isVisibleCustomilyButton(evt.target)) {
        if (state.approvalVisibleClickConsumed) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          return;
        }
        state.approvalVisibleClickConsumed = true;
        return;
      }
      if (evt.type === 'click' && isNativeProductSubmit(evt.target)) {
        if (!state.approvalVisibleClickConsumed || state.approvalNativeClickConsumed) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          return;
        }
        state.approvalNativeClickConsumed = true;
        return;
      }
      evt.preventDefault();
      evt.stopImmediatePropagation();
      return;
    }
    blockForApproval(evt);
  }

  function confirmAndSubmit() {
    if (!validation().ok) { const result = validation(); showProgressiveValidationNotice(result); fillReview(); focusRealNext(); return; }
    markFinalConfirmReviewed();
    closeReview();
    closeStudio();
    realSubmitButton()?.click();
  }

  // ---- DOM construction ----
  function buildLauncher() {
    const card = document.createElement('section');
    card.className = 'gs-shell-launcher';
    card.innerHTML = `
      <div class="gs-shell-launcher__eyebrow">Make it yours</div>
      <h2 class="gs-shell-launcher__title">Logo, photo, text or monogram</h2>
      <p class="gs-shell-launcher__note">Personalize this product in a few guided steps. Your real design data is saved exactly as Customily expects.</p>
      <button type="button" class="gs-shell-launcher__cta">Start personalizing</button>
    `;
    return card;
  }

  function buildShell() {
    const shell = document.createElement('section');
    shell.className = 'gs-shell';
    shell.hidden = true;
    shell.dataset.view = 'path';
    shell.innerHTML = `
      <div class="gs-shell__nav">
        <button type="button" class="gs-shell__back" aria-label="Back">‹</button>
        <span class="gs-shell__step">Step 1 of 3</span>
        <button type="button" class="gs-shell__close" aria-label="Close">×</button>
      </div>
      <div class="gs-shell__progress"><span></span></div>
      <div class="gs-shell__scroll">
        <h2 class="gs-shell__title">How do you want to personalize?</h2>
        <div class="gs-shell-status" data-gs-host="status"></div>

        <div class="gs-shell-section gs-shell-section--path">
          <div class="gs-shell-path" data-gs-host="path"></div>
        </div>

        <div class="gs-shell-section gs-shell-section--method" data-gs-host="method-wrap" hidden>
          <div class="gs-shell-section__label">Choose a method</div>
          <div class="gs-shell-chips" data-gs-host="method"></div>
        </div>

        <div class="gs-shell-section gs-shell-section--preview">
          <div class="gs-shell-preview">
            <div class="gs-shell-preview__label">Live preview</div>
            <div class="gs-shell-preview__body"><span class="gs-shell-preview__placeholder">Your design appears here</span></div>
          </div>
        </div>

        <div class="gs-shell-section gs-shell-section--upload" data-gs-host="upload-wrap">
          <div class="gs-shell-upload">
            <div class="gs-shell-upload__head">
              <div class="gs-shell-upload__title">Upload your artwork</div>
              <div class="gs-shell-upload__hint">PNG, JPG, SVG or PDF. Drop a file or browse below.</div>
            </div>
            <div class="gs-shell-upload__real"></div>
          </div>
        </div>

        <div class="gs-shell-section gs-shell-section--detail" data-gs-host="detail-wrap">
          <div class="gs-shell-detail">
            <div class="gs-shell-detail__real"></div>
          </div>
        </div>

        <div class="gs-shell-section gs-shell-section--consent" data-gs-host="consent"></div>
      </div>

      <div class="gs-shell__footer">
        <span class="gs-shell__footer-hint">Choose a personalization path.</span>
        <button type="button" class="gs-shell__footer-btn">Continue</button>
      </div>
    `;
    return shell;
  }

  function buildReview() {
    const review = document.createElement('aside');
    review.className = 'gs-shell-review';
    review.hidden = true;
    review.innerHTML = `
      <div class="gs-shell-review__grab"></div>
      <div class="gs-shell-review__header">
        <h3 class="gs-shell-review__title">Review your design</h3>
        <button type="button" class="gs-shell-review__close" aria-label="Close">×</button>
      </div>
      <div class="gs-shell-review__list"></div>
      <div class="gs-shell-review__error" hidden></div>
      <button type="button" class="gs-shell-review__submit">Add to cart</button>
    `;
    return review;
  }

  function bind() {
    state.launcher.querySelector('.gs-shell-launcher__cta').addEventListener('click', openStudio);
    state.backBtn.addEventListener('click', () => {
      // Back de-selects path to return to step 1, otherwise closes.
      if (chosenStyle()) { const c = qsa(STYLE_SELECTOR).find((i) => i.checked); if (c) { c.checked = false; c.dispatchEvent(new Event('change', { bubbles: true })); } refreshSoon(); }
      else closeStudio();
    });
    state.shell.querySelector('.gs-shell__close').addEventListener('click', closeStudio);
    state.footerBtn.addEventListener('click', () => {
      if (validation().ok) openReview();
      else focusRealNext();
    });
    state.review.querySelector('.gs-shell-review__close').addEventListener('click', closeReview);
    state.reviewSubmit.addEventListener('click', confirmAndSubmit);

    bindShared();
  }

  function bindProgressive() {
    state.inlineBtn.addEventListener('click', progressiveContinue);
    bindShared();
  }

  function bindShared() {
    productForm()?.addEventListener('submit', guardedSubmit, true);
    if (document.documentElement.dataset.gsZoomPanIdleBound !== 'true') {
      document.documentElement.dataset.gsZoomPanIdleBound = 'true';
      document.addEventListener('gs:zoom-pan-idle', flushRefreshDeferredForPan);
    }
    const armNoUploadImagesSelection = (target) => {
      const clickedLabel = target?.closest?.('label');
      const intendedStyle = target?.matches?.('input[type="radio"][name="properties[Choose Style]"]')
        ? target
        : (clickedLabel?.control || (clickedLabel?.htmlFor ? document.getElementById(clickedLabel.htmlFor) : null));
      const intendedImages = intendedStyle?.value === 'Images'
        || /^Images(?:\s|$)/.test(clickedLabel?.textContent?.trim() || '');
      if (!nativeEditorPopupMobileAllowed()
        || !intendedImages
        || chosenStyle() === 'Images'
        || hasDefiniteFileAttachment()
        || confirmedUploadRecord()?.ready === true) return;
      state.noUploadImagesTransitionToken = Number(state.noUploadImagesTransitionToken || 0) + 1;
      const transitionToken = state.noUploadImagesTransitionToken;
      state.pendingNoUploadImagesPreviousStyle = state.pendingNoUploadImagesPreviousStyle || chosenStyle();
      state.pendingNoUploadImagesPreviousMirrorFingerprint = state.pendingNoUploadImagesPreviousMirrorFingerprint
        || qs('#preview-canvas-popup2')?.dataset.gsFloatingMirrorFingerprint
        || '';
      state.pendingNoUploadImagesSelection = true;
      setNoUploadImagesTransitionHold(true);
      watchNoUploadImagesTransitionHold(transitionToken);
      invalidateFloatingPreviewMirror();
      syncFloatingPreviewGate();
    };
    if (!state.floatingViewportListenerBound) {
      state.floatingViewportListenerBound = true;
      const queueFloatingViewportSync = () => {
        if (state.floatingViewportRaf) return;
        state.floatingViewportRaf = window.requestAnimationFrame(() => {
          state.floatingViewportRaf = 0;
          syncFloatingPreviewCanvasMirror();
          syncFloatingPreviewGate();
          syncFloatingPreviewActiveGate();
        });
      };
      window.addEventListener('scroll', queueFloatingViewportSync, { passive: true });
      window.addEventListener('resize', queueFloatingViewportSync, { passive: true });
      window.visualViewport?.addEventListener?.('resize', queueFloatingViewportSync, { passive: true });
      window.visualViewport?.addEventListener?.('scroll', queueFloatingViewportSync, { passive: true });
      let responsiveChoiceFrame = 0;
      const queueResponsiveChoiceSync = () => {
        if (responsiveChoiceFrame) return;
        responsiveChoiceFrame = window.requestAnimationFrame(() => {
          responsiveChoiceFrame = 0;
          syncImageMethodOrder();
          syncClubhouseTileIconGeometry();
        });
      };
      window.addEventListener('resize', queueResponsiveChoiceSync, { passive: true });
      window.addEventListener('orientationchange', queueResponsiveChoiceSync, { passive: true });
      window.visualViewport?.addEventListener?.('resize', queueResponsiveChoiceSync, { passive: true });
      const choiceRoot = customilyRoot();
      if (choiceRoot && window.ResizeObserver && !choiceRoot.__gsChoiceResizeObserver) {
        let previousCompact = null;
        choiceRoot.__gsChoiceResizeObserver = new ResizeObserver((entries) => {
          const width = entries[0]?.contentRect?.width || choiceRoot.getBoundingClientRect().width;
          const compact = !window.matchMedia?.('(max-width: 749px)').matches && width > 0 && width <= 560;
          if (compact === previousCompact) return;
          previousCompact = compact;
          queueResponsiveChoiceSync();
        });
        choiceRoot.__gsChoiceResizeObserver.observe(choiceRoot);
      }
      const queueWakeSync = () => {
        if (document.visibilityState === 'hidden') return;
        queueFloatingViewportSync();
        queueResponsiveChoiceSync();
        ensureFloatingPreviewControls();
      };
      document.addEventListener('visibilitychange', queueWakeSync, { passive: true });
      window.addEventListener('pageshow', queueWakeSync, { passive: true });
    }
    document.addEventListener('pointerdown', (event) => armNoUploadImagesSelection(event.target), true);
    const controlChangeIsNoOp = (target) => {
      if (!target?.matches?.('input[type="radio"][name]')) return false;
      const key = target.name;
      const selected = qsa('input[type="radio"][name]').find((input) => input.name === key && input.checked);
      const value = norm(selected?.value || '');
      const previous = state.lastControlChangeValues.get(key);
      state.lastControlChangeValues.set(key, value);
      return previous !== undefined && previous === value;
    };
    document.addEventListener('change', (event) => {
      if (event.__gsSurfaceNudge === true) return;
      const target = event.target;
      const noOpControlChange = controlChangeIsNoOp(target);
      resetApprovalForCustomizationChange(target);
      refreshSoon();
      if (target?.matches?.(FILE_SELECTOR) && target.files?.length) {
        rememberPendingUpload(target);
        state.imagePreviewReady = false;
        cancelNativeEditorOpenWait();
      }
      if (!noOpControlChange && target?.matches?.(`${FILE_SELECTOR}, ${CUSTOMIZATION_METHOD_SELECTOR}, ${STYLE_SELECTOR}, ${IMAGE_METHOD_SELECTOR}, ${FONT_STYLE_SELECTOR}, ${DESIGN_COLOR_SELECTOR}, ${TEE_DESIGN_COLOR_SELECTOR}, ${MONOGRAM_SELECTOR}, ${TEXT_SELECTOR}, ${MONOGRAM_INITIALS_SELECTOR}`)) {
        requestFloatingPreviewConvergence(target.matches(IMAGE_METHOD_SELECTOR) ? 'image-method-change' : 'control-change');
      }
      if (!noOpControlChange && target?.matches?.(`${CUSTOMIZATION_METHOD_SELECTOR}, ${STYLE_SELECTOR}, ${IMAGE_METHOD_SELECTOR}, ${FONT_STYLE_SELECTOR}`)) scheduleProgressiveCardRestampBurst();
      if (!noOpControlChange && state.nativeEditorOpenWait && target?.matches?.(`${STYLE_SELECTOR}, ${IMAGE_METHOD_SELECTOR}`)) cancelNativeEditorOpenWait();
      // Product variant changes can cause Customily to swap the tee color-property group
      // after the Shopify variant event has already fired. Re-scan shortly after so
      // Design Color / B vs Design Color / W gets the progressive role every time.
      if (isTeeAdapter() && target?.matches?.('input[type="radio"]:not([name^="properties["])')) {
        state.teeVariantRescanTimers.splice(0).forEach((timer) => window.clearTimeout(timer));
        state.teeVariantRescanTimers.push(window.setTimeout(refreshSoon, 450));
        state.teeVariantRescanTimers.push(window.setTimeout(refreshSoon, 1400));
      }
    }, true);
    document.addEventListener('input', (event) => {
      const target = event.target;
      resetApprovalForCustomizationChange(target);
      if (target?.matches?.(FILE_SELECTOR)) {
        if (target.files?.length) {
          rememberPendingUpload(target);
          state.imagePreviewReady = false;
          cancelNativeEditorOpenWait();
        }
        requestFloatingPreviewConvergence('control-change');
      }
      const isPreviewTextInput = target && target.matches && target.matches(`${TEXT_SELECTOR}, ${MONOGRAM_INITIALS_SELECTOR}`);
      if (!isPreviewTextInput) { refreshSoon(); return; }
      requestFloatingPreviewConvergence('control-change');
      window.clearTimeout(state.previewReadyDebounce);
      state.previewReadyDebounce = window.setTimeout(refreshSoon, 300);
    }, true);
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (target && target.closest && target.closest('[data-gs-progressive-role="style"] input[type="radio"], [data-gs-progressive-role="style"] label, [data-gs-progressive-role="method"] input[type="radio"], [data-gs-progressive-role="method"] label, [data-gs-progressive-role="font-style"] input[type="radio"], [data-gs-progressive-role="font-style"] label')) {
        scheduleProgressiveCardRestampBurst();
      }
      if (target && target.closest && target.closest('[data-gs-progressive-role="color"] .change-color-btn, [data-gs-progressive-role="color"] input[type="radio"], [data-gs-progressive-role="color"] label')) {
        setTimeout(refreshSoon, 80);
      }
      const removeControl = target?.closest?.('.cl_remove-image, [aria-label*="Remove"], [aria-label*="remove"], [title*="Remove"], [title*="remove"]');
      if (removeControl
        && !removeControl.closest?.('[data-gs-progressive-role="method"]')
        && !removeControl.matches?.(IMAGE_METHOD_SELECTOR)) {
        invalidateConfirmedUpload('remove');
        cancelNativeEditorOpenWait();
        scheduleImagePreviewClear();
      }
      if (target && target.closest && target.closest('#preview-main-popup, #preview-canvas-popup2, #preview-canvas-popup, .canvas-expand-label, .main-product__media.popup-active')) {
        window.setTimeout(syncExpandedPopupFixes, 80);
        window.setTimeout(syncExpandedPopupFixes, 360);
      }
      // Use the browser's completed activation signal. Touch scroll gestures do
      // not produce a click, while an intentional tap, mouse click, or keyboard
      // activation does. Opening approval on pointerdown made the CTA fire before
      // the browser could distinguish a tap from a scroll brush.
      guardAddButtonActivation(event);
    }, true);
    if (document.documentElement.dataset.gsSwatchPostHandlerBound !== 'true') {
      document.documentElement.dataset.gsSwatchPostHandlerBound = 'true';
      let postCustomilySwatchStampQueued = false;
      const roleScopedTransitionControl = '[data-gs-progressive-role="style"] input[type="radio"], [data-gs-progressive-role="style"] label, [data-gs-progressive-role="font-style"] input[type="radio"], [data-gs-progressive-role="font-style"] label';
      const queuePostCustomilySwatchStamp = () => {
        if (!CLUBHOUSE_ENABLED || isGuided() || postCustomilySwatchStampQueued) return;
        postCustomilySwatchStampQueued = true;
        // These listeners run in bubble phase, after Customily's target handler.
        // Vue may commit dependent swatches in its own microtask, so queue ours
        // behind it and stamp once more at the next pre-paint rAF boundary.
        window.queueMicrotask(() => {
          postCustomilySwatchStampQueued = false;
          syncProgressiveSwatchTransitionFrame();
          window.requestAnimationFrame(syncProgressiveSwatchTransitionFrame);
        });
      };
      document.addEventListener('click', (event) => {
        if (event.target?.closest?.(roleScopedTransitionControl)) queuePostCustomilySwatchStamp();
      });
      document.addEventListener('change', (event) => {
        if (event.__gsSurfaceNudge === true) return;
        if (event.target?.matches?.(`${STYLE_SELECTOR}, ${FONT_STYLE_SELECTOR}`) || event.target?.closest?.(roleScopedTransitionControl)) {
          queuePostCustomilySwatchStamp();
        }
      });
    }
    document.addEventListener('keydown', (event) => {
      if ((event.key === 'Enter' || event.key === ' ') && event.target && event.target.closest && event.target.closest('[data-gs-progressive-role="color"] .change-color-btn')) {
        event.target.closest('[data-gs-progressive-role="color"] .change-color-btn')?.click();
      }
    }, true);
    document.addEventListener('customily-options-loaded', refreshSoon);
    document.addEventListener('customily-product-loaded', refreshSoon);
  }

  function failClosed(reason, root = customilyRoot()) {
    state.familyFailClosed = true;
    suppressForFamily(reason);
    root?.classList.remove('gs-progressive-customily-root', 'gs-guided-customily-root');
    if (state.observer) state.observer.disconnect();
    if (state.swatchLifecycleObserver) state.swatchLifecycleObserver.disconnect();
    state.swatchLifecycleObserver = null;
    state.swatchLifecycleScope = null;
    if (state.swatchReconcileRaf) window.cancelAnimationFrame(state.swatchReconcileRaf);
    state.swatchReconcileRaf = 0;
    state.booted = false;
  }

  function scheduleStandardFamilyAssertion(root) {
    window.setTimeout(() => {
      if (!enhancementEnabled() || !root || qsa(STYLE_SELECTOR).length) return;
      const hasAlternativeCustomilyControls = qsa('input[name="properties[Choose Customization Type]"], input[name="properties[Design Color / B]"], input[name="properties[Design Color / W]"], input[name="properties[Choose Font Style]"], input[name="properties[Add Text]"]').length > 0;
      if (hasAlternativeCustomilyControls) failClosed('standard-family-assertion-failed');
    }, 5500);
  }

  function bindProgressiveRuntimeRoot(root) {
    if (!root || state.progressiveRuntimeRoot === root) return;
    state.progressiveRuntimeRoot = root;
    root.classList.add('gs-progressive-customily-root');
    if (state.observer) state.observer.disconnect();
    state.observer = new MutationObserver(() => {
      refreshSoon();
      syncProgressiveSwatchTransitionFrame();
    });
    state.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'checked', 'value', 'hidden', 'src', 'srcset', 'id', 'for'] });
    installProgressiveSwatchLifecycle(root);
    refreshSoon();
  }

  function ensureProgressiveRootReplacementObserver(root) {
    bindProgressiveRuntimeRoot(root);
    if (state.progressiveRootReplacementObserver) return;
    state.progressiveRootReplacementObserver = new MutationObserver(() => {
      if (state.progressiveRootReplacementRaf) return;
      state.progressiveRootReplacementRaf = window.requestAnimationFrame(() => {
        state.progressiveRootReplacementRaf = 0;
        const replacement = customilyRoot();
        if (replacement && replacement !== state.progressiveRuntimeRoot) bindProgressiveRuntimeRoot(replacement);
        else refreshSoon();
      });
    });
    state.progressiveRootReplacementObserver.observe(document.body, { childList: true, subtree: true });
  }

  function install() {
    if (state.familyFailClosed) return true;
    if (state.booted) return true;
    const root = customilyRoot();
    if (!root) return false;
    if (!state.adapterProbeStartedAt) state.adapterProbeStartedAt = Date.now();
    if (!state.adapter?.bootAssert?.(root)) {
      if (Date.now() - state.adapterProbeStartedAt > 12000) {
        failClosed(`adapter-topology-mismatch:${state.adapter?.marker || 'unknown'}`, root);
        return true;
      }
      return false;
    }
    enableRuntimeClasses();

    if (!isGuided()) {
      root.classList.add('gs-progressive-customily-root');
      // Variant B stays inline on the PDP. The page-by-page summary/header card
      // was useful for the abandoned full guided studio, but it duplicates the
      // real Customily controls here. Keep only progressive visibility/gating.
      installApprovalModal();
      ensurePreviewSurfaceStyles();
      setFloatingPreviewMinimized(false);
      bindShared();
      state.booted = true;
      document.documentElement.dataset.gsCustomilyGuidedStudioBooted = 'true';
      ensureProgressiveRootReplacementObserver(root);
      if (state.popupObserver) state.popupObserver.disconnect();
      state.popupObserver = new MutationObserver((records) => {
        // Pan/zoom frames intentionally mutate only compositor transform style.
        // Do not run popup reconciliation for every pixel across the floating,
        // approval, or cart preview surfaces.
        const zoomPanOnly = records.length > 0 && records.every((record) => {
          if (record.type !== 'attributes' || record.attributeName !== 'style') return false;
          if (record.target?.matches?.('.gs-floating-preview__media-layer')) {
            return state.floatingPreviewDragging || !!state.floatingPreviewPinchStart;
          }
          if (record.target?.matches?.('.gs-approval-zoom__viewport img')) {
            return state.zoomDragging || !!state.zoomPinchStart;
          }
          const cartStage = record.target?.closest?.('.customily-cart-preview__stage');
          return !!cartStage && (cartStage.dataset.panning === 'true' || cartStage.dataset.pinching === 'true');
        });
        if (zoomPanOnly) return;
        ensureFloatingPreviewControls();
        syncFloatingPreviewForCartDrawer();
        syncExpandedPopupFixes();
        if (!expandedPopup()) state.expandedPopupZoomed = false;
      });
      state.popupObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      syncFloatingPreviewForCartDrawer();
      if ([FAMILY_STANDARD, FAMILY_DRINKWARE_DIRECT].includes(state.adapter?.marker)) scheduleStandardFamilyAssertion(root);
      refreshSoon();
      return true;
    }

    root.classList.add('gs-guided-customily-root');

    state.launcher = buildLauncher();
    state.shell = buildShell();
    state.review = buildReview();

    root.parentNode.insertBefore(state.launcher, root);
    root.parentNode.insertBefore(state.shell, root);
    document.body.appendChild(state.review);

    state.stepBadge = state.shell.querySelector('.gs-shell__step');
    state.progress = state.shell.querySelector('.gs-shell__progress span');
    state.stepTitle = state.shell.querySelector('.gs-shell__title');
    state.statusHost = state.shell.querySelector('[data-gs-host="status"]');
    state.backBtn = state.shell.querySelector('.gs-shell__back');
    state.pathHost = state.shell.querySelector('[data-gs-host="path"]');
    state.methodHost = state.shell.querySelector('[data-gs-host="method-wrap"]');
    state.methodChips = state.shell.querySelector('[data-gs-host="method"]');
    state.previewHost = state.shell.querySelector('.gs-shell-preview');
    state.uploadHost = state.shell.querySelector('.gs-shell-upload');
    state.detailHost = state.shell.querySelector('.gs-shell-detail');
    state.consentHost = state.shell.querySelector('[data-gs-host="consent"]');
    state.footer = state.shell.querySelector('.gs-shell__footer');
    state.footerHint = state.shell.querySelector('.gs-shell__footer-hint');
    state.footerBtn = state.shell.querySelector('.gs-shell__footer-btn');
    state.reviewList = state.review.querySelector('.gs-shell-review__list');
    state.reviewError = state.review.querySelector('.gs-shell-review__error');
    state.reviewSubmit = state.review.querySelector('.gs-shell-review__submit');

    bind();
    state.booted = true;
    document.documentElement.dataset.gsCustomilyGuidedStudioBooted = 'true';
    if (state.observer) state.observer.disconnect();
    state.observer = new MutationObserver(refreshSoon);
    state.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'checked', 'value', 'src', 'srcset'] });
    if ([FAMILY_STANDARD, FAMILY_DRINKWARE_DIRECT].includes(state.adapter?.marker)) scheduleStandardFamilyAssertion(root);
    refreshSoon();
    return true;
  }

  function boot() {
    if (install()) return;
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      if (install() || tries > 80) window.clearInterval(timer);
    }, 150);
    state.observer = new MutationObserver(() => {
      if (install() && state.observer) state.observer.disconnect();
    });
    state.observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Phase 2A 2026-07-03: instant non-interactive customizer loading shell.
     Paints a status-only skeleton where the Customily options app will render,
     then removes itself once real Customily controls exist. Safety model:
     - only runs on the enabled progressive lane (the family gate above already
       returned for anything suppressed/unknown);
     - pointer-events: none + no form controls, so it can never intercept or
       fake interaction with native Customily;
     - hard fail-open timeout dismisses it even if readiness is never observed;
     - it stores no state and never writes into Customily. */
  const LOADING_SHELL_READY_SELECTOR = '.customily_option, input[type="radio"], input[type="file"], input[type="text"], textarea, select';
  const LOADING_SHELL_FAIL_OPEN_MS = 20000;
  // Remove the shell synchronously once Customily has real controls. A fade leaves
  // both panels in normal flow long enough to create the double-stack Asher saw.
  const LOADING_SHELL_DISMISS_FADE_MS = 0;
  const LOADING_SHELL_ACTIVE_CLASS = 'gs-customily-loading-shell-active';

  function markPerformance(name) {
    try {
      if (window.performance && typeof window.performance.mark === 'function') window.performance.mark(name);
    } catch (error) { /* perf marks are best-effort only */ }
  }

  function loadingShellControlsReady() {
    const root = customilyRoot();
    return !!(root && root.querySelector(LOADING_SHELL_READY_SELECTOR));
  }

  function collapseLoadingShellRoot(root) {
    if (!root || root.dataset.gsLoadingShellCollapsed === 'true') return;
    root.dataset.gsLoadingShellCollapsed = 'true';
    root.dataset.gsLoadingShellOriginalStyle = root.getAttribute('style') || '';
    root.style.setProperty('height', '0', 'important');
    root.style.setProperty('min-height', '0', 'important');
    root.style.setProperty('max-height', '0', 'important');
    root.style.setProperty('margin', '0', 'important');
    root.style.setProperty('padding', '0', 'important');
    root.style.setProperty('overflow', 'hidden', 'important');
    root.style.setProperty('opacity', '0', 'important');
    root.style.setProperty('pointer-events', 'none', 'important');
  }

  function restoreCollapsedLoadingShellRoots() {
    qsa('[data-gs-loading-shell-collapsed="true"]').forEach((root) => {
      const originalStyle = root.dataset.gsLoadingShellOriginalStyle || '';
      if (originalStyle) root.setAttribute('style', originalStyle);
      else root.removeAttribute('style');
      delete root.dataset.gsLoadingShellCollapsed;
      delete root.dataset.gsLoadingShellOriginalStyle;
    });
  }

  function buildLoadingShell() {
    const family = state.adapter?.marker || FAMILY_STANDARD;
    const config = family === FAMILY_TEES
      ? { eyebrow: 'Add Text *', options: [''], sections: ['Choose Font Style *', 'Font Color *'] }
      : family === FAMILY_DRINKWARE_GATED
        ? { eyebrow: 'Choose Personalization Method *', options: ['Full Color', 'Engraving'], sections: [] }
        : { eyebrow: 'Choose Style *', options: ['Images', 'Custom Text', 'Monogram'], sections: [] };
    const shell = document.createElement('div');
    shell.className = 'gs-customily-loading-shell';
    shell.dataset.gsShellFamily = family;
    shell.setAttribute('role', 'status');
    shell.setAttribute('aria-live', 'polite');
    const options = config.options
      .map((label) => `<span class="gs-customily-loading-shell__option"><span class="gs-customily-loading-shell__icon" aria-hidden="true"></span><span>${label}</span></span>`)
      .join('');
    const sections = config.sections
      .map((label) => `<div class="gs-customily-loading-shell__section"><span class="gs-customily-loading-shell__section-label">${label}</span><span class="gs-customily-loading-shell__section-line" aria-hidden="true"></span><span class="gs-customily-loading-shell__section-grid" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span></div>`)
      .join('');
    shell.innerHTML = `
      <div class="gs-customily-loading-shell__head">
        <div class="gs-customily-loading-shell__eyebrow">${config.eyebrow}</div>
        <span class="gs-customily-loading-shell__spinner" aria-hidden="true"></span>
      </div>
      <p class="gs-customily-loading-shell__status">Preparing your options&hellip;</p>
      <div class="gs-customily-loading-shell__skeleton" aria-hidden="true">
        <div class="gs-customily-loading-shell__option-wrap">${options}</div>
        ${sections}
      </div>`;
    return shell;
  }

  function bootLoadingShell() {
    if (VARIANT !== 'progressive') return;
    if (qs('.gs-customily-loading-shell')) return;
    if (loadingShellControlsReady()) { markPerformance('gs_customily_controls_ready'); return; }

    // Anchor where the Customily app will render: before #cl_optionsapp when it
    // already exists, otherwise just above the buy buttons (Customily injects
    // its options app into the product form area). No anchor -> no shell.
    const anchor = customilyRoot() || qs('.product-form__buttons') || qs("form[action*='/cart/add']");
    if (!anchor || !anchor.parentNode) return;

    const shell = buildLoadingShell();
    document.documentElement.classList.add(LOADING_SHELL_ACTIVE_CLASS);
    anchor.parentNode.insertBefore(shell, anchor);
    markPerformance('gs_customizer_shell_painted');

    let dismissed = false;
    let pollTimer = 0;
    let handoffObserver = null;
    let checkQueued = false;
    const deadline = Date.now() + LOADING_SHELL_FAIL_OPEN_MS;

    const dismiss = (ready) => {
      if (dismissed) return;
      dismissed = true;
      window.clearInterval(pollTimer);
      if (handoffObserver) handoffObserver.disconnect();
      document.removeEventListener('customily-options-loaded', checkLoadingShell);
      document.removeEventListener('customily-product-loaded', checkLoadingShell);
      if (ready) markPerformance('gs_customily_controls_ready');
      shell.classList.add('is-dismissing');
      const removeShell = () => {
        shell.remove();
        restoreCollapsedLoadingShellRoots();
        document.documentElement.classList.remove(LOADING_SHELL_ACTIVE_CLASS);
      };
      if (LOADING_SHELL_DISMISS_FADE_MS > 0) window.setTimeout(removeShell, LOADING_SHELL_DISMISS_FADE_MS);
      else removeShell();
    };

    function checkLoadingShell() {
      if (dismissed) return;
      // This script already returned before boot for explicit native, unknown, or
      // uncertified products. During an approved cold start, the real progressive
      // class intentionally waits for Customily topology verification, so its
      // temporary absence must not dismiss the loading shell. Only an explicit
      // runtime suppression may fail open here.
      if (document.documentElement.dataset.gsCustomizerFamilySuppressed) { dismiss(false); return; }
      if (loadingShellControlsReady()) { dismiss(true); return; }
      if (Date.now() > deadline) { dismiss(false); return; }
      // If Customily starts creating its own root before controls are usable,
      // collapse that hidden staging root while the shell owns the visual slot.
      // Do not move the shell into Customily's wrapper; that caused the stacked
      // panel / shifted-shell sequence Asher captured.
      const root = customilyRoot();
      if (root) collapseLoadingShellRoot(root);
    }

    function scheduleLoadingShellCheck() {
      if (dismissed || checkQueued) return;
      checkQueued = true;
      window.requestAnimationFrame(() => {
        checkQueued = false;
        checkLoadingShell();
      });
    }

    pollTimer = window.setInterval(checkLoadingShell, 60);
    handoffObserver = new MutationObserver(scheduleLoadingShellCheck);
    handoffObserver.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('customily-options-loaded', checkLoadingShell);
    document.addEventListener('customily-product-loaded', checkLoadingShell);
  }
  function start() {
    // Paint the accepted non-interactive shell immediately after the synchronous
    // product/certification gate above. The real progressive runtime class still
    // waits for Customily topology verification inside install().
    bootLoadingShell();
    boot();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
